(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[603],{

/***/ 30411:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const ARROW_UP = 'M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z';
const IconArrowUp = lib.variant('IconArrowUp', icon.Icon, {
    path: ARROW_UP,
});

exports.C = IconArrowUp;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 54497:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const SHOPPING_CART = 'M17.4173 17.4087C17.9065 17.4087 18.3237 17.5889 18.6691 17.9495C19.0144 18.3101 19.187 18.7356 19.187 19.226C19.187 19.7163 19.0144 20.1346 18.6691 20.4808C18.3237 20.8269 17.9065 21 17.4173 21C16.9281 21 16.5036 20.8269 16.1439 20.4808C15.7842 20.1346 15.6043 19.7163 15.6043 19.226C15.6043 18.7356 15.7842 18.3101 16.1439 17.9495C16.5036 17.5889 16.9281 17.4087 17.4173 17.4087ZM3 3H5.95683L6.79856 4.77404H20.1151C20.3597 4.77404 20.5683 4.86418 20.741 5.04447C20.9137 5.22476 21 5.44471 21 5.70433C21 5.86298 20.9568 6 20.8705 6.11538L17.6763 11.9567C17.518 12.2308 17.2986 12.4543 17.018 12.6274C16.7374 12.8005 16.4317 12.887 16.1007 12.887H9.41007L8.61151 14.3582L8.56835 14.488C8.56835 14.5457 8.58993 14.5962 8.63309 14.6394C8.67626 14.6827 8.72662 14.7043 8.78417 14.7043H19.187V16.5216H8.39568C7.90647 16.5216 7.48921 16.3413 7.14388 15.9808C6.79856 15.6202 6.6259 15.1947 6.6259 14.7043C6.6259 14.4303 6.69784 14.149 6.84173 13.8606L8.05036 11.6106L4.81295 4.77404H3V3ZM8.39568 17.4087C8.88489 17.4087 9.30935 17.5889 9.66906 17.9495C10.0288 18.3101 10.2086 18.7356 10.2086 19.226C10.2086 19.7163 10.0288 20.1346 9.66906 20.4808C9.30935 20.8269 8.88489 21 8.39568 21C7.90647 21 7.48921 20.8269 7.14388 20.4808C6.79856 20.1346 6.6259 19.7163 6.6259 19.226C6.6259 18.7356 6.79856 18.3101 7.14388 17.9495C7.48921 17.5889 7.90647 17.4087 8.39568 17.4087Z';
const IconShoppingCart = lib.variant('IconShoppingCart', icon.Icon, {
    path: SHOPPING_CART,
});

exports.w = IconShoppingCart;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 40000:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const STAR = 'M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z';
const IconStar = lib.variant('IconStar', icon.Icon, {
    path: STAR,
});

exports.G = IconStar;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 10213:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const VIEW_COLUMN = 'M16,5V18H21V5M4,18H9V5H4M10,18H15V5H10V18Z';
const IconViewColumn = lib.variant('IconViewColumn', icon.Icon, {
    path: VIEW_COLUMN,
});

exports.n = IconViewColumn;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 77141:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const VIEW_COMPACT_LIST = 'M3 3.5C3 3.22386 3.22386 3 3.5 3H7.5C7.77614 3 8 3.22386 8 3.5V7.15C8 7.42614 7.77614 7.65 7.5 7.65H3.5C3.22386 7.65 3 7.42614 3 7.15V3.5Z M10 3.5C10 3.22386 10.2239 3 10.5 3H20.5C20.7761 3 21 3.22386 21 3.5V7.15C21 7.42614 20.7761 7.65 20.5 7.65H10.5C10.2239 7.65 10 7.42614 10 7.15V3.5Z M3 10.15C3 9.87385 3.22386 9.64999 3.5 9.64999H7.5C7.77614 9.64999 8 9.87385 8 10.15V13.8C8 14.0761 7.77614 14.3 7.5 14.3H3.5C3.22386 14.3 3 14.0761 3 13.8V10.15Z M10 10.15C10 9.87385 10.2239 9.64999 10.5 9.64999H20.5C20.7761 9.64999 21 9.87385 21 10.15V13.8C21 14.0761 20.7761 14.3 20.5 14.3H10.5C10.2239 14.3 10 14.0761 10 13.8V10.15Z M3 16.8C3 16.5238 3.22386 16.3 3.5 16.3H7.5C7.77614 16.3 8 16.5238 8 16.8V20.45C8 20.7261 7.77614 20.95 7.5 20.95H3.5C3.22386 20.95 3 20.7261 3 20.45V16.8Z M10 16.8C10 16.5238 10.2239 16.3 10.5 16.3H20.5C20.7761 16.3 21 16.5238 21 16.8V20.45C21 20.7261 20.7761 20.95 20.5 20.95H10.5C10.2239 20.95 10 20.7261 10 20.45V16.8Z';
const IconViewCompactList = lib.variant('IconViewCompactList', icon.Icon, {
    path: VIEW_COMPACT_LIST,
});

exports.e = IconViewCompactList;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 40483:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const VIEW_GRID = 'M4 3C3.44772 3 3 3.44772 3 4V10C3 10.5523 3.44772 11 4 11H10C10.5523 11 11 10.5523 11 10V4C11 3.44772 10.5523 3 10 3H4ZM14 3C13.4477 3 13 3.44772 13 4V10C13 10.5523 13.4477 11 14 11H20C20.5523 11 21 10.5523 21 10V4C21 3.44772 20.5523 3 20 3H14ZM3 14C3 13.4477 3.44772 13 4 13H10C10.5523 13 11 13.4477 11 14V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V14ZM14 13C13.4477 13 13 13.4477 13 14V20C13 20.5523 13.4477 21 14 21H20C20.5523 21 21 20.5523 21 20V14C21 13.4477 20.5523 13 20 13H14Z';
const IconViewGrid = lib.variant('IconViewGrid', icon.Icon, {
    path: VIEW_GRID,
});

exports.M = IconViewGrid;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 71282:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var lib = __webpack_require__(90908);
var icon = __webpack_require__(33634);
__webpack_require__(50959);
__webpack_require__(19803);
__webpack_require__(96742);
__webpack_require__(24774);

const VIEW_LIST = 'M3 14C3 13.4477 3.44772 13 4 13H20C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V14Z M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10V4Z';
const IconViewList = lib.variant('IconViewList', icon.Icon, {
    path: VIEW_LIST,
});

exports.d = IconViewList;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 51722:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},D="en",v={};v[D]=M;var p=function(t){return t instanceof _},S=function(t,e,n){var r;if(!t)return D;if("string"==typeof t)v[t]&&(r=t),e&&(v[t]=e,r=t);else{var i=t.name;v[i]=t,r=i}return!n&&r&&(D=r),r||!n&&D},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var D=this.$locale().weekStart||0,v=(y<D?y+7:y)-D;return $(r?m-v:m+(6-v),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].substr(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,D=O.m(this,M);return D=(l={},l[c]=D/12,l[f]=D,l[h]=D/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?D:O.a(D)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return v[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),b=_.prototype;return w.prototype=b,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){b[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=v[D],w.Ls=v,w.p={},w}));

/***/ }),

/***/ 31420:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 88987:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hashClear = __webpack_require__(71519),
    hashDelete = __webpack_require__(82999),
    hashGet = __webpack_require__(76111),
    hashHas = __webpack_require__(50506),
    hashSet = __webpack_require__(80845);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 175:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var listCacheClear = __webpack_require__(2173),
    listCacheDelete = __webpack_require__(33752),
    listCacheGet = __webpack_require__(10548),
    listCacheHas = __webpack_require__(63410),
    listCacheSet = __webpack_require__(3564);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 35922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 9440:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var mapCacheClear = __webpack_require__(7140),
    mapCacheDelete = __webpack_require__(56504),
    mapCacheGet = __webpack_require__(88833),
    mapCacheHas = __webpack_require__(80953),
    mapCacheSet = __webpack_require__(70724);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 6795:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 81956:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 78188:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MapCache = __webpack_require__(9440),
    setCacheAdd = __webpack_require__(96659),
    setCacheHas = __webpack_require__(97230);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 5929:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    stackClear = __webpack_require__(40551),
    stackDelete = __webpack_require__(4090),
    stackGet = __webpack_require__(47694),
    stackHas = __webpack_require__(86220),
    stackSet = __webpack_require__(68958);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 92210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 69477:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758),
    root = __webpack_require__(29165);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 41101:
/***/ ((module) => {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),

/***/ 48969:
/***/ ((module) => {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 79809:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseTimes = __webpack_require__(39739),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isIndex = __webpack_require__(91010),
    isTypedArray = __webpack_require__(73806);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 75697:
/***/ ((module) => {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 28486:
/***/ ((module) => {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 49499:
/***/ ((module) => {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 62718:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__(42448);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 86970:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseEach = __webpack_require__(30438);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),

/***/ 30404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__(34082);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 30438:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseForOwn = __webpack_require__(61343),
    createBaseEach = __webpack_require__(8202);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 91030:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createBaseFor = __webpack_require__(29);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 61343:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseFor = __webpack_require__(91030),
    keys = __webpack_require__(50579);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 97499:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castPath = __webpack_require__(60399),
    toKey = __webpack_require__(77817);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 38084:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayPush = __webpack_require__(28486),
    isArray = __webpack_require__(24669);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 71664:
/***/ ((module) => {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 84742:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 6620:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsEqualDeep = __webpack_require__(83977),
    isObjectLike = __webpack_require__(55073);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 83977:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    equalArrays = __webpack_require__(22684),
    equalByTag = __webpack_require__(7456),
    equalObjects = __webpack_require__(18120),
    getTag = __webpack_require__(81887),
    isArray = __webpack_require__(24669),
    isBuffer = __webpack_require__(61563),
    isTypedArray = __webpack_require__(73806);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 27122:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__(5929),
    baseIsEqual = __webpack_require__(6620);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 58939:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isMasked = __webpack_require__(90654),
    isObject = __webpack_require__(36838),
    toSource = __webpack_require__(51059);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 22882:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isLength = __webpack_require__(17216),
    isObjectLike = __webpack_require__(55073);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 5673:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseMatches = __webpack_require__(3772),
    baseMatchesProperty = __webpack_require__(30493),
    identity = __webpack_require__(48148),
    isArray = __webpack_require__(24669),
    property = __webpack_require__(51798);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 87473:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isPrototype = __webpack_require__(92963),
    nativeKeys = __webpack_require__(14457);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 3772:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsMatch = __webpack_require__(27122),
    getMatchData = __webpack_require__(67487),
    matchesStrictComparable = __webpack_require__(78857);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 30493:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsEqual = __webpack_require__(6620),
    get = __webpack_require__(65439),
    hasIn = __webpack_require__(28281),
    isKey = __webpack_require__(2610),
    isStrictComparable = __webpack_require__(92769),
    matchesStrictComparable = __webpack_require__(78857),
    toKey = __webpack_require__(77817);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 17498:
/***/ ((module) => {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 71000:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(97499);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 39739:
/***/ ((module) => {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 73150:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396),
    arrayMap = __webpack_require__(75697),
    isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 58792:
/***/ ((module) => {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 29880:
/***/ ((module) => {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 60399:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(24669),
    isKey = __webpack_require__(2610),
    stringToPath = __webpack_require__(26365),
    toString = __webpack_require__(8389);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 36633:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__(29165);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 49884:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayAggregator = __webpack_require__(41101),
    baseAggregator = __webpack_require__(86970),
    baseIteratee = __webpack_require__(5673),
    isArray = __webpack_require__(24669);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),

/***/ 8202:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArrayLike = __webpack_require__(47428);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 29:
/***/ ((module) => {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 34082:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 22684:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var SetCache = __webpack_require__(78188),
    arraySome = __webpack_require__(49499),
    cacheHas = __webpack_require__(29880);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 7456:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__(74396),
    Uint8Array = __webpack_require__(92210),
    eq = __webpack_require__(42448),
    equalArrays = __webpack_require__(22684),
    mapToArray = __webpack_require__(7523),
    setToArray = __webpack_require__(79967);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 18120:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getAllKeys = __webpack_require__(69698);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 69698:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetAllKeys = __webpack_require__(38084),
    getSymbols = __webpack_require__(97482),
    keys = __webpack_require__(50579);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 67707:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isKeyable = __webpack_require__(3880);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 67487:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isStrictComparable = __webpack_require__(92769),
    keys = __webpack_require__(50579);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 47758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsNative = __webpack_require__(58939),
    getValue = __webpack_require__(9149);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 97482:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayFilter = __webpack_require__(48969),
    stubArray = __webpack_require__(68036);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 81887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DataView = __webpack_require__(31420),
    Map = __webpack_require__(35922),
    Promise = __webpack_require__(6795),
    Set = __webpack_require__(81956),
    WeakMap = __webpack_require__(69477),
    baseGetTag = __webpack_require__(80732),
    toSource = __webpack_require__(51059);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 9149:
/***/ ((module) => {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 18554:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castPath = __webpack_require__(60399),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isIndex = __webpack_require__(91010),
    isLength = __webpack_require__(17216),
    toKey = __webpack_require__(77817);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 71519:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 82999:
/***/ ((module) => {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 76111:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 50506:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 80845:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var nativeCreate = __webpack_require__(37722);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 91010:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 2610:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__(24669),
    isSymbol = __webpack_require__(16764);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 3880:
/***/ ((module) => {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 90654:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var coreJsData = __webpack_require__(36633);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 92963:
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 92769:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__(36838);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 2173:
/***/ ((module) => {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 33752:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 10548:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 63410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 3564:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__(62718);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 7140:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Hash = __webpack_require__(88987),
    ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 56504:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 88833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 80953:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 70724:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getMapData = __webpack_require__(67707);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 7523:
/***/ ((module) => {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 78857:
/***/ ((module) => {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 45171:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var memoize = __webpack_require__(34736);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 37722:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__(47758);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 14457:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__(75542);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 8478:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(96476);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 75542:
/***/ ((module) => {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 96659:
/***/ ((module) => {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 97230:
/***/ ((module) => {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 79967:
/***/ ((module) => {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 40551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 4090:
/***/ ((module) => {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 47694:
/***/ ((module) => {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 86220:
/***/ ((module) => {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 68958:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ListCache = __webpack_require__(175),
    Map = __webpack_require__(35922),
    MapCache = __webpack_require__(9440);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 26365:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var memoizeCapped = __webpack_require__(45171);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 77817:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isSymbol = __webpack_require__(16764);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 51059:
/***/ ((module) => {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 42448:
/***/ ((module) => {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 65439:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(97499);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 759:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__(30404),
    createAggregator = __webpack_require__(49884);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),

/***/ 28281:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseHasIn = __webpack_require__(71664),
    hasPath = __webpack_require__(18554);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 48148:
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 30353:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsArguments = __webpack_require__(84742),
    isObjectLike = __webpack_require__(55073);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 24669:
/***/ ((module) => {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 47428:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__(92042),
    isLength = __webpack_require__(17216);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 61563:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(29165),
    stubFalse = __webpack_require__(84193);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 82691:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseKeys = __webpack_require__(87473),
    getTag = __webpack_require__(81887),
    isArguments = __webpack_require__(30353),
    isArray = __webpack_require__(24669),
    isArrayLike = __webpack_require__(47428),
    isBuffer = __webpack_require__(61563),
    isPrototype = __webpack_require__(92963),
    isTypedArray = __webpack_require__(73806);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 92042:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(80732),
    isObject = __webpack_require__(36838);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 17216:
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 73806:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIsTypedArray = __webpack_require__(22882),
    baseUnary = __webpack_require__(58792),
    nodeUtil = __webpack_require__(8478);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 50579:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayLikeKeys = __webpack_require__(79809),
    baseKeys = __webpack_require__(87473),
    isArrayLike = __webpack_require__(47428);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 34736:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MapCache = __webpack_require__(9440);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 51798:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseProperty = __webpack_require__(17498),
    basePropertyDeep = __webpack_require__(71000),
    isKey = __webpack_require__(2610),
    toKey = __webpack_require__(77817);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 68036:
/***/ ((module) => {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 84193:
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 8389:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseToString = __webpack_require__(73150);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 13653:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  /* eslint-disable */
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","џ":"dz","Ґ":"G","ґ":"g","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₹":"indian rupee","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}')
  /* eslint-enable */

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var slug = string.split('')
      .reduce(function (result, ch) {
        return result + (charMap[ch] || ch)
          // allowed
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]/g, '')
      }, '')
      // trim leading/trailing spaces
      .trim()
      // convert spaces
      .replace(/[-\s]+/g, options.replacement || '-')

    return options.lower ? slug.toLowerCase() : slug
  }

  replace.extend = function (customMap) {
    for (var key in customMap) {
      charMap[key] = customMap[key]
    }
  }

  return replace
}))


/***/ }),

/***/ 26478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

(function (global) {

    // minimal symbol polyfill for IE11 and others
    if (typeof Symbol !== 'function') {
        var Symbol = function(name) {
            return name;
        }

        Symbol.nonNative = true;
    }

    const STATE_PLAINTEXT = Symbol('plaintext');
    const STATE_HTML      = Symbol('html');
    const STATE_COMMENT   = Symbol('comment');

    const ALLOWED_TAGS_REGEX  = /<(\w*)>/g;
    const NORMALIZE_TAG_REGEX = /<\/?([^\s\/>]+)/;

    function striptags(html, allowable_tags, tag_replacement) {
        html            = html || '';
        allowable_tags  = allowable_tags || [];
        tag_replacement = tag_replacement || '';

        let context = init_context(allowable_tags, tag_replacement);

        return striptags_internal(html, context);
    }

    function init_striptags_stream(allowable_tags, tag_replacement) {
        allowable_tags  = allowable_tags || [];
        tag_replacement = tag_replacement || '';

        let context = init_context(allowable_tags, tag_replacement);

        return function striptags_stream(html) {
            return striptags_internal(html || '', context);
        };
    }

    striptags.init_streaming_mode = init_striptags_stream;

    function init_context(allowable_tags, tag_replacement) {
        allowable_tags = parse_allowable_tags(allowable_tags);

        return {
            allowable_tags : allowable_tags,
            tag_replacement: tag_replacement,

            state         : STATE_PLAINTEXT,
            tag_buffer    : '',
            depth         : 0,
            in_quote_char : ''
        };
    }

    function striptags_internal(html, context) {
        if (typeof html != "string") {
            throw new TypeError("'html' parameter must be a string");
        }

        let allowable_tags  = context.allowable_tags;
        let tag_replacement = context.tag_replacement;

        let state         = context.state;
        let tag_buffer    = context.tag_buffer;
        let depth         = context.depth;
        let in_quote_char = context.in_quote_char;
        let output        = '';

        for (let idx = 0, length = html.length; idx < length; idx++) {
            let char = html[idx];

            if (state === STATE_PLAINTEXT) {
                switch (char) {
                    case '<':
                        state       = STATE_HTML;
                        tag_buffer += char;
                        break;

                    default:
                        output += char;
                        break;
                }
            }

            else if (state === STATE_HTML) {
                switch (char) {
                    case '<':
                        // ignore '<' if inside a quote
                        if (in_quote_char) {
                            break;
                        }

                        // we're seeing a nested '<'
                        depth++;
                        break;

                    case '>':
                        // ignore '>' if inside a quote
                        if (in_quote_char) {
                            break;
                        }

                        // something like this is happening: '<<>>'
                        if (depth) {
                            depth--;

                            break;
                        }

                        // this is closing the tag in tag_buffer
                        in_quote_char = '';
                        state         = STATE_PLAINTEXT;
                        tag_buffer   += '>';

                        if (allowable_tags.has(normalize_tag(tag_buffer))) {
                            output += tag_buffer;
                        } else {
                            output += tag_replacement;
                        }

                        tag_buffer = '';
                        break;

                    case '"':
                    case '\'':
                        // catch both single and double quotes

                        if (char === in_quote_char) {
                            in_quote_char = '';
                        } else {
                            in_quote_char = in_quote_char || char;
                        }

                        tag_buffer += char;
                        break;

                    case '-':
                        if (tag_buffer === '<!-') {
                            state = STATE_COMMENT;
                        }

                        tag_buffer += char;
                        break;

                    case ' ':
                    case '\n':
                        if (tag_buffer === '<') {
                            state      = STATE_PLAINTEXT;
                            output    += '< ';
                            tag_buffer = '';

                            break;
                        }

                        tag_buffer += char;
                        break;

                    default:
                        tag_buffer += char;
                        break;
                }
            }

            else if (state === STATE_COMMENT) {
                switch (char) {
                    case '>':
                        if (tag_buffer.slice(-2) == '--') {
                            // close the comment
                            state = STATE_PLAINTEXT;
                        }

                        tag_buffer = '';
                        break;

                    default:
                        tag_buffer += char;
                        break;
                }
            }
        }

        // save the context for future iterations
        context.state         = state;
        context.tag_buffer    = tag_buffer;
        context.depth         = depth;
        context.in_quote_char = in_quote_char;

        return output;
    }

    function parse_allowable_tags(allowable_tags) {
        let tag_set = new Set();

        if (typeof allowable_tags === 'string') {
            let match;

            while ((match = ALLOWED_TAGS_REGEX.exec(allowable_tags))) {
                tag_set.add(match[1]);
            }
        }

        else if (!Symbol.nonNative &&
                 typeof allowable_tags[Symbol.iterator] === 'function') {

            tag_set = new Set(allowable_tags);
        }

        else if (typeof allowable_tags.forEach === 'function') {
            // IE11 compatible
            allowable_tags.forEach(tag_set.add, tag_set);
        }

        return tag_set;
    }

    function normalize_tag(tag_buffer) {
        let match = NORMALIZE_TAG_REGEX.exec(tag_buffer);

        return match ? match[1].toLowerCase() : null;
    }

    if (true) {
        // AMD
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function module_factory() { return striptags; }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }

    else {}
}(this));


/***/ }),

/***/ 90912:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ category_information)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/category/components/category-information/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CategoryInformation = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryInformation",
    componentId: "sc-0-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.tertiary;
}, base/* layout.fontSizes.base.desktop.rem */.bK.fontSizes.base.desktop.rem, base/* layout.measurements.spacing125 */.bK.measurements.spacing125);
var CategoryInformationPTag = styled_components_browser_esm["default"].p.withConfig({
    displayName: "CategoryInformationPTag",
    componentId: "sc-0-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/areas/category/components/category-information/index.tsx



var category_information_CategoryInformation = function(param) {
    var statistics = param.statistics;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(CategoryInformation, null, statistics && t("category", "product-list.product-and-store-count", {
        products: statistics.productsCount,
        stores: statistics.storesCount
    }), /*#__PURE__*/ react.createElement(CategoryInformationPTag, null, t("category", "product-list.rank-information")));
};
/* harmony default export */ var category_information = (/*#__PURE__*/(0,react.memo)(category_information_CategoryInformation));


/***/ }),

/***/ 11341:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ Badge)
/* harmony export */ });
/* unused harmony export Text */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21541);
/* harmony import */ var src_areas_expert_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46674);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Badge = function(props) {
    var type = props.type;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).t;
    var text = (0,src_areas_expert_utils__WEBPACK_IMPORTED_MODULE_5__/* .getTranslationByContentType */ .r)(type, t);
    return text ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, null, text) : null;
};
var Text = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.TitleMediumText).withConfig({
    displayName: "Text",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, function(p) {
    return p.theme.colors.maybeBlue700;
});


/***/ }),

/***/ 53973:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ expert_avatar)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/user-avatar/index.tsx + 1 modules
var user_avatar = __webpack_require__(60738);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ExpertAvatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpertAvatar",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/index.tsx





var expert_avatar_ExpertAvatar = function(param) {
    var avatar = param.avatar, className = param.className, displayName = param.displayName, link = param.link, size = param.size;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref.renderMode, linkTo = ref.linkTo;
    var children = /*#__PURE__*/ react.createElement(user_avatar/* UserAvatar */.Y, {
        size: size,
        avatar: avatar,
        displayName: displayName
    });
    return /*#__PURE__*/ react.createElement(ExpertAvatar, {
        className: className
    }, link ? /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
        to: linkTo("expertProfile", {
            semantic_id: link || ""
        }, renderMode === "native" ? {
            view: "native"
        } : undefined)
    }, children) : children);
};
/* harmony default export */ var expert_avatar = (expert_avatar_ExpertAvatar);


/***/ }),

/***/ 8454:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": () => (/* binding */ ExpertUserCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/areas/expert/components/expert-avatar/index.tsx + 1 modules
var expert_avatar = __webpack_require__(53973);
// EXTERNAL MODULE: ./src/areas/expert/types.ts
var types = __webpack_require__(54712);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-user-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    align-self: center;\n    grid-area: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  grid-area: 1 / 1 / 3 / 2;\n  align-self: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    display: grid;\n    grid-template-columns: ",
        "px 1fr;\n    grid-template-rows: auto auto;\n    column-gap: ",
        ";\n    margin-left: ",
        ";\n    z-index: ",
        ";\n\n    p {\n      margin: 0;\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    ",
        "\n    max-height: ",
        "px;\n\n    &[href]:hover {\n      ",
        " {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var USER_AVATAR_SIZE_SMALL = 32;
var USER_AVATAR_SIZE_MEDIUM = 48;
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject(), props.$showSubtitle ? "1 / 2 / 2 / 3" : "1 / 2 / 3 / 3");
});
var Subtitle = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), props.$size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal : base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
});
var Avatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Avatar",
    componentId: "sc-0-2"
})(_templateObject2());
var Expert = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Expert",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject3(), props.$size, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.$overlap ? "-".concat(props.$size * props.$overlap / 2, "px") : "0", props.$index);
});
var Container = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Container",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.$pointer ? "cursor: pointer;" : "", props.$size, Title, props.theme.text.callToActionHover);
});

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-user-card/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}








var ExpertUserCard = function(props) {
    var className = props.className, customTitle = props.customTitle, experts = props.experts, _size = props.size, size = _size === void 0 ? types/* ExpertUserCardSize.SMALL */.M.SMALL : _size, subtitle = props.subtitle, _pointer = props.pointer, pointer = _pointer === void 0 ? false : _pointer;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, renderMode = ref.renderMode, linkTo = ref.linkTo;
    var avatarSize = size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? USER_AVATAR_SIZE_MEDIUM : USER_AVATAR_SIZE_SMALL;
    var container = experts.length === 1 ? clickable/* Clickable */.P : "div";
    var containerProps = experts.length === 1 && experts[0].url ? {
        to: linkTo("expertProfile", {
            semantic_id: experts[0].url
        }, renderMode === "native" ? {
            view: "native"
        } : undefined),
        isExternal: renderMode === "native",
        onClick: function() {
            if (experts[0].url) {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.EXPERT_PROFILE_GO_TO */.U.EXPERT_PROFILE_GO_TO,
                    nextPage: experts[0].url
                });
            }
        }
    } : undefined;
    var getSingularExpertText = function(expert) {
        if (customTitle) return /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: false
        }, customTitle);
        return /*#__PURE__*/ react.createElement(react.Fragment, null, size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: Boolean(subtitle)
        }, /*#__PURE__*/ react.createElement(variants.TitleMediumText, {
            behavior: variants.Behavior.Oneline
        }, expert.name)) : /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: Boolean(subtitle)
        }, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            behavior: variants.Behavior.Oneline
        }, expert.name)));
    };
    var getPluralExpertText = function() {
        if (customTitle) return /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: false
        }, customTitle);
        return /*#__PURE__*/ react.createElement(react.Fragment, null, size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement(variants.TitleMediumText, {
            behavior: variants.Behavior.Oneline
        }, t("expert", "guide.lists-expert-plural", {
            count: experts.length
        }))) : /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            behavior: variants.Behavior.Oneline
        }, t("expert", "guide.lists-expert-plural", {
            count: experts.length
        }))));
    };
    return /*#__PURE__*/ react.createElement(Container, _extends({
        className: className,
        as: container,
        $size: avatarSize,
        $pointer: experts.length === 1 && pointer
    }, containerProps), experts.map(function(expert, index) {
        return /*#__PURE__*/ react.createElement(Expert, {
            key: expert.name,
            $index: experts.length - index,
            $overlap: index,
            $size: avatarSize
        }, /*#__PURE__*/ react.createElement(Avatar, null, /*#__PURE__*/ react.createElement(expert_avatar/* default */.Z, {
            avatar: expert.avatar,
            displayName: expert.avatarAlt || expert.name,
            size: avatarSize
        })), experts.length === 1 && getSingularExpertText(expert), experts.length > 1 && index === experts.length - 1 && getPluralExpertText());
    }));
};


/***/ }),

/***/ 8263:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": () => (/* binding */ TrackingSource),
  "Z": () => (/* binding */ list_of_content_cards)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/article-card/index.tsx + 1 modules
var article_card = __webpack_require__(55445);
// EXTERNAL MODULE: ./src/areas/expert/components/card-image/index.tsx
var card_image = __webpack_require__(59669);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/expert/components/product-images/index.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      &::after {\n        ",
        ";\n        pointer-events: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  column-gap: ",
        ";\n  position: relative;\n  padding: 0 ",
        ";\n  align-items: center;\n  width: 100%;\n  height: ",
        ";\n\n  img {\n    max-height: 64px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var spacing100 = base/* layout.measurements.spacing100 */.bK.measurements.spacing100;
var Images = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Images",
    componentId: "sc-0-0"
})(_templateObject1(), spacing100, spacing100, function(p) {
    return p.height;
}, function(p) {
    return p.background && (0,styled_components_browser_esm.css)(_templateObject(), base/* styledUtils.overlay */.au.overlay());
});
var ProductImages = function(param) {
    var products = param.products, _selectedPosition = param.selectedPosition, selectedPosition = _selectedPosition === void 0 ? 1 : _selectedPosition, _height = param.height, height = _height === void 0 ? "auto" : _height, _background = param.background, background = _background === void 0 ? true : _background;
    // Select the two closest product images to the selected product
    var visible = 3;
    var productImages = products.filter(function(item) {
        if (selectedPosition === 1) return item.order <= visible;
        if (selectedPosition === products.length) return item.order > products.length - visible;
        return item.order === selectedPosition - 1 || item.order === selectedPosition || item.order === selectedPosition + 1;
    }).map(function(p) {
        var ref, ref1, ref2;
        return (p.image || ((ref = p.media) === null || ref === void 0 ? void 0 : ref.first)) && /*#__PURE__*/ react.createElement("img", {
            alt: p.name,
            key: p.image || ((ref1 = p.media) === null || ref1 === void 0 ? void 0 : ref1.first),
            src: p.image || ((ref2 = p.media) === null || ref2 === void 0 ? void 0 : ref2.first)
        });
    });
    return /*#__PURE__*/ react.createElement(Images, {
        background: background,
        height: height
    }, productImages);
};


// EXTERNAL MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/utils.ts
var utils = __webpack_require__(74596);
// EXTERNAL MODULE: ./src/areas/expert/types.ts
var types = __webpack_require__(54712);
// EXTERNAL MODULE: ./src/areas/expert/components/badge/index.tsx
var badge = __webpack_require__(11341);
// EXTERNAL MODULE: ./src/areas/expert/components/expert-user-card/index.tsx + 1 modules
var expert_user_card = __webpack_require__(8454);
// EXTERNAL MODULE: ./src/components/advized/tracking.ts
var tracking = __webpack_require__(98864);
// EXTERNAL MODULE: ./src/areas/expert/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(1946);
;// CONCATENATED MODULE: ./src/areas/expert/components/list-of-content-cards/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Rating = (0,styled_components_browser_esm["default"])(rating/* default */.Z).withConfig({
    displayName: "Rating",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.10.7/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(51722);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/areas/expert/components/list-of-content-cards/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













var TrackingSource;
(function(TrackingSource) {
    TrackingSource["ADVIZED_WIDGET"] = "advizedWidget";
})(TrackingSource || (TrackingSource = {}));
var ContentCards = function(param) {
    var category = param.category, className = param.className, onClick = param.onClick, items = param.items, _imageSize = param.imageSize, imageSize = _imageSize === void 0 ? 130 : _imageSize, _limit = param.limit, limit = _limit === void 0 ? 0 : _limit, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, hideExperts = param.hideExperts, trackingSource = param.trackingSource;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), market = ref.market, t = ref.t;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var numberOfCards = limit ? limit + offset : items.length;
    var getDefaultExpert = function() {
        return {
            avatar: "".concat(market.cdn, "/g/rfe/logos/logo_v2_symbol.svg"),
            name: t("search", "editorial.defaultauthor"),
            url: undefined,
            hideExpertIcon: true
        };
    };
    var getPrismicExpert = function(param) {
        var avatar = param.avatar, author = param.author;
        return {
            avatar: (avatar === null || avatar === void 0 ? void 0 : avatar.url) || "".concat(market.cdn, "/g/rfe/logos/logo_v2_symbol.svg"),
            avatarAlt: (avatar === null || avatar === void 0 ? void 0 : avatar.alt) || "",
            name: author || "",
            url: undefined,
            hideExpertIcon: true
        };
    };
    var getNavigationScope = function(clickInfo) {
        switch(clickInfo.type){
            case types/* ContentTypes.ARTICLE */.b.ARTICLE:
                return tracking_tracking/* InternalNavigationScope.ARTICLE_PAGE_GO_TO */.U.ARTICLE_PAGE_GO_TO;
            case types/* ContentTypes.GUIDE */.b.GUIDE:
                return tracking_tracking/* InternalNavigationScope.GUIDE_PAGE_GO_TO */.U.GUIDE_PAGE_GO_TO;
            case types/* ContentTypes.TEST */.b.TEST:
                return tracking_tracking/* InternalNavigationScope.PRODUCT_TEST_PAGE_GO_TO */.U.PRODUCT_TEST_PAGE_GO_TO;
            case types/* ContentTypes.TOPLIST */.b.TOPLIST:
                return tracking_tracking/* InternalNavigationScope.TOPLIST_PAGE_GO_TO */.U.TOPLIST_PAGE_GO_TO;
            case types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE:
                return tracking_tracking/* InternalNavigationScope.TOPLIST_PAGE_HEADLINE_GO_TO */.U.TOPLIST_PAGE_HEADLINE_GO_TO;
            default:
                return null;
        }
    };
    var onClickAndTracking = function(clickInfo) {
        onClick === null || onClick === void 0 ? void 0 : onClick(clickInfo);
        switch(trackingSource){
            case TrackingSource.ADVIZED_WIDGET:
                {
                    (0,tracking/* trackCategoryPageExpertCarouselCard */.t)(category === null || category === void 0 ? void 0 : category.url, clickInfo.type);
                    break;
                }
            default:
        }
        var scope = getNavigationScope(clickInfo);
        if (scope) {
            (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                scope: scope,
                nextPage: clickInfo.url,
                index: clickInfo.index
            });
        }
    };
    var getContentCard = function(item, index) {
        switch(item.__typename){
            case types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE:
                {
                    var ref, ref1, ref2, ref3, ref4;
                    if (!item.toplists || !item.toplists[0]) {
                        return null;
                    }
                    var list = item.toplists[0];
                    var image = (ref = list.description) === null || ref === void 0 ? void 0 : ref.find(function(d) {
                        return d.type === "image";
                    });
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: list.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.name,
                                type: types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: (ref1 = list.headlineInfo) === null || ref1 === void 0 ? void 0 : ref1.likes,
                        media: (image === null || image === void 0 ? void 0 : image.data) ? /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: image.data,
                            alt: list.title,
                            height: imageSize
                        }) : /*#__PURE__*/ react.createElement(ProductImages, {
                            height: "".concat(imageSize, "px"),
                            background: false,
                            selectedPosition: 2,
                            products: (ref2 = item.toplists[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.map(function(p) {
                                return _objectSpread({}, p);
                            })
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TOPLIST_HEADLINE */.b.TOPLIST_HEADLINE
                        }), ": ", item.name),
                        url: item.url,
                        footer: !hideExperts && list.expert.url ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                list.expert
                            ].concat(_toConsumableArray((list === null || list === void 0 ? void 0 : (ref4 = list.headlineInfo) === null || ref4 === void 0 ? void 0 : ref4.otherExperts) || []))
                        }) : null
                    });
                }
            case types/* ContentTypes.TOPLIST */.b.TOPLIST:
                {
                    var ref5, ref6, ref7, ref8, ref9, ref10;
                    var ref11;
                    var imageUrl = (ref11 = (ref5 = item.image) === null || ref5 === void 0 ? void 0 : ref5.src) !== null && ref11 !== void 0 ? ref11 : (ref7 = (ref6 = item.description) === null || ref6 === void 0 ? void 0 : ref6.find(function(d) {
                        return d.type === "image";
                    })) === null || ref7 === void 0 ? void 0 : ref7.data;
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.TOPLIST */.b.TOPLIST,
                                url: item.headlineInfo.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: (ref8 = item.headlineInfo) === null || ref8 === void 0 ? void 0 : ref8.likes,
                        media: imageUrl ? /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: imageUrl,
                            alt: item.title,
                            height: imageSize
                        }) : /*#__PURE__*/ react.createElement(ProductImages, {
                            height: "".concat(imageSize, "px"),
                            products: item.products.map(function(p) {
                                return _objectSpread({}, p);
                            }),
                            background: false
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TOPLIST */.b.TOPLIST
                        }), ": ", item.title),
                        url: item.headlineInfo.url,
                        footer: !hideExperts && ((ref9 = item.expert) === null || ref9 === void 0 ? void 0 : ref9.url) ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ].concat(_toConsumableArray(((ref10 = item.headlineInfo) === null || ref10 === void 0 ? void 0 : ref10.otherExperts) || []))
                        }) : null
                    });
                }
            case types/* ContentTypes.TEST */.b.TEST:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        grade: item.gradeNotConverted !== undefined && /*#__PURE__*/ react.createElement(Rating, {
                            grade: item.gradeNotConverted
                        }),
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.TEST */.b.TEST,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: item.likes,
                        media: item.imageWithSize && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.imageWithSize.src,
                            alt: item.imageWithSize.alt,
                            height: imageSize
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.TEST */.b.TEST
                        }), ": ", item.title),
                        url: item.url,
                        footer: !hideExperts ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ]
                        }) : null
                    });
                }
            case types/* ContentTypes.GUIDE */.b.GUIDE:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.GUIDE */.b.GUIDE,
                                url: item.url,
                                index: index
                            });
                        },
                        key: item.id,
                        likes: item.likes,
                        media: item.image && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.image.src,
                            alt: item.image.alt,
                            height: imageSize
                        }),
                        titleAndCategory: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(badge/* Badge */.C, {
                            type: types/* ContentTypes.GUIDE */.b.GUIDE
                        }), ": ", item.title),
                        url: item.url,
                        footer: !hideExperts ? /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            experts: [
                                item.expert
                            ]
                        }) : null
                    });
                }
            case types/* ContentTypes.ARTICLE */.b.ARTICLE:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: item.date,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.ARTICLE */.b.ARTICLE,
                                url: item.link,
                                index: index
                            });
                        },
                        key: item.id,
                        media: item.image && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.image.src,
                            alt: item.image.alt,
                            height: imageSize
                        }),
                        titleAndCategory: item.title,
                        url: item.link,
                        footer: /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            pointer: true,
                            experts: [
                                getDefaultExpert()
                            ]
                        }),
                        footerPartOfLink: true
                    });
                }
            case types/* ContentTypes.GENERIC_ARTICLE */.b.GENERIC_ARTICLE:
            case types/* ContentTypes.EDITORIAL_LANDING_PAGE */.b.EDITORIAL_LANDING_PAGE:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        date: dayjs_min_default()(item.date).format("DD MMMM YYYY"),
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.GENERIC_ARTICLE */.b.GENERIC_ARTICLE,
                                url: (0,utils/* getLinkByType */.ME)(item, linkTo) || "",
                                index: index
                            });
                        },
                        key: item.id,
                        media: item.thumbnail && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.thumbnail,
                            alt: item.thumbnailAlt || item.title,
                            height: imageSize
                        }),
                        titleAndCategory: item.title,
                        url: (0,utils/* getLinkByType */.ME)(item, linkTo),
                        footer: /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            pointer: true,
                            experts: [
                                getDefaultExpert()
                            ]
                        }),
                        footerPartOfLink: true
                    });
                }
            case types/* ContentTypes.VIDEO */.b.VIDEO:
                {
                    return /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
                        pretitle: category,
                        className: className,
                        onClick: function() {
                            return onClickAndTracking({
                                id: item.id,
                                title: item.title,
                                type: types/* ContentTypes.VIDEO */.b.VIDEO,
                                url: item.youtubeId,
                                index: index
                            });
                        },
                        key: item.id,
                        media: item.previewImage && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
                            src: item.previewImage,
                            alt: "",
                            height: 130
                        }),
                        videoMetadata: {
                            title: item.title,
                            thumbnail: item.previewImage,
                            videoId: item.youtubeId
                        },
                        titleAndCategory: item.title,
                        footer: /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
                            pointer: true,
                            experts: [
                                getPrismicExpert(item)
                            ]
                        }),
                        footerPartOfLink: true
                    });
                }
            default:
                return null;
        }
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, items.map(function(item, index) {
        if (!item || !item.id || !item.__typename) {
            return null;
        }
        if (index < offset || index >= numberOfCards) {
            return null;
        }
        return getContentCard(item, index);
    }));
};
/* harmony default export */ var list_of_content_cards = (ContentCards);


/***/ }),

/***/ 1946:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ rating)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(51362);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/star/index.js
var star = __webpack_require__(40000);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/expert/components/rating/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  font-weight: 600;\n  font-size: ",
        ";\n  line-height: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  background: ",
        ";\n  border-radius: 20px;\n  justify-self: start;\n  font-weight: 600;\n  color: ",
        ";\n  line-height: 1;\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 700;\n  font-size: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var _measurements = base/* layout.measurements */.bK.measurements, spacing025 = _measurements.spacing025, spacing050 = _measurements.spacing050;
var ExpertRating = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpertRating",
    componentId: "sc-0-0"
})(_templateObject());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(_templateObject1(), spacing025, base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium);
var Badge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Badge",
    componentId: "sc-0-2"
})(_templateObject2(), spacing025, spacing050, base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(base/* brandColors.expert */.D2.expert, 1), function(p) {
    return p.theme.colors.base0;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var Stars = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Stars",
    componentId: "sc-0-3"
})(_templateObject3());
var RatingText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "RatingText",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(72321);
;// CONCATENATED MODULE: ./src/areas/expert/components/rating/index.tsx






var rating_ExpertRating = function(param) {
    var className = param.className, grade = param.grade, text = param.text, _as = param.as, as = _as === void 0 ? "badge" : _as;
    var rating = rating_helper/* default.toRoundedString */.Z.toRoundedString(grade);
    if (as === "stars") {
        return /*#__PURE__*/ react.createElement(Stars, {
            className: className
        }, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
            rate: grade,
            expertColors: true,
            size: "large"
        }), " ", /*#__PURE__*/ react.createElement(RatingText, null, rating));
    }
    return /*#__PURE__*/ react.createElement(ExpertRating, {
        className: className
    }, text && /*#__PURE__*/ react.createElement(Text, null, text, ": "), /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "BLUE_INVERTED",
        icon: star/* IconStar */.G,
        text: rating
    }));
};
/* harmony default export */ var rating = (rating_ExpertRating);


/***/ }),

/***/ 54712:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ ExpertUserCardSize),
/* harmony export */   "b": () => (/* binding */ ContentTypes)
/* harmony export */ });
var ContentTypes;
(function(ContentTypes) {
    ContentTypes["TEST"] = "AdvizedTest";
    ContentTypes["TOPLIST"] = "AdvizedToplist";
    ContentTypes["TOPLIST_HEADLINE"] = "ToplistHeadline";
    ContentTypes["GUIDE"] = "ExpertGuide";
    ContentTypes["ARTICLE"] = "SearchArticleItem";
    ContentTypes["SPONSORED_ARTICLE"] = "SearchSponsoredArticle";
    ContentTypes["VIDEO"] = "SearchVideoItem";
    ContentTypes["GENERIC_ARTICLE"] = "SearchGenericArticle";
    ContentTypes["EDITORIAL_LANDING_PAGE"] = "SearchEditorialLandingPage";
})(ContentTypes || (ContentTypes = {}));
var ExpertUserCardSize;
(function(ExpertUserCardSize) {
    ExpertUserCardSize["SMALL"] = "SMALL";
    ExpertUserCardSize["MEDIUM"] = "MEDIUM";
})(ExpertUserCardSize || (ExpertUserCardSize = {}));


/***/ }),

/***/ 46674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": () => (/* binding */ getTranslationByContentType),
/* harmony export */   "t": () => (/* binding */ compareByDate)
/* harmony export */ });
/* harmony import */ var src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54712);

/**
 * Compare function for sorting Adviced content in arrays
 */ var compareByDate = function(a, b) {
    // If null or undefined, move to bottom of list
    if (!a || !a.publishedAt) return 1;
    if (!b || !b.publishedAt) return -1;
    return parseInt(b.publishedAt, 10) - parseInt(a.publishedAt, 10);
};
var getTranslationByContentType = function(type, t) {
    switch(type){
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TEST */ .b.TEST:
            return t("expert", "test.test");
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TOPLIST */ .b.TOPLIST:
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.TOPLIST_HEADLINE */ .b.TOPLIST_HEADLINE:
            return t("expert", "toplist.toplist");
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_0__/* .ContentTypes.GUIDE */ .b.GUIDE:
            return t("expert", "guide.guide");
        default:
            return null;
    }
};


/***/ }),

/***/ 97351:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ProductCollectionSitemapPageLoader": () => (/* binding */ ProductCollectionSitemapPageLoader),
  "default": () => (/* binding */ product_collection_sitemap)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(42281);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/product-collection-sitemap/components/header-block/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: normal;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200);
var Title = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(_templateObject1(), (0,base/* remCalc */.vR)(36), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product-collection-sitemap/components/header-block/index.tsx


var HeaderBlock = function(param) {
    var title = param.title;
    return /*#__PURE__*/ react.createElement(Header, null, /*#__PURE__*/ react.createElement(Title, null, title));
};
/* harmony default export */ var header_block = (HeaderBlock);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/areas/product-collection-sitemap/components/sitemap-item/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  line-height: 2.25;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SitemapItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "SitemapItem",
    componentId: "sc-0-0"
})(styles_templateObject());
var SitemapLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).attrs({
    "data-test": "SitemapLink"
}).withConfig({
    displayName: "SitemapLink",
    componentId: "sc-0-1"
})(styles_templateObject1(), function(p) {
    return p.theme.colors.maybeBlue700;
});

;// CONCATENATED MODULE: ./src/areas/product-collection-sitemap/components/sitemap-item/index.tsx


var sitemap_item_SitemapItem = function(param) {
    var path = param.path, title = param.title, onClick = param.onClick;
    return /*#__PURE__*/ react.createElement(SitemapItem, null, /*#__PURE__*/ react.createElement(SitemapLink, {
        to: path,
        onClick: function() {
            return onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    }, title));
};
/* harmony default export */ var sitemap_item = (sitemap_item_SitemapItem);

;// CONCATENATED MODULE: ./src/areas/product-collection-sitemap/components/sitemap-collections/styles.ts
function sitemap_collections_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function sitemap_collections_styles_templateObject() {
    var data = sitemap_collections_styles_taggedTemplateLiteral([
        "\n  align-items: center;\n  display: flex;\n  margin-bottom: ",
        ";\n"
    ]);
    sitemap_collections_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sitemap_collections_styles_templateObject1() {
    var data = sitemap_collections_styles_taggedTemplateLiteral([
        "\n    grid-template-columns: repeat(auto-fill, minmax(auto, 33%));\n  "
    ]);
    sitemap_collections_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = sitemap_collections_styles_taggedTemplateLiteral([
        "\n    grid-template-columns: repeat(auto-fill, minmax(auto, 25%));\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = sitemap_collections_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  flex: 1 0 auto;\n  grid-template-columns: repeat(auto-fill, minmax(auto, 50%));\n  list-style: none;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var styles_Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(sitemap_collections_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SitemapItemList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "SitemapItemList",
    componentId: "sc-0-1"
})(_templateObject3(), base/* media.mediumOnly */.BC.mediumOnly(sitemap_collections_styles_templateObject1()), base/* media.largeUp */.BC.largeUp(_templateObject2()));

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/product-collection-sitemap/components/sitemap-collections/index.tsx




var SitemapCollection = function(param) {
    var sitemapItems = param.sitemapItems;
    return /*#__PURE__*/ react.createElement(SitemapItemList, null, Array.isArray(sitemapItems) && sitemapItems.filter(function(obj) {
        return obj !== undefined;
    }).map(function(param, index) {
        var path = param.path, title = param.title;
        return /*#__PURE__*/ react.createElement(sitemap_item, {
            key: path,
            path: path,
            title: title,
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.PRODUCT_COLLECTION_SITEMAP_LINK */.U.PRODUCT_COLLECTION_SITEMAP_LINK,
                    nextPage: path,
                    index: index
                });
            }
        });
    }));
};
/* harmony default export */ var sitemap_collections = (SitemapCollection);

// EXTERNAL MODULE: ./src/areas/product-collection-sitemap/query.graphql
var query_graphql = __webpack_require__(48993);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/product-collection-sitemap/queries/use-product-collection-sitemap-page.ts


function useProductCollectionSitemapPageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "productCollectionSitemap",
        variables: variables
    });
}

;// CONCATENATED MODULE: ./src/areas/product-collection-sitemap/styles.ts
function product_collection_sitemap_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_collection_sitemap_styles_templateObject() {
    var data = product_collection_sitemap_styles_taggedTemplateLiteral([
        "\n  display: block;\n  margin: 0 ",
        ";\n"
    ]);
    product_collection_sitemap_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SitemapWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "SitemapWrapper",
    componentId: "sc-0-0"
})(product_collection_sitemap_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product-collection-sitemap/product-collection-sitemap.tsx









var ProductCollectionSitemapPageLoader = function() {
    var ref, ref1;
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref2;
    var variables = {
        slug: (ref2 = route === null || route === void 0 ? void 0 : (ref = route.match) === null || ref === void 0 ? void 0 : (ref1 = ref.params) === null || ref1 === void 0 ? void 0 : ref1.slug) !== null && ref2 !== void 0 ? ref2 : ""
    };
    var ref3 = useProductCollectionSitemapPageQuery(variables), data = ref3.data, isLoading = ref3.isLoading, isSuccess = ref3.isSuccess;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true,
        "data-test": "ProductCollectionSitemapPage"
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && (data === null || data === void 0 ? void 0 : data.productCollectionSitemap) ? /*#__PURE__*/ react.createElement(ProductCollectionSitemapPage, {
        productCollectionSitemap: data.productCollectionSitemap
    }) : null);
};
var ProductCollectionSitemapPage = function(param) {
    var productCollectionSitemap = param.productCollectionSitemap;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var sitemapCollection = productCollectionSitemap.sitemapCollection, title = productCollectionSitemap.name;
    return /*#__PURE__*/ react.createElement(SitemapWrapper, null, /*#__PURE__*/ react.createElement(header_block, {
        title: t("category", "product-collection-sitemap.heading", {
            title: title
        })
    }), Array.isArray(sitemapCollection) ? sitemapCollection.filter(function(obj) {
        return obj !== undefined;
    }).map(function(param) {
        var property = param.property, sitemapItems = param.sitemapItems;
        return /*#__PURE__*/ react.createElement(sitemap_collections, {
            key: property,
            sitemapItems: sitemapItems
        });
    }) : null);
};
/* harmony default export */ var product_collection_sitemap = (/*#__PURE__*/(0,react.memo)(ProductCollectionSitemapPageLoader));


/***/ }),

/***/ 26300:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": () => (/* binding */ expandable_group_ExpandableGroup),
  "w": () => (/* binding */ ExpandedIndicator)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(59945);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-down/index.js
var chevron_down = __webpack_require__(34783);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/expandable-group/styles.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      box-shadow: inset 0 -2px 0 ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  color: ",
        ";\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  padding: ",
        ";\n  text-align: left;\n  transition: background-color ",
        ";\n  width: 100%;\n\n  ",
        ";\n\n  ",
        ";\n\n  &.focus-visible {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n  font-size: ",
        ";\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  transition: transform 0.15s ease-in-out;\n  transform: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  /* Align the badge to the right */\n  margin-left: auto;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var ExpandableGroup = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpandableGroup",
    componentId: "sc-0-0"
})(_templateObject());
var Header = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Header",
    componentId: "sc-0-1"
})(_templateObject3(), function(props) {
    return props.theme.text.callToAction;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, function(props) {
    return props.expanded && (0,styled_components_browser_esm.css)(_templateObject1(), props.theme.lines.groupHeader);
}, function(props) {
    return props.dark && (0,styled_components_browser_esm.css)(_templateObject2(), base/* colors.backgroundDarkGray */.O9.backgroundDarkGray);
}, function(props) {
    return base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(props.theme.colors.maybeBlue700, "0.5");
});
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(_templateObject4(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var HeaderArrow = (0,styled_components_browser_esm["default"])(function(_param) /*#__PURE__*/ {
    var expanded = _param.expanded, props = _objectWithoutProperties(_param, [
        "expanded"
    ]);
    return react.createElement(chevron_down/* IconChevronDown */.C, _extends({}, props, {
        color: "maybeBlue700",
        size: 24
    }));
}).withConfig({
    displayName: "HeaderArrow",
    componentId: "sc-0-3"
})(_templateObject5(), function(props) {
    return props.expanded ? "scaleY(-1)" : "none";
});
var BadgeArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BadgeArea",
    componentId: "sc-0-4"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/areas/product-collection/components/expandable-group/index.tsx




var expandable_group_ExpandableGroup = function(param) {
    var children = param.children, expanded = param.expanded, title = param.title, onToggle = param.onToggle, badge = param.badge, dark = param.dark;
    return /*#__PURE__*/ react.createElement(ExpandableGroup, null, /*#__PURE__*/ react.createElement(Header, {
        expanded: expanded,
        onClick: onToggle,
        dark: dark
    }, /*#__PURE__*/ react.createElement(ExpandedIndicator, {
        expanded: expanded
    }), /*#__PURE__*/ react.createElement(Title, null, title), badge && /*#__PURE__*/ react.createElement(BadgeArea, null, badge)), /*#__PURE__*/ react.createElement(hideable.Hideable, {
        visible: expanded,
        collapse: ui/* Axis.Y */.RD.Y
    }, children));
};
var ExpandedIndicator = function(param) {
    var expanded = param.expanded;
    return /*#__PURE__*/ react.createElement(HeaderArrow, {
        expanded: expanded
    });
};


/***/ }),

/***/ 6462:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ij": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_2__.ij),
/* harmony export */   "uj": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_2__.uj),
/* harmony export */   "xj": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_2__.xj)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2812);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17492);

var FilterSection = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-collection-filter";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-collection-filter */ 120).then(__webpack_require__.bind(__webpack_require__, 3748));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(3748);
        }
        return eval("require.resolve")("./filter-section");
    }
});


/* harmony default export */ __webpack_exports__["ZP"] = (FilterSection);


/***/ }),

/***/ 2812:
/***/ (() => {

"use strict";



/***/ }),

/***/ 17492:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bd": () => (/* binding */ getSelectedListItems),
/* harmony export */   "ij": () => (/* binding */ findGroupedSections),
/* harmony export */   "uj": () => (/* binding */ isValidSection),
/* harmony export */   "xj": () => (/* binding */ findUngroupedSections)
/* harmony export */ });
/* unused harmony exports isFeaturedSection, isNotFeaturedSection, isGroupedSection, isUngroupedSection, isDisabledSection */
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(759);
/* harmony import */ var lodash_groupBy__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_groupBy__WEBPACK_IMPORTED_MODULE_0__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var isValidSection = function(section) {
    return [
        "ListSection",
        "ListTreeSection",
        "RangeSection",
        "RangeGroupSection",
        "BooleanSection"
    ].includes(section.__typename || "");
};
var isFeaturedSection = function(section) {
    return Boolean(section.featured);
};
var isNotFeaturedSection = function(section) {
    return !section.featured;
};
var isGroupedSection = function(section) {
    return !section.featured && Boolean(section.group);
};
var isUngroupedSection = function(section) {
    return Boolean(section.featured) || !section.group;
};
var findUngroupedSections = function(sections) {
    return sections.filter(isUngroupedSection).filter(isValidSection);
};
var findGroupedSections = function(sections, filters, countryCode) {
    var aggregationsByGroup = lodash_groupBy__WEBPACK_IMPORTED_MODULE_0___default()(sections.filter(isGroupedSection).filter(isValidSection), "group");
    var sectionGroups = Object.entries(aggregationsByGroup).map(function(param) {
        var _param = _slicedToArray(param, 2), title = _param[0], groupSections = _param[1];
        return {
            title: title,
            sections: groupSections,
            filterCount: filters.filter(function(filter) {
                return groupSections.some(function(section) {
                    return section.property === filter.property;
                });
            }).length
        };
    });
    return moveMiscellaneousToBottom(sectionGroups, countryCode);
};
var moveMiscellaneousToBottom = function(sectionGroups, countryCode) {
    var translations = {
        se: "\xf6vrigt",
        dk: "diverse",
        no: "annet",
        fr: "divers",
        fi: "muuta",
        gb: "miscellaneous"
    };
    var index = sectionGroups.findIndex(function(elem) {
        return elem.title.toLowerCase() === translations[countryCode];
    });
    if (index !== -1) {
        var miscellaneous = sectionGroups.splice(index, 1)[0];
        sectionGroups.splice(sectionGroups.length, 0, miscellaneous);
    }
    return sectionGroups;
};
var isDisabledSection = function(section) {
    switch(section.__typename){
        case "ListSection":
            return !section.items || !section.items.length;
        case "RangeSection":
            return section.min === section.max;
        default:
            return false;
    }
};
var getSelectedListItems = function(filter) {
    if (!filter) return undefined;
    switch(filter.__typename){
        case "ProductCollectionTermFilter":
            return filter.value ? [
                {
                    id: filter.id,
                    value: filter.value
                }
            ] : undefined;
        case "ProductCollectionTermsFilter":
            return filter.values ? filter.values.map(function(value, index) {
                return {
                    id: filter.ids[index],
                    value: value
                };
            }).sort(function(a, b) {
                return a.value.localeCompare(b.value);
            }) : undefined;
        default:
            return undefined;
    }
};


/***/ }),

/***/ 68941:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ header_block)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/header-block/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      margin-top: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n    padding: 0 ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 1.5rem;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n\n    && {\n      ",
        ";\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 36em;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var Header = styled_components_browser_esm["default"].header.withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(_templateObject(), props.$noMargins ? "0" : "".concat(base/* layout.measurements.spacing050 */.bK.measurements.spacing050)));
});
var Title = (0,styled_components_browser_esm["default"])(page/* PageHeader */.mr).withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.noUppercase ? "" : "&::first-letter {\n      text-transform: uppercase;\n    }", base/* media.smallOnly */.BC.smallOnly(_templateObject2()), base/* media.mediumDown */.BC.mediumDown(_templateObject3(), props.$noMargins && "margin: 0"));
});
var Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Description",
    componentId: "sc-0-2"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/areas/product-collection/components/header-block/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var HeaderBlock = function(param) {
    var title = param.title, pagination = param.pagination, _noMargins = param.noMargins, noMargins = _noMargins === void 0 ? false : _noMargins, _noUppercase = param.noUppercase, noUppercase = _noUppercase === void 0 ? false : _noUppercase;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var titleWithPagination = pagination && pagination.currentPage > 1 ? t("category", "product-collection.paginated-title", _objectSpreadProps(_objectSpread({}, pagination), {
        title: title
    })) : title;
    return /*#__PURE__*/ react.createElement(Header, {
        $noMargins: noMargins,
        "data-test": "HeaderText"
    }, /*#__PURE__*/ react.createElement(Title, {
        noUppercase: noUppercase,
        $noMargins: noMargins,
        title: titleWithPagination
    }));
};
/* harmony default export */ var header_block = (HeaderBlock);


/***/ }),

/***/ 51772:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": () => (/* binding */ NavigationSliceView)
});

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/index.tsx + 1 modules
var horizontal_scroll = __webpack_require__(75081);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(22899);
// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
;// CONCATENATED MODULE: ./src/components/media-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  padding: ",
        ";\n\n  &::after {\n    ",
        "\n    border-radius: 50%;\n    transition: background-color 150ms ease;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  text-align: center;\n  flex: 1 1 auto;\n  width: 100%;\n  height: 100%;\n\n  > *:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n\n  &:hover {\n    ",
        " {\n      &::after {\n        background-color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Media = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Media",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* styledUtils.overlay */.au.overlay());
var Button = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Button",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Media, function(p) {
    return base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.colors.base800, 0.08);
});

;// CONCATENATED MODULE: ./src/components/media-button/index.tsx


var MediaButton = function(props) {
    var children = props.children, className = props.className, url = props.url, onClick = props.onClick, media = props.media;
    return /*#__PURE__*/ react.createElement(Button, {
        className: className,
        to: url,
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(Media, null, media), children);
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/navigation/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    max-width: calc(100vw - 120px);\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n      height: 140px;\n      overflow: hidden;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  justify-content: flex-start;\n  grid-template-columns: repeat(auto-fit, minmax(120px, auto));\n  flex-wrap: wrap;\n  list-style: none;\n  flex-grow: 1;\n  margin-bottom: 0;\n  row-gap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  min-width: ",
        "px;\n  max-width: ",
        "px;\n  min-height: 140px;\n  display: block;\n  margin-left: 5px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  word-break: break-word;\n  white-space: normal;\n  overflow: hidden;\n  /* stylelint-disable value-no-vendor-prefix  */\n  display: -webkit-box;\n  /* stylelint-disable property-no-vendor-prefix  */\n  -webkit-line-clamp: ",
        ";\n  -webkit-box-orient: vertical;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n  display: block;\n  grid-column-end: -1;\n  grid-row-start: 1;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var ITEM_WIDTH = 120;
var MEDIA_SIZE = 60;
var Wrapper = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.largeUp */.BC.largeUp(styles_templateObject()));
var ListWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListWrapper",
    componentId: "sc-0-1"
})(_templateObject2());
var List = styled_components_browser_esm["default"].ul.attrs({
    "data-test": "NavigationList"
}).withConfig({
    displayName: "List",
    componentId: "sc-0-2"
})(_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return !p.$showAll && (0,styled_components_browser_esm.css)(_templateObject3());
});
var listItemStyles = (0,styled_components_browser_esm.css)(_templateObject5(), ITEM_WIDTH, ITEM_WIDTH);
var ListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-3"
})(_templateObject6(), listItemStyles);
var ListItemDiv = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListItemDiv",
    componentId: "sc-0-4"
})(_templateObject7(), listItemStyles);
var ListItemText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListItemText",
    componentId: "sc-0-5"
})(_templateObject8());
var LimitedTextField = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LimitedTextField",
    componentId: "sc-0-6"
})(_templateObject9(), function(param) {
    var lines = param.lines;
    return lines !== null && lines !== void 0 ? lines : 2;
});
var ListItemImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListItemImage",
    componentId: "sc-0-7"
})(_templateObject10(), MEDIA_SIZE, MEDIA_SIZE);
var ListAction = styled_components_browser_esm["default"].div.attrs({
    "data-test": "NavigationListAction"
}).withConfig({
    displayName: "ListAction",
    componentId: "sc-0-8"
})(_templateObject11(), listItemStyles);
var ListActionButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListActionButton",
    componentId: "sc-0-9"
})(_templateObject12(), MEDIA_SIZE, MEDIA_SIZE);
var NavigationSliceWrapper = styled_components_browser_esm["default"].div.attrs({
    "data-test": "NavigationList"
}).withConfig({
    displayName: "NavigationSliceWrapper",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product-collection/components/navigation/link.tsx





var NavigationLink = function(param) {
    var link = param.link, selected = param.selected, onClickPreventDefault = param.onClickPreventDefault, Component = param.Component, onClick = param.onClick, _lazyLoadImage = param.lazyLoadImage, lazyLoadImage = _lazyLoadImage === void 0 ? true : _lazyLoadImage;
    var onClickHandler = (0,react.useCallback)(function(e) {
        // Help google with a-links, but handle filter updates via actions
        if (onClick) {
            if (onClickPreventDefault) {
                e.preventDefault();
            }
            onClick(link);
        }
    }, [
        link,
        onClick,
        onClickPreventDefault
    ]);
    var children = (0,react.useMemo)(function() {
        var image = link.imageUrl;
        if (!image) {
            return /*#__PURE__*/ react.createElement(variants.H1Text, {
                container: "span",
                emphasis: variants.FontEmphasis.LOW
            }, link.value.replace(/[^\w]+/, "").charAt(0));
        }
        var img = /*#__PURE__*/ react.createElement("img", {
            src: image,
            alt: link.value
        });
        if (lazyLoadImage) {
            return /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
                offset: 0
            }, img);
        }
        return img;
    }, [
        lazyLoadImage,
        link.imageUrl,
        link.value
    ]);
    var addSpaceBetweenSpecialCharacters = function(input) {
        var specialCharacters = RegExp("([^\\p{L}\\p{N}\\s])", "gu");
        return input.replace(specialCharacters, " $1 ");
    };
    return /*#__PURE__*/ react.createElement(Component, {
        selected: selected,
        "data-test": "NavigationLink",
        "data-cy": link.value
    }, /*#__PURE__*/ react.createElement(MediaButton, {
        media: /*#__PURE__*/ react.createElement(ListItemImage, null, children),
        url: link.indexable && link.path || undefined,
        onClick: onClickHandler
    }, /*#__PURE__*/ react.createElement(ListItemText, null, /*#__PURE__*/ react.createElement(LimitedTextField, {
        lines: 2
    }, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        color: variants.FontColor.DARK
    }, addSpaceBetweenSpecialCharacters(link.value))))));
};
/* harmony default export */ var navigation_link = (NavigationLink);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./src/hooks/resize-observer.ts
var resize_observer = __webpack_require__(32495);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/navigation/navigation-component.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var DEFAULT_ITEM_LIMIT = 7;
var renderNavigationLinks = function(param) {
    var links = param.links, onClick = param.onClick, onClickPreventDefault = param.onClickPreventDefault, __showAll = param._showAll, _showAll = __showAll === void 0 ? true : __showAll, _asListItems = param.asListItems, asListItems = _asListItems === void 0 ? false : _asListItems, _itemLimit = param.itemLimit, itemLimit = _itemLimit === void 0 ? DEFAULT_ITEM_LIMIT : _itemLimit;
    return links && links.length ? links.map(function(link, index) {
        var selected = link.selected;
        var Component = asListItems ? ListItem : ListItemDiv;
        return link.path ? /*#__PURE__*/ react.createElement(navigation_link, {
            key: link.value,
            link: link,
            selected: selected,
            onClick: function(facetLink) {
                return onClick === null || onClick === void 0 ? void 0 : onClick(facetLink, index);
            },
            onClickPreventDefault: onClickPreventDefault,
            // Lazy loading is disabled for all initially visible images to enable them
            // to load before React is loaded. The goal of this strategy is to improve
            // our Lighthouse performance score, and specifically the "Largest Contentful
            // Paint" metric.
            lazyLoadImage: index >= itemLimit,
            Component: Component
        }) : null;
    }) : null;
};
var NavigationSliceView = function(param) {
    var links = param.links, onClick = param.onClick, _onClickPreventDefault = param.onClickPreventDefault, onClickPreventDefault = _onClickPreventDefault === void 0 ? false : _onClickPreventDefault, _itemLimit = param.itemLimit, itemLimit = _itemLimit === void 0 ? DEFAULT_ITEM_LIMIT : _itemLimit, _showAll = param.showAll, showAll = _showAll === void 0 ? false : _showAll, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(false), 2), _showAll1 = ref[0], _setShowAll = ref[1];
    var onShowAll = (0,react.useCallback)(function() {
        return _setShowAll(!_showAll1);
    }, [
        _showAll1,
        _setShowAll
    ]);
    var trackOnClick = function(link, index) {
        if (link.path) (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.NAVIGATION_CAROUSEL */.U.NAVIGATION_CAROUSEL,
            nextPage: link.path,
            index: index
        });
        onClick === null || onClick === void 0 ? void 0 : onClick(link);
    };
    var mobileLinks = renderNavigationLinks({
        links: links,
        onClick: trackOnClick,
        onClickPreventDefault: onClickPreventDefault,
        itemLimit: itemLimit
    });
    var desktopLinks = renderNavigationLinks({
        links: links,
        onClick: trackOnClick,
        onClickPreventDefault: onClickPreventDefault,
        _showAll: _showAll1,
        asListItems: true,
        itemLimit: itemLimit
    });
    var ref1 = (0,resize_observer/* useResizeObserver */.y)(), ref2 = ref1.ref, width = ref1.width;
    var showMore = (0,react.useMemo)(function() {
        if (!(links === null || links === void 0 ? void 0 : links.length) || !width) return false;
        return Math.floor(width / 120) < links.length;
    }, [
        links,
        width
    ]);
    return mobileLinks || desktopLinks ? /*#__PURE__*/ react.createElement(Wrapper, {
        className: className
    }, mobileLinks && /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        mobile: true,
        tablet: true
    }, /*#__PURE__*/ react.createElement(horizontal_scroll/* HorizontalScroll */.Z, {
        itemWidth: 110,
        loadingHeight: 140,
        showArrows: false,
        negativeMargin: false
    }, mobileLinks)), desktopLinks && /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        desktop: true
    }, /*#__PURE__*/ react.createElement(ListWrapper, {
        ref: ref2
    }, /*#__PURE__*/ react.createElement(List, {
        $showAll: showAll || _showAll1,
        $itemLimit: itemLimit
    }, showMore && links && links.length > itemLimit && !showAll ? /*#__PURE__*/ react.createElement(ListAction, null, /*#__PURE__*/ react.createElement(MediaButton, {
        onClick: onShowAll,
        media: /*#__PURE__*/ react.createElement(ListActionButton, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, null, t("common", _showAll1 ? "button.show-less" : "button.show-more")))
    })) : null, desktopLinks)))) : null;
};


/***/ }),

/***/ 79821:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": () => (/* binding */ OffersGrid)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35632);


var OffersGrid = function(param) {
    var children = param.children, className = param.className, offers = param.offers, isExtraWide = param.isExtraWide, isOffers = param.isOffers;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_1__/* .OffersGrid */ .u5, {
        "data-test": isOffers ? "OfferGrid" : "ProductGrid",
        className: className,
        isExtraWide: isExtraWide
    }, children, offers && react__WEBPACK_IMPORTED_MODULE_0__.Children.map(offers, function(child, index) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_1__/* .OffersGridItem */ .EA, {
            "data-test": isOffers ? "OfferGridCard" : "ProductGridCard",
            style: {
                order: index
            }
        }, child);
    }));
};


/***/ }),

/***/ 35632:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EA": () => (/* binding */ OffersGridItem),
/* harmony export */   "cq": () => (/* binding */ ITEMS),
/* harmony export */   "u5": () => (/* binding */ OffersGrid)
/* harmony export */ });
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94141);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76323);
/* eslint-disable no-nested-ternary */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          grid-gap: ",
        "rem;\n          grid-template-columns: repeat(\n            auto-fill,\n            minmax(auto, calc(",
        " - ",
        "))\n          );\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    @supports (grid-template-columns: repeat(auto-fill, minmax(auto, 50%))) {\n      display: grid;\n      flex: 1 0 auto;\n      list-style: none;\n\n      ",
        "\n      ",
        "\n    }\n\n    /* Fallback to flex if grid-template-columns is not supported */\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



// We need to cover ALL breakpoints here since we use '`${breakpoint}Only`'
// If we left out xxl for example, then >1600px would look very weird as it wouldn't be covered by any breakpoint
// (This only works because the smallest and largest breakpoints are open in their respective direction)
var ITEMS = {
    small: 2,
    medium: 3,
    large: 4,
    xlarge: 4,
    xxlarge: 4
};
var GAPS = {
    small: 0.5,
    medium: 1,
    large: 1,
    xlarge: 1,
    xxlarge: 1
};
// These are calculated for each render
var SIZES = {};
var GUTTERS = {};
/**
 * Certain experiments require a different grid layout, which is passed as props
 * Here we determine how many items to show depending on the passed props
 */ function getItemsForExperiments(param) {
    var isExtraWide = param.isExtraWide;
    if (isExtraWide) {
        return {
            large: 4,
            xlarge: 5,
            xxlarge: 6
        };
    }
    return {
        large: 4,
        xlarge: 4,
        xxlarge: 4
    };
}
var OffersGrid = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].ul.withConfig({
    displayName: "OffersGrid",
    componentId: "sc-0-0"
})(function(props) {
    // We need to mutate the object here because src/areas/product-collection/components/products/layout-grid/layout-grid.tsx relies on the current layout configuration, and that depends on getItemsForExperiment
    // We don't want to implement the same logic twice, therefore we need to access this object from somewhere else
    Object.assign(ITEMS, getItemsForExperiments(props));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // I'm not really happy with the current solution, but if we dynamically change ITEMS.large etc. for each render, then we also need to recalculate (gutter) sizes for each render
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for(var _iterator = src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__/* .breakpointNames */ .PS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var bp = _step.value;
            SIZES[bp] = "".concat(100 / ITEMS[bp], "%");
            GUTTERS[bp] = "".concat(GAPS[bp] * (ITEMS[bp] - 1), "rem / ").concat(ITEMS[bp]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), /* This only works because smallOnly and xxlargeOnly have no boundaries in each unset direction i.e. everything larger than xxlarge is considered xxlarge */ null, src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__/* .breakpointNames.map */ .PS.map(function(breakpoint) {
        return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC["".concat(breakpoint, "Only")](_templateObject(), GAPS[breakpoint], SIZES[breakpoint], GUTTERS[breakpoint]);
    }));
});
var OffersGridItem = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].li.withConfig({
    displayName: "OffersGridItem",
    componentId: "sc-0-1"
})(_templateObject2());


/***/ }),

/***/ 41471:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var query_string_for_all__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25932);
/* harmony import */ var query_string_for_all__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(query_string_for_all__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_components_list_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91441);
/* harmony import */ var _prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36074);
/* harmony import */ var _prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _sort_options__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31618);
/* harmony import */ var src_components_filter_overlay_components_overlay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65304);
/* harmony import */ var _globals_tracking_filter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15301);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var OverlaySort = function(param) {
    var currentSort = param.currentSort, onClose = param.onClose, sortOptions = param.sortOptions, sortTranslations = param.sortTranslations, productCollectionName = param.productCollectionName, searchTerm = param.searchTerm;
    var handleOnClick = function handleOnClick(sortOption) {
        (0,_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_7__/* .trackSortingSelectEvent */ .Em)({
            value: sortOption,
            property: currentSortName,
            scope: productCollectionName ? _globals_tracking_filter__WEBPACK_IMPORTED_MODULE_7__/* .PageScope.CATEGORY */ .VN.CATEGORY : _globals_tracking_filter__WEBPACK_IMPORTED_MODULE_7__/* .PageScope.SEARCH */ .VN.SEARCH,
            category: productCollectionName,
            searchTerm: searchTerm
        });
        onClose();
    };
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).t;
    if (!sortOptions.length) {
        return null;
    }
    var currentSortName = (0,_sort_options__WEBPACK_IMPORTED_MODULE_5__/* .getTranslationForSortOption */ .P)(currentSort, sortTranslations, t);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_filter_overlay_components_overlay__WEBPACK_IMPORTED_MODULE_6__/* .OverlayWrapper */ .Fp, {
        onClose: onClose,
        title: t("common", "sorting.title")
    }, sortOptions.map(function(sortOption) {
        var queryParams = (0,_prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4__.getSortedQuery)(_objectSpreadProps(_objectSpread({}, query_string_for_all__WEBPACK_IMPORTED_MODULE_1___default().parse(location.search.replace(/^\?/, ""))), {
            offset: undefined,
            direction: undefined,
            sort: sortOption
        }));
        var sortNameTranslation = (0,_sort_options__WEBPACK_IMPORTED_MODULE_5__/* .getTranslationForSortOption */ .P)(sortOption, sortTranslations, t);
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_list_item__WEBPACK_IMPORTED_MODULE_3__/* .ListItem */ .H, {
            key: sortOption,
            link: "".concat(location.pathname, "?").concat(query_string_for_all__WEBPACK_IMPORTED_MODULE_1___default().stringify(queryParams)),
            name: sortNameTranslation,
            showArrow: false,
            onClick: function() {
                return handleOnClick(sortOption);
            },
            disabled: sortNameTranslation === currentSortName
        });
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (OverlaySort);


/***/ }),

/***/ 95779:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64799);
/* harmony import */ var query_string_for_all__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25932);
/* harmony import */ var query_string_for_all__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(query_string_for_all__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_number_pagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49192);
/* harmony import */ var _prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36074);
/* harmony import */ var _prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var Pagination = function(param) {
    var pageInfo = param.pageInfo, total = param.total, alwaysShowStepButtons = param.alwaysShowStepButtons, _onClick = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    var offset = pageInfo.offset, limit = pageInfo.limit;
    var search = (0,react_router__WEBPACK_IMPORTED_MODULE_1__/* .useLocation */ .TH)().search;
    var linkToPage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(pageNumber) {
        return typeof limit === "number" ? "?".concat(query_string_for_all__WEBPACK_IMPORTED_MODULE_2___default().stringify((0,_prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4__.getSortedQuery)(_objectSpreadProps(_objectSpread({}, query_string_for_all__WEBPACK_IMPORTED_MODULE_2___default().parse(search.substr(1))), {
            offset: pageNumber > 1 ? (pageNumber - 1) * limit : undefined
        })))) : "";
    }, [
        limit,
        search
    ]);
    var currentPage = typeof offset === "number" && typeof limit === "number" ? Math.floor(offset / limit) + 1 : 1;
    var onClickHandler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var pageNumber = param.pageNumber;
        var clickedOffset = limit && pageNumber > 1 ? (pageNumber - 1) * limit : undefined;
        onClick(clickedOffset);
    }, [
        limit,
        onClick
    ]);
    if (typeof limit !== "number" || typeof offset !== "number" || limit === 0) {
        return null;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_number_pagination__WEBPACK_IMPORTED_MODULE_3__/* .NumberPagination */ .O, {
        currentPage: currentPage,
        onClick: onClickHandler,
        totalPages: Math.ceil(total / limit),
        linkToPage: linkToPage,
        alwaysShowStepButtons: alwaysShowStepButtons
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 31618:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ getTranslationForSortOption)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3616);
/* harmony import */ var query_string_for_all__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25932);
/* harmony import */ var query_string_for_all__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(query_string_for_all__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25349);
/* harmony import */ var _prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36074);
/* harmony import */ var _prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_properties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82740);
/* harmony import */ var _prisjakt_ui_dropdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33888);
/* harmony import */ var _prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99816);
/* harmony import */ var src_components_dropdown_item__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28839);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66646);
/* harmony import */ var src_ui_zindex__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92873);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var getTranslationForSortOption = function(sortKey, availableTranslations, t) {
    var property = (0,_utils_properties__WEBPACK_IMPORTED_MODULE_5__/* .getPropertyFromSortKey */ .T)(sortKey);
    return availableTranslations[property] ? availableTranslations[property] : t("common", "sort.".concat(availableTranslations[sortKey] ? availableTranslations[sortKey] : sortKey));
};
var SortOptions = function(param) {
    var availableSorts = param.availableSorts, _availableSortsTranslations = param.availableSortsTranslations, availableSortsTranslations = _availableSortsTranslations === void 0 ? {} : _availableSortsTranslations, currentSort = param.currentSort, onClick = param.onClick, className = param.className;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_3__/* .AppContext */ .Il).t;
    var location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .useLocation */ .TH)();
    var sortOptions = Array.isArray(availableSorts) ? availableSorts : [];
    var currentSortName = getTranslationForSortOption(currentSort, availableSortsTranslations, t);
    if (!sortOptions.length) {
        return null;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_9__/* .SortOptions */ .oi, {
        className: className
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_9__/* .SortOptionsTitle */ .pY, null, t("common", "sort.title"), ":"), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_dropdown__WEBPACK_IMPORTED_MODULE_6__/* .Dropdown */ .Lt, {
        closeOnItemClick: true,
        containerProps: {
            "data-test": "SortOrderDropdown"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_dropdown__WEBPACK_IMPORTED_MODULE_6__/* .DropdownToggle */ .Z_, {
        type: _prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_7__.ButtonType.TEXT,
        showActiveIcon: true,
        containerProps: {
            "data-test": "DropdownToggle"
        }
    }, currentSortName), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_dropdown__WEBPACK_IMPORTED_MODULE_6__/* .DropdownContent */ .Nv, {
        zIndex: src_ui_zindex__WEBPACK_IMPORTED_MODULE_10__/* .zindex.overlay */ .Y.overlay
    }, sortOptions.filter(function(sortOption) {
        return sortOption !== currentSort;
    }).map(function(sort) {
        var queryParams = (0,_prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_4__.getSortedQuery)(_objectSpreadProps(_objectSpread({}, query_string_for_all__WEBPACK_IMPORTED_MODULE_2___default().parse(location.search.replace(/^\?/, ""))), {
            offset: undefined,
            direction: undefined,
            sort: sort
        }));
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_dropdown_item__WEBPACK_IMPORTED_MODULE_8__/* .DropdownItem */ .h, {
            key: sort,
            to: "".concat(location.pathname, "?").concat(query_string_for_all__WEBPACK_IMPORTED_MODULE_2___default().stringify(queryParams)),
            onClick: function() {
                return onClick ? onClick(sort, currentSortName) : null;
            },
            "data-test": "DropdownOption",
            containerProps: {
                "data-test-key": sort
            }
        }, getTranslationForSortOption(sort, availableSortsTranslations, t));
    }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SortOptions);


/***/ }),

/***/ 66646:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EP": () => (/* binding */ StyledFilterButton),
/* harmony export */   "Mj": () => (/* binding */ SearchInput),
/* harmony export */   "_U": () => (/* binding */ SearchTextWrapper),
/* harmony export */   "im": () => (/* binding */ Wrapper),
/* harmony export */   "nv": () => (/* binding */ MobileWrapper),
/* harmony export */   "oi": () => (/* binding */ SortOptions),
/* harmony export */   "pY": () => (/* binding */ SortOptionsTitle),
/* harmony export */   "qX": () => (/* binding */ Notice),
/* harmony export */   "r7": () => (/* binding */ SearchInputIcon),
/* harmony export */   "r_": () => (/* binding */ CompareSortWrapper),
/* harmony export */   "x2": () => (/* binding */ Feedback)
/* harmony export */ });
/* unused harmony exports DisplayOptions, ProductsHeader, ProductList, ProductListItem, SidebarFilterButton, SortOptionsButton, ProductCount, LayoutButtonContainer, AdvertWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var src_components_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95088);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21541);
/* harmony import */ var _toggle_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97908);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-column-gap: ",
        ";\n  align-items: center;\n  grid-auto-flow: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  list-style: none;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n  color: ",
        ";\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    margin-right: ",
        ";\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  margin-left: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  margin-right: ",
        ";\n  margin-bottom: 0;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  font: inherit;\n  margin: ",
        " auto;\n  max-width: 40em;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  padding: ",
        "px;\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    margin-bottom: ",
        ";\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  min-width: ",
        "px;\n  display: flex;\n  align-content: start;\n  align-items: center;\n  flex: 1;\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: 0;\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    transition: ",
        ";\n    width: ",
        ";\n    opacity: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n          position: absolute;\n          right: 0;\n        "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  height: 100%;\n  width: ",
        "px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 50%;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 -",
        ";\n  background: ",
        ";\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}





var DisplayOptions = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "DisplayOptions",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var ProductsHeader = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ProductsHeader",
    componentId: "sc-0-1"
})(_templateObject1());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].main.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-2"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var ProductList = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].ul.withConfig({
    displayName: "ProductList",
    componentId: "sc-0-3"
})(_templateObject3());
var ProductListItem = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].li.withConfig({
    displayName: "ProductListItem",
    componentId: "sc-0-4"
})(_templateObject4());
var SidebarFilterButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z).withConfig({
    displayName: "SidebarFilterButton",
    componentId: "sc-0-5"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject5()));
var SortOptions = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "SortOptions",
    componentId: "sc-0-6"
})(_templateObject7());
var SortOptionsTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "SortOptionsTitle",
    componentId: "sc-0-7"
})(_templateObject9(), function(p) {
    return p.theme.text.quaternary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject8()));
var SortOptionsButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z).withConfig({
    displayName: "SortOptionsButton",
    componentId: "sc-0-8"
})(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
var ProductCount = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_3__.H3Text).withConfig({
    displayName: "ProductCount",
    componentId: "sc-0-9"
})(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var Notice = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
    displayName: "Notice",
    componentId: "sc-0-10"
})(_templateObject13(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200);
var Feedback = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
    displayName: "Feedback",
    componentId: "sc-0-11"
})(_templateObject14());
var LAYOUT_BUTTON_CONTAINER_PADDING = 2;
var LayoutButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "LayoutButtonContainer",
    componentId: "sc-0-12"
})(_templateObject15(), LAYOUT_BUTTON_CONTAINER_PADDING, function(p) {
    return p.theme.bg.tertiary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var SearchInput = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "SearchInput",
    componentId: "sc-0-13"
})(_templateObject17(), function(p) {
    return p.iconSize;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject16(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100));
var SearchTextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "SearchTextWrapper",
    componentId: "sc-0-14"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), props.expanded ? "opacity 0.1s ease-out 0.1s, width 0.25s ease-out" : "opacity 0.1s ease-out, width 0.25s ease-out", props.expanded ? props.inputWidth || "330px" : "".concat(props.iconSize, "px"), props.expanded ? "1" : "0", src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject18()));
});
var SearchInputIcon = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.withConfig({
    displayName: "SearchInputIcon",
    componentId: "sc-0-15"
})(_templateObject21(), function(param) {
    var positionAbsolute = param.positionAbsolute;
    return positionAbsolute ? (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject20()) : "";
}, function(p) {
    return p.iconSize;
}, function(p) {
    return p.theme.icons.callToActionHover;
});
var MobileWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MobileWrapper",
    componentId: "sc-0-16"
})(_templateObject22());
var CompareSortWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "CompareSortWrapper",
    componentId: "sc-0-17"
})(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var StyledFilterButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_toggle_button__WEBPACK_IMPORTED_MODULE_4__/* .ToggleButton */ .C).withConfig({
    displayName: "StyledFilterButton",
    componentId: "sc-0-18"
})(_templateObject25(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject24()));
var AdvertWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "AdvertWrapper",
    componentId: "sc-0-19"
})(_templateObject26(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.bg.tertiary;
});


/***/ }),

/***/ 64983:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": () => (/* reexport */ CompactListLayout)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/product-card-old/product-card-context.tsx
var product_card_context = __webpack_require__(5780);
// EXTERNAL MODULE: ./src/areas/product-collection/components/ads/index.tsx + 1 modules
var ads = __webpack_require__(72943);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/highlighted-search-result.tsx
var highlighted_search_result = __webpack_require__(85029);
// EXTERNAL MODULE: ./src/areas/product-collection/utils/products.ts
var utils_products = __webpack_require__(37424);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(21068);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/product-card-old/index.tsx + 27 modules
var product_card_old = __webpack_require__(90299);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-compact-list/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  list-style: none;\n  margin-top: ",
        ";\n\n  [class^='AdContainer'] {\n    padding: ",
        " 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  order: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  order: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ListUl = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "ListUl",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ProductCard = (0,styled_components_browser_esm["default"])(product_card_old/* ProductCompactListCard */.Yu).withConfig({
    displayName: "ProductCard",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.$order;
});
var OfferCard = (0,styled_components_browser_esm["default"])(product_card_old/* ProductCompactListCard */.Yu).withConfig({
    displayName: "OfferCard",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.$order;
});

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-compact-list/layout-compact-list.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var ProductCardWrapper = function(props) {
    var ref, ref1, ref2;
    var deselectProductById = props.deselectProductById, isSelectingProducts = props.isSelectingProducts, onClick = props.onClick, order = props.order, product = props.product, selectedProducts = props.selectedProducts, selectProductById = props.selectProductById;
    var id = product.id;
    if (product.__typename === "Offer") {
        var _offerId;
        id = (_offerId = product.offerId) !== null && _offerId !== void 0 ? _offerId : "";
    }
    var dealsDiffPercentage = product === null || product === void 0 ? void 0 : (ref = product.dealInfo) === null || ref === void 0 ? void 0 : ref.dealPercentage;
    var onSelect = function(productId) {
        return selectProductById && selectProductById(productId);
    };
    var onDeselect = function(productId) {
        return deselectProductById && deselectProductById(productId);
    };
    var onClickHandler = (0,react.useCallback)(function() {
        return onClick && onClick({
            id: id,
            name: product.name,
            type: product.__typename
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        id
    ]);
    var getPrice = function() {
        switch(product.__typename){
            case "Product":
                return product.priceSummary.regular;
            case "Offer":
                return product.offerPrice.regular;
            case "Raw":
                return product.price;
            default:
                return undefined;
        }
    };
    var disableUnfeaturedClickout = (0,utils_products/* isRaw */._)(product) && !((ref1 = product.store) === null || ref1 === void 0 ? void 0 : ref1.featured);
    var isSponsored = Boolean(product.sponsor);
    (0,react.useEffect)(function() {
        if (isSponsored) {
            (0,data_layer/* pushEvent */.A)("temp_view_sponsored_product_card", {
                productId: product.id
            });
        }
    }, [
        product.id,
        isSponsored
    ]);
    return !(0,utils_products/* isRaw */._)(product) ? /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        diffPercentage: dealsDiffPercentage,
        highlightedName: product.highlight ? /*#__PURE__*/ react.createElement(highlighted_search_result/* default */.Z, null, product.highlight) : undefined,
        onClick: onClickHandler,
        product: product,
        selectStates: {
            onDeselect: function() {
                return onDeselect(product.id);
            },
            onSelect: function() {
                return onSelect(product.id);
            },
            selectable: Boolean(isSelectingProducts),
            selected: Boolean(selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.find(function(p) {
                return p.id === product.id;
            }))
        }
    }, /*#__PURE__*/ react.createElement(ProductCard, {
        $order: order
    })) : /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        onClick: onClickHandler,
        product: _objectSpreadProps(_objectSpread({}, product), {
            media: {
                first: product.__typename === "Offer" ? (ref2 = product.media) === null || ref2 === void 0 ? void 0 : ref2.first : undefined
            },
            pathName: disableUnfeaturedClickout ? undefined : product.externalUri,
            priceSummary: {
                regular: getPrice()
            }
        }),
        type: "offer"
    }, /*#__PURE__*/ react.createElement(OfferCard, {
        key: "".concat(product.name, "-").concat(order),
        $order: order
    }));
};
var CompactListLayout = function(props) {
    var feedbackPrompt = props.feedbackPrompt, _feedbackPromptPosition = props.feedbackPromptPosition, feedbackPromptPosition = _feedbackPromptPosition === void 0 ? 5 : _feedbackPromptPosition, adsLayoutConfig = props.adsLayoutConfig, onClick = props.onClick, products = props.products, hasFeedback = props.hasFeedback, productComparisonProps = _objectWithoutProperties(props, [
        "feedbackPrompt",
        "feedbackPromptPosition",
        "adsLayoutConfig",
        "onClick",
        "products",
        "hasFeedback"
    ]);
    var hasSponsoredProduct = products.some(function(param) {
        var sponsor = param.sponsor;
        return !!sponsor;
    });
    var market = (0,app_context/* useAppContext */.bp)().market;
    return /*#__PURE__*/ react.createElement(ListUl, {
        "data-test": "ProductLayoutList"
    }, products.map(function(product, index) {
        /*#__PURE__*/ return react.createElement(ProductCardWrapper, _extends({
            key: !(0,utils_products/* isRaw */._)(product) ? product.id : "".concat(product.name, "-").concat(index.toString()),
            onClick: function(productData) {
                onClick === null || onClick === void 0 ? void 0 : onClick(productData.id, productData.name, productData.type);
                if (!(0,utils_products/* isRaw */._)(product)) {
                    if (product.sponsor) {
                        var ref;
                        (0,tracking/* trackInternalNavigationClick */.p)({
                            scope: tracking/* InternalNavigationScope.SPONSORED_PRODUCT_CARD */.U.SPONSORED_PRODUCT_CARD,
                            nextPage: product.pathName,
                            index: index
                        });
                        (ref = window.pjsession) === null || ref === void 0 ? void 0 : ref.track("sponsored_product", {
                            clientId: "1331",
                            market: market.code.toUpperCase(),
                            event_data: {
                                product_id: String(productData.id)
                            }
                        });
                    } else {
                        (0,tracking/* trackInternalNavigationClick */.p)({
                            scope: tracking/* InternalNavigationScope.COMPACT_LIST_LAYOUT_PRODUCT_CARD */.U.COMPACT_LIST_LAYOUT_PRODUCT_CARD,
                            nextPage: product.pathName,
                            index: index
                        });
                    }
                }
            },
            order: index + 1,
            product: product
        }, productComparisonProps));
    }), !hasSponsoredProduct ? /*#__PURE__*/ react.createElement(ads/* Ads */.f, {
        key: "static-ads",
        offersLength: products.length,
        layout: types/* LayoutMode.COMPACT_LIST */.X.COMPACT_LIST,
        layoutConfig: adsLayoutConfig
    }) : null, hasFeedback && /*#__PURE__*/ react.createElement("li", {
        style: {
            order: feedbackPromptPosition - 1
        }
    }, feedbackPrompt));
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-compact-list/index.tsx



/***/ }),

/***/ 39438:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": () => (/* binding */ FEEDBACK_PROMPT_ROW_POSITION),
/* harmony export */   "DT": () => (/* binding */ MIXED_CONTENT_ROW_POSITIONS),
/* harmony export */   "cj": () => (/* binding */ MIXED_CONTENT_VISIBILITY_MIN_PRODUCTS_COUNT)
/* harmony export */ });
var FEEDBACK_PROMPT_ROW_POSITION = 6;
var MIXED_CONTENT_ROW_POSITIONS = [
    // This is the row position of the first mixed content card and the second mixed content card,
    // per breakpoint.
    {
        desktop: 2,
        tablet: 3,
        mobile: 5
    },
    {
        desktop: 5,
        tablet: 7,
        mobile: 13
    },
    {
        desktop: 8,
        tablet: 12,
        mobile: 20
    },
    {
        desktop: 11,
        tablet: 15,
        mobile: 25
    }
];
var MIXED_CONTENT_VISIBILITY_MIN_PRODUCTS_COUNT = [
    // This is the minimum number of products that need to be visible
    // for the first mixed content card and the second mixed content card,
    // per breakpoint.
    {
        isDesktop: 6,
        isTablet: 7,
        isMobile: 6
    },
    {
        isDesktop: 16,
        isTablet: 14,
        isMobile: 14
    },
    {
        isDesktop: 26,
        isTablet: 27,
        isMobile: 26
    },
    {
        isDesktop: 35,
        isTablet: 34,
        isMobile: 34
    }
];


/***/ }),

/***/ 7830:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": () => (/* reexport */ GridLayout)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(21068);
// EXTERNAL MODULE: ./src/components/advized/index.tsx
var advized = __webpack_require__(69988);
// EXTERNAL MODULE: ./src/areas/product-collection/utils/products.ts
var utils_products = __webpack_require__(37424);
// EXTERNAL MODULE: ./src/areas/product-collection/components/ads/index.tsx + 1 modules
var ads = __webpack_require__(72943);
// EXTERNAL MODULE: ./src/areas/product-collection/components/offers-grid/index.tsx
var offers_grid = __webpack_require__(79821);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/utils.ts
var utils = __webpack_require__(74596);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/areas/expert/types.ts
var expert_types = __webpack_require__(54712);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/description/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  p {\n    margin: 0;\n\n    &:not(:first-child) {\n      display: none;\n    }\n\n    /* stylelint-disable */\n    /* Restrict the box to the specified number of lines of text.\n   * See https://css-tricks.com/almanac/properties/l/line-clamp/ */\n    display: -webkit-box;\n    -webkit-line-clamp: ",
        ";\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledDescription = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledDescription",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.$maxLines;
});

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/description/index.tsx



var MAX_LINES = 7;
var Description = function(param) {
    var item = param.item;
    switch(item.__typename){
        case expert_types/* ContentTypes.TOPLIST */.b.TOPLIST:
            {
                var ref, ref1;
                if (!((ref = item.description) === null || ref === void 0 ? void 0 : ref.length)) return undefined;
                var markup = function(html) {
                    return {
                        __html: html
                    };
                };
                var texts = (ref1 = item.description) === null || ref1 === void 0 ? void 0 : ref1.filter(function(description) {
                    return description.type === "text";
                });
                return texts.length > 0 ? /*#__PURE__*/ react.createElement(StyledDescription, {
                    key: texts[0].data,
                    dangerouslySetInnerHTML: markup(texts[0].data),
                    $maxLines: MAX_LINES
                }) : null;
            }
        case expert_types/* ContentTypes.GUIDE */.b.GUIDE:
        case expert_types/* ContentTypes.ARTICLE */.b.ARTICLE:
            return /*#__PURE__*/ react.createElement(StyledDescription, {
                $maxLines: MAX_LINES
            }, /*#__PURE__*/ react.createElement("p", null, item.description));
        case expert_types/* ContentTypes.SPONSORED_ARTICLE */.b.SPONSORED_ARTICLE:
        case expert_types/* ContentTypes.GENERIC_ARTICLE */.b.GENERIC_ARTICLE:
        case expert_types/* ContentTypes.EDITORIAL_LANDING_PAGE */.b.EDITORIAL_LANDING_PAGE:
            return /*#__PURE__*/ react.createElement(StyledDescription, {
                $maxLines: MAX_LINES
            }, /*#__PURE__*/ react.createElement("p", null, item.preamble));
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/shared/image/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 140px;\n  height: 140px;\n  object-fit: cover;\n  rotate: 6deg;\n  border-radius: 16px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  border-radius: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var StyledRotatedImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledRotatedImage",
    componentId: "sc-0-0"
})(styles_templateObject());
var StyledFullImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledFullImage",
    componentId: "sc-0-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/shared/image/index.tsx



var Image = function(param) {
    var item = param.item;
    switch(item.__typename){
        case expert_types/* ContentTypes.GUIDE */.b.GUIDE:
        case expert_types/* ContentTypes.ARTICLE */.b.ARTICLE:
        case expert_types/* ContentTypes.TOPLIST */.b.TOPLIST:
            return (item === null || item === void 0 ? void 0 : item.image) && /*#__PURE__*/ react.createElement(StyledRotatedImage, {
                src: item.image.src,
                alt: item.image.alt
            });
        case expert_types/* ContentTypes.SPONSORED_ARTICLE */.b.SPONSORED_ARTICLE:
        case expert_types/* ContentTypes.GENERIC_ARTICLE */.b.GENERIC_ARTICLE:
        case expert_types/* ContentTypes.EDITORIAL_LANDING_PAGE */.b.EDITORIAL_LANDING_PAGE:
            return (item === null || item === void 0 ? void 0 : item.thumbnail) && /*#__PURE__*/ react.createElement(StyledRotatedImage, {
                src: item.thumbnail,
                alt: item.title
            });
        case expert_types/* ContentTypes.VIDEO */.b.VIDEO:
            return item.previewImage ? /*#__PURE__*/ react.createElement(StyledFullImage, {
                src: item.previewImage
            }) : null;
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./src/areas/expert/components/expert-avatar/index.tsx + 1 modules
var expert_avatar = __webpack_require__(53973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/arrow-right/index.js
var arrow_right = __webpack_require__(7743);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/link-text/styles.ts
function link_text_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function link_text_styles_templateObject() {
    var data = link_text_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: ",
        "px 1fr;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    link_text_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = link_text_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = link_text_styles_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var EXPERT_AVATAR_SIZE = 40;
var StyledExpert = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledExpert",
    componentId: "sc-0-0"
})(link_text_styles_templateObject(), EXPERT_AVATAR_SIZE, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledLinkTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledLinkTextWrapper",
    componentId: "sc-0-1"
})(styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledLinkText = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "StyledLinkText",
    componentId: "sc-0-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/link-text/index.tsx






var LinkText = function(param) {
    var item = param.item;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var linkText = function() {
        switch(item.__typename){
            case expert_types/* ContentTypes.ARTICLE */.b.ARTICLE:
            case expert_types/* ContentTypes.GENERIC_ARTICLE */.b.GENERIC_ARTICLE:
                return t("search", "mixed-content.".concat(expert_types/* ContentTypes.ARTICLE.toLowerCase */.b.ARTICLE.toLowerCase(), "-link-text"));
            default:
                var ref;
                return t("search", "mixed-content.".concat((ref = item.__typename) === null || ref === void 0 ? void 0 : ref.toLowerCase(), "-link-text"));
        }
    };
    var linkIconSize = 18;
    switch(item.__typename){
        case expert_types/* ContentTypes.TOPLIST */.b.TOPLIST:
        case expert_types/* ContentTypes.GUIDE */.b.GUIDE:
            var ref;
            if ((ref = item.expert) === null || ref === void 0 ? void 0 : ref.name) {
                return /*#__PURE__*/ react.createElement(StyledExpert, null, /*#__PURE__*/ react.createElement(expert_avatar/* default */.Z, {
                    size: EXPERT_AVATAR_SIZE,
                    displayName: item.expert.name,
                    avatar: item.expert.avatar
                }), " ", /*#__PURE__*/ react.createElement(StyledLinkTextWrapper, null, /*#__PURE__*/ react.createElement(StyledLinkText, null, "".concat(linkText(), " ").concat(item.expert.name)), /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
                    size: linkIconSize
                })));
            }
            return null;
        case expert_types/* ContentTypes.ARTICLE */.b.ARTICLE:
        case expert_types/* ContentTypes.GENERIC_ARTICLE */.b.GENERIC_ARTICLE:
        case expert_types/* ContentTypes.EDITORIAL_LANDING_PAGE */.b.EDITORIAL_LANDING_PAGE:
            return /*#__PURE__*/ react.createElement(StyledLinkTextWrapper, null, /*#__PURE__*/ react.createElement(StyledLinkText, null, linkText()), /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
                size: linkIconSize
            }));
        case expert_types/* ContentTypes.SPONSORED_ARTICLE */.b.SPONSORED_ARTICLE:
            return /*#__PURE__*/ react.createElement(StyledLinkTextWrapper, null, /*#__PURE__*/ react.createElement(StyledLinkText, null, linkText()), /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
                size: linkIconSize
            }));
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33561);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/styles.ts
function link_card_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function link_card_styles_templateObject() {
    var data = link_card_styles_taggedTemplateLiteral([
        "\n    padding: ",
        ";\n  "
    ]);
    link_card_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function link_card_styles_templateObject1() {
    var data = link_card_styles_taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n  justify-content: space-between;\n  padding: ",
        ";\n  row-gap: ",
        ";\n\n  ",
        "\n"
    ]);
    link_card_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = link_card_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = link_card_styles_taggedTemplateLiteral([
        "\n  width: fit-content;\n  padding: 0 6px;\n  margin-bottom: 5px;\n  border-radius: 4px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledCardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "StyledCardActionArea",
    componentId: "sc-0-0"
})(link_card_styles_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* media.smallOnly */.BC.smallOnly(link_card_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var StyledDescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDescriptionWrapper",
    componentId: "sc-0-1"
})(styles_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var SponsoredBadge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SponsoredBadge",
    componentId: "sc-0-2"
})(_templateObject3(), function(props) {
    return props.theme.colors.yellove500;
});

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/link-card/index.tsx










var LinkCard = function(props) {
    var item = props.item, link = props.link;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var preTitle = getPreTitle(item, t);
    var onClick = function() {
        if (!link) return;
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.MIXED_CONTENT_CARD */.U.MIXED_CONTENT_CARD,
            nextPage: link
        });
    };
    return /*#__PURE__*/ react.createElement(StyledCardActionArea, {
        container: link ? clickable/* Clickable */.P : "div",
        containerProps: {
            onClick: onClick,
            to: link
        }
    }, /*#__PURE__*/ react.createElement("div", null, preTitle, /*#__PURE__*/ react.createElement(variants.H2Text, null, item.title), /*#__PURE__*/ react.createElement(StyledDescriptionWrapper, null, /*#__PURE__*/ react.createElement(Description, {
        item: item
    }), /*#__PURE__*/ react.createElement(Image, {
        item: item
    }))), /*#__PURE__*/ react.createElement(LinkText, {
        item: item
    }));
};
var getPreTitle = function(item, t) {
    if (!item.__typename) {
        return null;
    }
    if (item.__typename === "SearchSponsoredArticle") {
        return /*#__PURE__*/ react.createElement(SponsoredBadge, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
            scale: variants.FontScale.XS,
            color: variants.FontColor.DARK
        }, t("search", "mixed-content.".concat(item.__typename.toLowerCase(), "-pre-title"), {
            sponsor: item.sponsorName
        })));
    }
    var preTitle = function() {
        switch(item.__typename){
            case "SearchArticleItem":
            case "SearchGenericArticle":
                return t("search", "mixed-content.".concat(expert_types/* ContentTypes.ARTICLE.toLowerCase */.b.ARTICLE.toLowerCase(), "-pre-title"));
            default:
                var ref;
                return t("search", "mixed-content.".concat((ref = item.__typename) === null || ref === void 0 ? void 0 : ref.toLowerCase(), "-pre-title"));
        }
    };
    return /*#__PURE__*/ react.createElement(variants.BodySmallText, null, preTitle());
};

// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/components/partner-video-carousel/components/partner-video-modal/index.tsx + 3 modules
var partner_video_modal = __webpack_require__(87191);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./src/components/youtube-icon/index.tsx + 1 modules
var youtube_icon = __webpack_require__(22448);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/modal-card/styles.ts
function modal_card_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function modal_card_styles_templateObject() {
    var data = modal_card_styles_taggedTemplateLiteral([
        "\n    padding: ",
        ";\n  "
    ]);
    modal_card_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function modal_card_styles_templateObject1() {
    var data = modal_card_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n  padding: ",
        ";\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    modal_card_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function modal_card_styles_templateObject2() {
    var data = modal_card_styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    modal_card_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = modal_card_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var styles_StyledCardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "StyledCardActionArea",
    componentId: "sc-0-0"
})(modal_card_styles_templateObject1(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing150, base/* media.smallOnly */.BC.smallOnly(modal_card_styles_templateObject(), design_tokens.measurements.spacing100));
var StyledImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledImageWrapper",
    componentId: "sc-0-1"
})(modal_card_styles_templateObject2());
var StyledYoutubeIcon = (0,styled_components_browser_esm["default"])(youtube_icon/* YoutubeIcon */.L).withConfig({
    displayName: "StyledYoutubeIcon",
    componentId: "sc-0-2"
})(styles_templateObject3());

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/modal-card/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var ModalCard = function(props) {
    var item = props.item;
    var ref = _slicedToArray((0,react.useState)(false), 2), isPartnerVideoModalOpen = ref[0], setIsPartnerVideoModalOpen = ref[1];
    if (!item.previewImage) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, isPartnerVideoModalOpen && /*#__PURE__*/ react.createElement(partner_video_modal/* PartnerVideoModal */.o, {
        closeModal: function() {
            return setIsPartnerVideoModalOpen(false);
        },
        isOpen: isPartnerVideoModalOpen,
        imageUrl: item.previewImage,
        title: item.title,
        videoId: item.youtubeId
    }), /*#__PURE__*/ react.createElement(styles_StyledCardActionArea, {
        containerProps: {
            onClick: function() {
                return setIsPartnerVideoModalOpen(true);
            },
            type: "button"
        }
    }, /*#__PURE__*/ react.createElement(StyledImageWrapper, null, /*#__PURE__*/ react.createElement(StyledYoutubeIcon, {
        size: 60
    }), /*#__PURE__*/ react.createElement(Image, {
        item: item
    })), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, item.author), /*#__PURE__*/ react.createElement(variants.H2Text, null, item.title))));
};

// EXTERNAL MODULE: ./src/areas/product-collection/components/offers-grid/styles.ts
var styles = __webpack_require__(35632);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/styles.ts
function mixed_content_cards_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mixed_content_cards_styles_templateObject() {
    var data = mixed_content_cards_styles_taggedTemplateLiteral([
        "\n      grid-column: ",
        ";\n      grid-row: ",
        ";\n    "
    ]);
    mixed_content_cards_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mixed_content_cards_styles_templateObject1() {
    var data = mixed_content_cards_styles_taggedTemplateLiteral([
        "\n      grid-column: ",
        " / span 2;\n      grid-row: ",
        ";\n    "
    ]);
    mixed_content_cards_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function mixed_content_cards_styles_templateObject2() {
    var data = mixed_content_cards_styles_taggedTemplateLiteral([
        "\n      grid-column: ",
        " / span 2;\n      grid-row: ",
        ";\n    "
    ]);
    mixed_content_cards_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function mixed_content_cards_styles_templateObject3() {
    var data = mixed_content_cards_styles_taggedTemplateLiteral([
        "\n    ",
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    mixed_content_cards_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = mixed_content_cards_styles_taggedTemplateLiteral([
        "\n    background: ",
        ";\n    height: 100%;\n    box-shadow: none;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var StyledCardWrapper = styled_components_browser_esm["default"].li.withConfig({
    displayName: "StyledCardWrapper",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(mixed_content_cards_styles_templateObject3(), base/* media.smallOnly */.BC.smallOnly(mixed_content_cards_styles_templateObject(), "1 / span ".concat(styles/* ITEMS.small */.cq.small, "}"), props.$row.mobile), base/* media.mediumOnly */.BC.mediumOnly(mixed_content_cards_styles_templateObject1(), props.$position === "right" ? "2" : "1", props.$row.tablet), base/* media.largeUp */.BC.largeUp(mixed_content_cards_styles_templateObject2(), props.$position === "right" ? "3" : "1", props.$row.desktop));
});
var StyledMixedContentCard = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "StyledMixedContentCard",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.theme.colors.base100);
});

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/mixed-content-cards/index.tsx








var MixedContentCards = function(props) {
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var viewportContext = (0,context/* useViewportContext */.Ak)();
    var currentPage = props.currentPage, items = props.items, productsCount = props.productsCount;
    if (currentPage !== 1) return null;
    var currentViewport = Object.keys(viewportContext).find(function(index) {
        return viewportContext[index];
    });
    var visibleItems = (0,utils/* getVisibleCards */.Bq)(items, productsCount, currentViewport);
    return visibleItems.map(function(item, index) {
        var link = (0,utils/* getLinkByType */.ME)(item, linkTo);
        return /*#__PURE__*/ react.createElement(StyledCardWrapper, {
            key: item.id,
            $position: index % 2 ? "left" : "right",
            $row: (0,utils/* getRowPosition */.F6)(index)
        }, /*#__PURE__*/ react.createElement(StyledMixedContentCard, null, item.__typename === expert_types/* ContentTypes.VIDEO */.b.VIDEO ? /*#__PURE__*/ react.createElement(ModalCard, {
            item: item
        }) : /*#__PURE__*/ react.createElement(LinkCard, {
            item: item,
            link: link
        })));
    });
};

// EXTERNAL MODULE: ./src/components/product-card-old/product-card-context.tsx
var product_card_context = __webpack_require__(5780);
// EXTERNAL MODULE: ./src/components/action-buttons/add-to-list/index.tsx
var add_to_list = __webpack_require__(90814);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/highlighted-search-result.tsx
var highlighted_search_result = __webpack_require__(85029);
// EXTERNAL MODULE: ./src/components/product-card-old/index.tsx + 27 modules
var product_card_old = __webpack_require__(90299);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(73426);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/product-cards/grid-product-card.tsx






var GridProductCard = function(props) {
    var ref;
    var deselectProductById = props.deselectProductById, hasExpertBadge = props.hasExpertBadge, id = props.id, isSelectingProducts = props.isSelectingProducts, lazyLoadImage = props.lazyLoadImage, onClick = props.onClick, product = props.product, selectedProducts = props.selectedProducts, selectProductById = props.selectProductById, showCategoryButton = props.showCategoryButton;
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var dealsDiffPercentage = product === null || product === void 0 ? void 0 : (ref = product.dealInfo) === null || ref === void 0 ? void 0 : ref.dealPercentage;
    var onSelect = (0,react.useCallback)(function(productId) {
        return selectProductById && selectProductById(productId);
    }, [
        selectProductById
    ]);
    var onDeselect = (0,react.useCallback)(function(productId) {
        return deselectProductById && deselectProductById(productId);
    }, [
        deselectProductById
    ]);
    return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        ActionArea: isAuthenticated && !isSelectingProducts && /*#__PURE__*/ react.createElement(add_to_list/* AddToListButton */.a, {
            productId: product.id,
            productName: product.name
        }),
        diffPercentage: dealsDiffPercentage,
        hasExpertBadge: hasExpertBadge,
        highlightedName: product.highlight ? /*#__PURE__*/ react.createElement(highlighted_search_result/* default */.Z, null, product.highlight) : undefined,
        onClick: onClick,
        product: product,
        selectStates: {
            onDeselect: function() {
                return onDeselect(product.id);
            },
            onSelect: function() {
                return onSelect(product.id);
            },
            selectable: isSelectingProducts,
            selected: selectedProducts ? selectedProducts.some(function(p) {
                return p.id === id;
            }) : false
        },
        shouldLazyLoadImage: lazyLoadImage,
        showCategoryButton: showCategoryButton
    }, /*#__PURE__*/ react.createElement(product_card_old/* ProductGridCard */.r4, null));
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/product-cards/grid-raw-product-card.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var GridRawProductCard = function(props) {
    var ref;
    var onClick = props.onClick, product = props.product, showCategoryButton = props.showCategoryButton;
    var getPrice = function() {
        switch(product.__typename){
            case "Offer":
                return product.offerPrice.regular;
            case "Raw":
                return product.price;
            default:
                return undefined;
        }
    };
    return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        onClick: onClick,
        product: _objectSpreadProps(_objectSpread({}, product), {
            media: product.__typename === "Offer" ? product.media : undefined,
            pathName: ((ref = product.store) === null || ref === void 0 ? void 0 : ref.featured) ? product.externalUri : undefined,
            priceSummary: {
                regular: getPrice()
            }
        }),
        showCategoryButton: showCategoryButton,
        type: "offer"
    }, /*#__PURE__*/ react.createElement(product_card_old/* ProductGridCard */.r4, null));
};

// EXTERNAL MODULE: ./src/components/product-card/index.ts + 67 modules
var product_card = __webpack_require__(866);
// EXTERNAL MODULE: ./src/components/product-of-the-year/hooks.ts
var hooks = __webpack_require__(44266);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/layout-grid/constants.ts
var constants = __webpack_require__(39438);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/types.ts
var products_types = __webpack_require__(60);
// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(76323);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/styles.ts
function layout_grid_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function layout_grid_styles_templateObject() {
    var data = layout_grid_styles_taggedTemplateLiteral([
        "grid-column: 1 / span ",
        ""
    ]);
    layout_grid_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function layout_grid_styles_templateObject1() {
    var data = layout_grid_styles_taggedTemplateLiteral([
        "\n  grid-row: ",
        ";\n  ",
        "\n"
    ]);
    layout_grid_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




// This should work because OffersGrid (src/areas/product-collection/components/offers-grid/styles) renders first and mutates ITEMS during that render
// Therefore, ITEMS here should match the items number used to render the offers grid
var StyledFeedbackPrompt = styled_components_browser_esm["default"].li.withConfig({
    displayName: "StyledFeedbackPrompt",
    componentId: "sc-0-0"
})(layout_grid_styles_templateObject1(), function(p) {
    return p.$position;
}, variables/* breakpointNames.map */.PS.map(function(bp) {
    return base/* media */.BC["".concat(bp, "Only")](layout_grid_styles_templateObject(), styles/* ITEMS */.cq[bp]);
}));

// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/layout-grid.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

















var IMAGES_PER_ROW_MOBILE = 2;
var ProductCardWrapper = function(param) {
    var deselectProductById = param.deselectProductById, isSelectingProducts = param.isSelectingProducts, _lazyLoadImage = param.lazyLoadImage, lazyLoadImage = _lazyLoadImage === void 0 ? true : _lazyLoadImage, _showCategoryButton = param.showCategoryButton, showCategoryButton = _showCategoryButton === void 0 ? false : _showCategoryButton, onClick = param.onClick, product = param.product, hasExpertBadge = param.hasExpertBadge, selectProductById = param.selectProductById, selectedProducts = param.selectedProducts, pageType = param.pageType;
    var productOfTheYear = (0,hooks/* useGetProductOfTheYear */.i)(product.id);
    var raw = (0,utils_products/* isRaw */._)(product);
    var id = product.id;
    if (product.__typename === "Offer") {
        var _offerId;
        id = (_offerId = product.offerId) !== null && _offerId !== void 0 ? _offerId : "";
    }
    var onClickHandler = (0,react.useCallback)(function() {
        return onClick && onClick({
            id: id,
            name: product.name,
            type: product.__typename
        });
    }, [
        id,
        onClick,
        product.__typename,
        product.name
    ]);
    var renderProductCardByPageType = function() {
        switch(pageType){
            case products_types/* PageTypeEnum.SEARCH */.D.SEARCH:
                return /*#__PURE__*/ react.createElement(product_card/* SearchProductCard */.xJ, {
                    product: product,
                    productOfTheYear: productOfTheYear
                });
            default:
                return /*#__PURE__*/ react.createElement(GridProductCard, {
                    deselectProductById: deselectProductById,
                    hasExpertBadge: hasExpertBadge,
                    id: id,
                    isSelectingProducts: isSelectingProducts,
                    lazyLoadImage: lazyLoadImage,
                    onClick: onClickHandler,
                    product: product,
                    selectedProducts: selectedProducts,
                    selectProductById: selectProductById,
                    showCategoryButton: showCategoryButton
                });
        }
    };
    var isSponsored = Boolean(product.sponsor);
    (0,react.useEffect)(function() {
        if (isSponsored) {
            (0,data_layer/* pushEvent */.A)("temp_view_sponsored_product_card", {
                productId: product.id
            });
        }
    }, [
        product.id,
        isSponsored
    ]);
    return raw ? /*#__PURE__*/ react.createElement(GridRawProductCard, {
        onClick: onClickHandler,
        product: product,
        showCategoryButton: showCategoryButton
    }) : renderProductCardByPageType();
};
var GridLayout = function(_param) {
    var feedbackPrompt = _param.feedbackPrompt, onClick = _param.onClick, products = _param.products, expert = _param.expert, adsLayoutConfig = _param.adsLayoutConfig, isExtraWide = _param.isExtraWide, hasFeedback = _param.hasFeedback, _showCategoryButton = _param.showCategoryButton, showCategoryButton = _showCategoryButton === void 0 ? false : _showCategoryButton, mixedContentCards = _param.mixedContentCards, currentPage = _param.currentPage, pageType = _param.pageType, productComparisonProps = _objectWithoutProperties(_param, [
        "feedbackPrompt",
        "onClick",
        "products",
        "expert",
        "adsLayoutConfig",
        "isExtraWide",
        "hasFeedback",
        "showCategoryButton",
        "mixedContentCards",
        "currentPage",
        "pageType"
    ]);
    var hasSponsoredProduct = products.some(function(param) {
        var sponsor = param.sponsor;
        return !!sponsor;
    });
    var market = (0,app_context/* useAppContext */.bp)().market;
    return /*#__PURE__*/ react.createElement(offers_grid/* OffersGrid */.u, {
        isExtraWide: isExtraWide,
        offers: products.map(function(product, index) {
            var raw = (0,utils_products/* isRaw */._)(product);
            return /*#__PURE__*/ react.createElement(ProductCardWrapper, _extends({
                key: !raw ? product.id : "".concat(product.name, "-").concat(index.toString()),
                onClick: function(productData) {
                    onClick === null || onClick === void 0 ? void 0 : onClick(productData.id, productData.name, productData.type, index);
                    if (!raw) {
                        if (product.sponsor) {
                            var ref;
                            (0,tracking/* trackInternalNavigationClick */.p)({
                                scope: tracking/* InternalNavigationScope.SPONSORED_PRODUCT_CARD */.U.SPONSORED_PRODUCT_CARD,
                                nextPage: product.pathName,
                                index: index
                            });
                            (ref = window.pjsession) === null || ref === void 0 ? void 0 : ref.track("sponsored_product", {
                                clientId: "1331",
                                market: market.code.toUpperCase(),
                                event_data: {
                                    product_id: String(productData.id)
                                }
                            });
                        } else {
                            (0,tracking/* trackInternalNavigationClick */.p)({
                                scope: tracking/* InternalNavigationScope.GRID_LAYOUT_PRODUCT_CARD */.U.GRID_LAYOUT_PRODUCT_CARD,
                                nextPage: product.pathName,
                                index: index
                            });
                        }
                    }
                },
                product: product,
                hasExpertBadge: !raw && product.isExpertTopRated,
                // Lazy loading is disabled for the first row of images (two first for mobile)
                // to enable images to load before React is loaded. The goal of this strategy
                // is to improve our Lighthouse performance score, and specifically the
                // "Largest Contentful Paint" metric.
                lazyLoadImage: index >= IMAGES_PER_ROW_MOBILE * 2,
                showCategoryButton: showCategoryButton,
                pageType: pageType
            }, productComparisonProps));
        })
    }, !hasSponsoredProduct ? /*#__PURE__*/ react.createElement(ads/* Ads */.f, {
        key: "static-ads",
        offersLength: products.length,
        layout: types/* LayoutMode.GRID */.X.GRID,
        layoutConfig: adsLayoutConfig
    }) : null, expert && /*#__PURE__*/ react.createElement(advized/* AdvizedCarousel */._, _extends({}, expert, {
        grid: true
    })), hasFeedback && /*#__PURE__*/ react.createElement(StyledFeedbackPrompt, {
        $position: constants/* FEEDBACK_PROMPT_ROW_POSITION */.B9
    }, feedbackPrompt), mixedContentCards && /*#__PURE__*/ react.createElement(MixedContentCards, {
        currentPage: currentPage,
        items: mixedContentCards,
        productsCount: products.length
    }));
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-grid/index.tsx



/***/ }),

/***/ 74596:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": () => (/* binding */ getVisibleCards),
/* harmony export */   "F6": () => (/* binding */ getRowPosition),
/* harmony export */   "ME": () => (/* binding */ getLinkByType)
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39438);
/* harmony import */ var src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54712);


var getLinkByType = function(item, linkTo) {
    switch(item.__typename){
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.TOPLIST */ .b.TOPLIST:
            return item.headlineInfo.url;
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.GUIDE */ .b.GUIDE:
            return item.url;
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.ARTICLE */ .b.ARTICLE:
            return item.link;
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.SPONSORED_ARTICLE */ .b.SPONSORED_ARTICLE:
            return linkTo("sponsoredArticle", {
                slug: item.slug
            });
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.GENERIC_ARTICLE */ .b.GENERIC_ARTICLE:
            return linkTo("article", {
                slug: item.slug
            });
        case src_areas_expert_types__WEBPACK_IMPORTED_MODULE_1__/* .ContentTypes.EDITORIAL_LANDING_PAGE */ .b.EDITORIAL_LANDING_PAGE:
            return linkTo("editorialLandingPage", {
                slug: item.slug
            });
        default:
            return undefined;
    }
};
// Gets the amount of mixed content cards that can be shown based on the number of products in the grid.
var getVisibleCards = function(items, productsCount, currentViewport) {
    try {
        return items.filter(function(_, index) {
            return _constants__WEBPACK_IMPORTED_MODULE_0__/* .MIXED_CONTENT_VISIBILITY_MIN_PRODUCTS_COUNT */ .cj[index][currentViewport] <= productsCount;
        });
    } catch (e) {
        throw e;
    }
};
var getRowPosition = function(index) {
    return _constants__WEBPACK_IMPORTED_MODULE_0__/* .MIXED_CONTENT_ROW_POSITIONS */ .DT[index];
};


/***/ }),

/***/ 77951:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": () => (/* reexport */ ListLayout)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/notification-filled/index.js
var notification_filled = __webpack_require__(40900);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(50999);
// EXTERNAL MODULE: ./src/components/action-buttons/base-button.tsx
var base_button = __webpack_require__(3686);
// EXTERNAL MODULE: ./src/components/action-buttons/alert/alert-modal.tsx
var alert_modal = __webpack_require__(25059);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(33944);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(73426);
// EXTERNAL MODULE: ./src/components/action-buttons/styles.ts
var styles = __webpack_require__(61058);
;// CONCATENATED MODULE: ./src/components/action-buttons/alert/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var AlertButton = function(param) {
    var product = param.product, _layout = param.layout, layout = _layout === void 0 ? "icon" : _layout;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = _slicedToArray((0,react.useState)(false), 2), openAlertModal = ref1[0], setOpenAlertModal = ref1[1];
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var userProductAlerts = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.alerts.products;
    });
    var userAlert = userProductAlerts.find(function(alert) {
        return alert.productId === product.id;
    });
    var alertId = userAlert === null || userAlert === void 0 ? void 0 : userAlert.alertId;
    var showAlertModal = (0,react.useCallback)(function() {
        setOpenAlertModal(true);
    }, []);
    var removeAlert = (0,react.useCallback)(function(id, productId) {
        if (!id) return;
        dispatch((0,actions_alert/* openAlerts */.SU)());
        dispatch((0,actions_alert/* removeAlertRequest */.s$)(id, productId));
    }, [
        dispatch
    ]);
    var editAlert = (0,react.useCallback)(function() {
        dispatch((0,actions_alert/* openAlerts */.SU)());
        showAlertModal();
    }, [
        dispatch,
        showAlertModal
    ]);
    if (!market.login.enabled) {
        return null;
    }
    if (!product) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(alert_modal/* AlertModal */.V, {
        closeModal: function() {
            return setOpenAlertModal(false);
        },
        isOpen: openAlertModal,
        productId: product.id
    }), alertId && isAuthenticated ? /*#__PURE__*/ react.createElement(styles/* Dropdown */.Lt, {
        variant: "secondary",
        grow: "left",
        showArrow: false,
        toggleElement: /*#__PURE__*/ react.createElement(base_button/* default */.Z, {
            isActive: true,
            icon: /*#__PURE__*/ react.createElement(notification_filled/* IconNotificationFilled */.Q, null),
            ariaLabel: t("product", "alert.create-button"),
            tooltip: t("product", "action-button.alert-tooltip")
        })
    }, /*#__PURE__*/ react.createElement(styles/* DropdownItem */.hP, {
        onClick: function() {
            return removeAlert(alertId, product.id);
        }
    }, t("product", "alert.delete-button")), /*#__PURE__*/ react.createElement(styles/* DropdownItem */.hP, {
        onClick: editAlert
    }, t("product", "alert.edit-button"))) : /*#__PURE__*/ react.createElement(base_button/* default */.Z, {
        isActive: false,
        icon: /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null),
        ariaLabel: t("alerts", "alert-form.create-button"),
        onClick: showAlertModal,
        tooltip: t("product", "action-button.alert-tooltip"),
        layout: layout
    }));
};

// EXTERNAL MODULE: ./src/components/action-buttons/add-to-list/index.tsx
var add_to_list = __webpack_require__(90814);
// EXTERNAL MODULE: ./src/components/product-card-old/index.tsx + 27 modules
var product_card_old = __webpack_require__(90299);
// EXTERNAL MODULE: ./src/areas/product-collection/components/ads/index.tsx + 1 modules
var ads = __webpack_require__(72943);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/highlighted-search-result.tsx
var highlighted_search_result = __webpack_require__(85029);
// EXTERNAL MODULE: ./src/areas/product-collection/utils/products.ts
var utils_products = __webpack_require__(37424);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(21068);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./src/components/product-card-old/product-card-context.tsx
var product_card_context = __webpack_require__(5780);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-list/layout-list.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-rows: repeat(auto-fill, 1fr);\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n  list-style: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  order: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  order: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    display:none;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
















var ProductCardWrapper = function(props) {
    var ref, ref1, ref2;
    var deselectProductById = props.deselectProductById, isSelectingProducts = props.isSelectingProducts, onClick = props.onClick, order = props.order, product = props.product, hasExpertBadge = props.hasExpertBadge, selectedProducts = props.selectedProducts, selectProductById = props.selectProductById;
    var id = product.id;
    if (product.__typename === "Offer") {
        var _offerId;
        id = (_offerId = product.offerId) !== null && _offerId !== void 0 ? _offerId : "";
    }
    var dealsDiffPercentage = product === null || product === void 0 ? void 0 : (ref = product.dealInfo) === null || ref === void 0 ? void 0 : ref.dealPercentage;
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var onSelect = function(productId) {
        return selectProductById && selectProductById(productId);
    };
    var onDeselect = function(productId) {
        return deselectProductById && deselectProductById(productId);
    };
    var onClickHandler = (0,react.useCallback)(function() {
        return onClick && onClick({
            id: id,
            name: product.name,
            type: product.__typename
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        id
    ]);
    var getPrice = function() {
        switch(product.__typename){
            case "Product":
                return product.priceSummary.regular;
            case "Offer":
                return product.offerPrice.regular;
            case "Raw":
                return product.price;
            default:
                return undefined;
        }
    };
    var disableUnfeaturedClickout = (0,utils_products/* isRaw */._)(product) && !((ref1 = product.store) === null || ref1 === void 0 ? void 0 : ref1.featured);
    // Related to isClickoutExperiment
    var renderActionArea = function(p) {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, isAuthenticated && /*#__PURE__*/ react.createElement(AddToListWrapper, null, /*#__PURE__*/ react.createElement(add_to_list/* AddToListButton */.a, {
            productId: p.id,
            productName: p.name,
            tooltipAlign: ui/* Direction.Left */.Nm.Left,
            dropdownGrow: "right"
        }), " "), /*#__PURE__*/ react.createElement(AddAlertWrapper, null, /*#__PURE__*/ react.createElement(AlertButton, {
            product: p,
            layout: "button"
        })));
    };
    var isSponsored = Boolean(product.sponsor);
    (0,react.useEffect)(function() {
        if (isSponsored) {
            (0,data_layer/* pushEvent */.A)("temp_view_sponsored_product_card", {
                productId: product.id
            });
        }
    }, [
        product.id,
        isSponsored
    ]);
    return !(0,utils_products/* isRaw */._)(product) ? /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        ActionArea: renderActionArea(product),
        container: "li",
        diffPercentage: dealsDiffPercentage,
        hasExpertBadge: hasExpertBadge,
        highlightedName: product.highlight ? /*#__PURE__*/ react.createElement(highlighted_search_result/* default */.Z, null, product.highlight) : undefined,
        imageSize: 100,
        onClick: onClickHandler,
        product: product,
        selectStates: {
            onDeselect: function() {
                return onDeselect(product.id);
            },
            onSelect: function() {
                return onSelect(product.id);
            },
            selectable: isSelectingProducts,
            selected: Boolean(selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.find(function(p) {
                return p.id === product.id;
            }))
        },
        shouldLazyLoadImage: true
    }, /*#__PURE__*/ react.createElement(ProductCard, {
        key: product.id,
        $order: order
    })) : /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        onClick: onClickHandler,
        product: _objectSpreadProps(_objectSpread({}, product), {
            media: {
                first: product.__typename === "Offer" ? (ref2 = product.media) === null || ref2 === void 0 ? void 0 : ref2.first : undefined
            },
            pathName: disableUnfeaturedClickout ? undefined : product.externalUri,
            priceSummary: {
                regular: getPrice()
            }
        }),
        type: "offer"
    }, /*#__PURE__*/ react.createElement(OfferCard, {
        key: "".concat(product.name, "-").concat(order),
        $order: order
    }));
};
var ListLayout = function(props) {
    var adsLayoutConfig = props.adsLayoutConfig, feedbackPrompt = props.feedbackPrompt, _feedbackPromptPosition = props.feedbackPromptPosition, feedbackPromptPosition = _feedbackPromptPosition === void 0 ? 5 : _feedbackPromptPosition, hasFeedback = props.hasFeedback, onClick = props.onClick, products = props.products, productComparisonProps = _objectWithoutProperties(props, [
        "adsLayoutConfig",
        "feedbackPrompt",
        "feedbackPromptPosition",
        "hasFeedback",
        "onClick",
        "products"
    ]);
    var hasSponsoredProduct = products.some(function(param) {
        var sponsor = param.sponsor;
        return !!sponsor;
    });
    var market = (0,app_context/* useAppContext */.bp)().market;
    return /*#__PURE__*/ react.createElement(List, null, products.map(function(product, index) {
        /*#__PURE__*/ return react.createElement(ProductCardWrapper, _extends({
            key: !(0,utils_products/* isRaw */._)(product) ? product.id : "".concat(product.name, "-").concat(index.toString()),
            onClick: function(productData) {
                onClick === null || onClick === void 0 ? void 0 : onClick(productData.id, productData.name, productData.type);
                if (!(0,utils_products/* isRaw */._)(product)) {
                    if (product.sponsor) {
                        var ref;
                        (0,tracking/* trackInternalNavigationClick */.p)({
                            scope: tracking/* InternalNavigationScope.SPONSORED_PRODUCT_CARD */.U.SPONSORED_PRODUCT_CARD,
                            nextPage: product.pathName,
                            index: index
                        });
                        (ref = window.pjsession) === null || ref === void 0 ? void 0 : ref.track("sponsored_product", {
                            clientId: "1331",
                            market: market.code.toUpperCase(),
                            event_data: {
                                product_id: String(productData.id)
                            }
                        });
                    } else {
                        (0,tracking/* trackInternalNavigationClick */.p)({
                            scope: tracking/* InternalNavigationScope.LIST_LAYOUT_PRODUCT_CARD */.U.LIST_LAYOUT_PRODUCT_CARD,
                            nextPage: product.pathName,
                            index: index
                        });
                    }
                }
            },
            order: index + 1,
            product: product,
            hasExpertBadge: !(0,utils_products/* isRaw */._)(product) && product.isExpertTopRated
        }, productComparisonProps));
    }), !hasSponsoredProduct ? /*#__PURE__*/ react.createElement(ads/* Ads */.f, {
        key: "static-ads",
        offersLength: products.length,
        layout: types/* LayoutMode.LIST */.X.LIST,
        layoutConfig: adsLayoutConfig
    }) : null, hasFeedback && /*#__PURE__*/ react.createElement("li", {
        style: {
            order: feedbackPromptPosition - 1
        }
    }, feedbackPrompt));
};
var List = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "List",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ProductCard = (0,styled_components_browser_esm["default"])(product_card_old/* ProductListCard */.MP).withConfig({
    displayName: "ProductCard",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.$order;
});
var OfferCard = (0,styled_components_browser_esm["default"])(product_card_old/* ProductListCard */.MP).withConfig({
    displayName: "OfferCard",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.$order;
});
var AddAlertWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AddAlertWrapper",
    componentId: "sc-0-3"
})(_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(_templateObject3()));
var AddToListWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AddToListWrapper",
    componentId: "sc-0-4"
})(_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-list/index.tsx



/***/ }),

/***/ 60:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": () => (/* binding */ PageTypeEnum)
/* harmony export */ });
var PageTypeEnum;
(function(PageTypeEnum) {
    PageTypeEnum["SEARCH"] = "search";
})(PageTypeEnum || (PageTypeEnum = {}));


/***/ }),

/***/ 97908:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": () => (/* binding */ ToggleButton),
  "y": () => (/* reexport */ VariantEnum)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/toggle-button/types.ts
var VariantEnum;
(function(VariantEnum) {
    VariantEnum["DEFAULT"] = "default";
    VariantEnum["OUTLINED"] = "outlined";
})(VariantEnum || (VariantEnum = {}));

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/toggle-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      overflow: hidden;\n\n      ",
        " {\n        text-align: center;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    align-items: center;\n    border-radius: 50%;\n    display: inline-flex;\n    font-weight: 600;\n    height: 20px;\n    justify-content: center;\n    margin: 0 ",
        ";\n    width: 20px;\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledTitle = (0,styled_components_browser_esm["default"])(ui_button.ButtonText).withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-0"
})(_templateObject());
var StyledButton = (0,styled_components_browser_esm["default"])(ui_button.Button).withConfig({
    displayName: "StyledButton",
    componentId: "sc-0-1"
})(function(param) {
    var $shouldTruncate = param.$shouldTruncate;
    return (0,styled_components_browser_esm.css)(_templateObject2(), $shouldTruncate && (0,styled_components_browser_esm.css)(_templateObject1(), StyledTitle));
});
var StyledAppliedFilterCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledAppliedFilterCount",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.buttonVariant !== "outlined" && (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.pill.inverted.bg, props.theme.pill.inverted.text));
});

;// CONCATENATED MODULE: ./src/areas/product-collection/components/toggle-button/index.tsx




var ToggleButton = function(props) {
    var className = props.className, count = props.count, dataTest = props["data-test"], icon = props.icon, onToggle = props.onToggle, title = props.title, truncate = props.truncate, _variant = props.variant, variant = _variant === void 0 ? VariantEnum.DEFAULT : _variant;
    return /*#__PURE__*/ react.createElement(StyledButton, {
        className: className,
        containerProps: {
            "data-test": dataTest
        },
        elevation: ui_button.ButtonElevation.NONE,
        onClick: onToggle,
        type: variant === VariantEnum.OUTLINED ? ui_button.ButtonType.OUTLINED : ui_button.ButtonType.PRIMARY,
        $shouldTruncate: Boolean(truncate)
    }, icon && /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, icon), title && /*#__PURE__*/ react.createElement(StyledTitle, null, title), count && count !== 0 ? /*#__PURE__*/ react.createElement(StyledAppliedFilterCount, {
        buttonVariant: variant
    }, count) : null);
};



/***/ }),

/***/ 14367:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G_": () => (/* binding */ ProductCollectionFilterTrackingScopeContext),
/* harmony export */   "JB": () => (/* binding */ useTrackClearFilter),
/* harmony export */   "Xn": () => (/* binding */ ProductCollectionTrackingContext),
/* harmony export */   "Yd": () => (/* binding */ ProductCollectionFilterContext),
/* harmony export */   "o$": () => (/* binding */ useTrackFilterSelect)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _client_data_layer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24005);
/* harmony import */ var src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15301);



var ProductCollectionFilterContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    filterLayout: null
});
var ProductCollectionTrackingContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    categoryId: null,
    categoryName: null
});
var ProductCollectionFilterTrackingScopeContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    scope: null
});
var useTrackFilterSelect = function(param) {
    var type = param.type, property = param.property, title = param.title;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductCollectionTrackingContext), categoryId = ref.categoryId, categoryName = ref.categoryName;
    var filterLayout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductCollectionFilterContext).filterLayout;
    var scope = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductCollectionFilterTrackingScopeContext).scope;
    var trackFilterSelectForProductCollection = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(data) {
        var ref;
        // Push old Universal Analytics event
        (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_1__/* .pushEvent */ .A)("productCollectionFilterUpdate", {
            type: type,
            title: title,
            value: data.value,
            property: property,
            categoryId: categoryId,
            categoryName: categoryName,
            filterLayout: filterLayout
        });
        var ref1;
        // Track new event
        (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .trackFilterSelectEvent */ .f9)({
            value: data.value || property,
            scope: scope,
            property: data.property || title || property,
            category: categoryId,
            layout: filterLayout,
            type: type,
            translatedValue: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.translatedValue) === null || ref === void 0 ? void 0 : ref.join(",")) !== null && ref1 !== void 0 ? ref1 : data.value
        });
    }, [
        scope,
        property,
        categoryId,
        filterLayout,
        type,
        title,
        categoryName
    ]);
    var trackFilterRemoveForProductCollection = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(data) {
        var ref;
        var ref1;
        (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .trackFilterRemoveEvent */ .YD)({
            value: data.value || property,
            scope: scope,
            property: data.property || title || property,
            category: categoryId,
            layout: filterLayout,
            type: type,
            translatedValue: (ref1 = data === null || data === void 0 ? void 0 : (ref = data.translatedValue) === null || ref === void 0 ? void 0 : ref.join(",")) !== null && ref1 !== void 0 ? ref1 : data.value
        });
    }, [
        scope,
        property,
        categoryId,
        filterLayout,
        type
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            trackFilterSelect: trackFilterSelectForProductCollection,
            trackFilterRemove: trackFilterRemoveForProductCollection
        };
    }, [
        trackFilterSelectForProductCollection,
        trackFilterRemoveForProductCollection
    ]);
};
var useTrackClearFilter = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductCollectionTrackingContext), categoryId = ref.categoryId, categoryName = ref.categoryName;
    var clearFilter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(property) {
        (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_1__/* .pushEvent */ .A)("productCollectionFilterClear", {
            property: property,
            categoryId: categoryId,
            categoryName: categoryName
        });
    }, [
        categoryId,
        categoryName
    ]);
    return clearFilter;
};


/***/ }),

/***/ 48778:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ useAggregationSettings)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _routes_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65620);


var useAggregationSettings = function(id) {
    var currentRouteState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_routes_context__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).currentRouteState;
    var aggregations = currentRouteState.aggregations;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (aggregations === null || aggregations === void 0 ? void 0 : aggregations.length) ? aggregations.find(function(agg) {
            return agg.id === id;
        }) : undefined;
    }, [
        aggregations,
        id
    ]);
};


/***/ }),

/***/ 61139:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ product_collection)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./packages/product-collection-urls/dist/index.js
var product_collection_urls_dist = __webpack_require__(36074);
// EXTERNAL MODULE: ./src/areas/product-collection/actions/index.ts
var actions = __webpack_require__(72270);
// EXTERNAL MODULE: ./src/areas/product-collection/utils/properties.ts
var properties = __webpack_require__(82740);
;// CONCATENATED MODULE: ./src/areas/product-collection/reducers/static-actions.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




// We need to do this here because we need access to the store in updateFilters
// However we can't statically import it since produces with SSR.
// This way, we only import it in the browser.
var store;
if (true) {
    // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
    store = (__webpack_require__(77679)/* ["default"] */ .Z);
}
var hasOnlyValidFilters = function(filter) {
    if (!("type" in filter)) {
        return false;
    }
    switch(filter.type){
        case "term":
            return "id" in filter && filter.id;
        case "terms":
            return "ids" in filter && filter.ids && filter.ids.length;
        default:
            return true;
    }
};
var replaceOrAdd = function(array, entry) {
    var matchBy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "property";
    var index = array.findIndex(function(x) {
        return x[matchBy] === entry[matchBy];
    });
    var newArr = _toConsumableArray(array);
    if (index >= 0) {
        newArr.splice(index, 1, entry);
    } else {
        newArr.push(entry);
    }
    return newArr;
};
var updateFilters = function(state, filters) {
    var newState = _objectSpreadProps(_objectSpread({}, state), {
        // Reset offset whenever filters are updated
        url: null,
        offset: 0,
        filters: filters
    });
    if (state.id) {
        var filterAction = (0,actions/* updateProductCollectionFilters */.E8)(state.id, filters);
        store.dispatch(filterAction);
        // react ads lib doesn't really support how we've setup PC
        // so this is a fix good enough for now to refresh the ads on filter change
        if (typeof window !== "undefined" && window.apntag && window.apntag.refresh) {
            window.apntag.refresh();
        }
    }
    return newState;
};
// TODO: Update types once resolvers are properly typed (moved to TS)
var productCollectionStaticReducer = function(state, action) {
    switch(action.type){
        case "SHOW_ALL_FILTERS":
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    onlyFeaturedFilters: false
                });
            }
        case "URL_CHANGE":
            {
                var ref = dist_default().parse(action.location.search), qsOffset = ref.offset, sort = ref.sort, direction = ref.direction;
                var offset = typeof qsOffset === "string" ? parseInt(qsOffset, 10) : 0;
                var url = "".concat(action.location.pathname).concat(action.location.search);
                var filters = (0,product_collection_urls_dist.extractFiltersFromUrl)(url).map(function(f) {
                    // ProductCollectionFilterInput type doesn't allow operator property
                    var _ref = f !== null && f !== void 0 ? f : {}, _ = _ref.operator, filter = _objectWithoutProperties(_ref, [
                        "operator"
                    ]);
                    return filter;
                });
                return _objectSpreadProps(_objectSpread({}, state), {
                    url: null,
                    offset: offset,
                    sort: sort,
                    direction: direction,
                    filters: filters
                });
            }
        // BUG: ??? currently in production when we change sorting, the URL resets itself ???
        case "SORT_CHANGE":
            {
                var ref1 = dist_default().parse(action.location.search), offset1 = ref1.offset, direction1 = ref1.direction;
                return _objectSpreadProps(_objectSpread({}, state), {
                    sort: action.sort,
                    offset: typeof offset1 === "string" ? parseInt(offset1, 10) : 0,
                    direction: direction1
                });
            }
        case "PAGINATION":
            {
                var ref2 = dist_default().parse(action.location.search), sort1 = ref2.sort, direction2 = ref2.direction;
                return _objectSpreadProps(_objectSpread({}, state), {
                    offset: action.clickedOffset,
                    sort: sort1,
                    direction: direction2
                });
            }
        case "FILTER_RANGE_UPDATE":
            {
                return updateFilters(state, replaceOrAdd(state.filters, action.filter));
            }
        case "FILTER_RANGE_GROUP_UPDATE":
            {
                var key;
                if (action.multiple) {
                    var currentFilter = state.filters.find(function(f) {
                        return "property" in f && f.property === action.property;
                    });
                    var currentKeys = [];
                    if (currentFilter) {
                        currentKeys = Array.isArray(currentFilter.key) ? currentFilter.key : [
                            currentFilter.key
                        ];
                    }
                    var index = currentKeys.indexOf(action.id);
                    if (index >= 0) {
                        currentKeys.splice(index, 1);
                    } else {
                        currentKeys.push(action.id);
                    }
                    key = currentKeys;
                } else {
                    key = [
                        action.id
                    ];
                }
                var filter = {
                    type: "range-group",
                    property: action.property,
                    key: key
                };
                return updateFilters(state, !filter.key.length ? state.filters.filter(function(f) {
                    return "property" in f && f.property !== action.property;
                }) : replaceOrAdd(state.filters, filter));
            }
        case "FILTER_BOOLEAN_UPDATE":
            {
                var filter1 = {
                    type: "boolean",
                    id: action.id,
                    property: action.property
                };
                var newFilters = replaceOrAdd(state.filters, filter1);
                return updateFilters(state, newFilters.filter(hasOnlyValidFilters));
            }
        case "FILTER_LIST_UPDATE":
            {
                var id = action.id, clearCurrentFilters = action.clearCurrentFilters;
                var filters1 = clearCurrentFilters ? [] : state.filters;
                var currentFilter1 = filters1.find(function(f) {
                    return "property" in f && f.property === action.property;
                });
                var termId = currentFilter1 && "id" in currentFilter1 ? currentFilter1.id : [];
                var termIds = currentFilter1 && "ids" in currentFilter1 ? currentFilter1.ids : [];
                var ids = termIds.concat(termId);
                if (!id) {
                    return state;
                }
                if (!action.multiple) {
                    var newFilters1 = replaceOrAdd(filters1, {
                        type: "term",
                        id: id,
                        property: action.property
                    });
                    return updateFilters(state, newFilters1.filter(hasOnlyValidFilters));
                }
                var index1 = ids.indexOf(id);
                if (index1 >= 0) {
                    ids.splice(index1, 1);
                } else {
                    ids.push(id);
                }
                var filter2 = ids.length === 1 ? {
                    type: "term",
                    property: action.property,
                    id: ids[0]
                } : {
                    type: "terms",
                    property: action.property,
                    ids: ids
                };
                var newFilters2 = replaceOrAdd(filters1, filter2);
                return updateFilters(state, newFilters2.filter(hasOnlyValidFilters));
            }
        case "FILTER_LIST_TREE_UPDATE":
            {
                var otherActiveFilters = state.filters.filter(function(f) {
                    return "property" in f && f.property !== action.property;
                });
                var ids1 = action.ids;
                var filter3 = ids1.length === 1 ? {
                    type: "term",
                    property: action.property,
                    id: ids1[0]
                } : {
                    type: "terms",
                    property: action.property,
                    ids: ids1
                };
                var filters2 = ids1.length ? _toConsumableArray(otherActiveFilters).concat([
                    filter3
                ]) : otherActiveFilters;
                return updateFilters(state, filters2);
            }
        case "FILTER_NAME_SEARCH_UPDATE":
            {
                var ref3;
                var newFilters3 = state.filters.filter(function(f) {
                    return "type" in f && f.type !== "name-search";
                });
                if ((ref3 = action.query) === null || ref3 === void 0 ? void 0 : ref3.length) {
                    newFilters3.push({
                        type: "name-search",
                        query: action.query
                    });
                }
                return updateFilters(state, newFilters3.filter(hasOnlyValidFilters));
            }
        case "FILTER_REMOVE":
            {
                // If a property is passed, clear filters for that property, otherwise all filters
                return action.property ? updateFilters(state, state.filters.filter(function(f) {
                    return "property" in f && f.property !== action.property;
                })) : updateFilters(state, []);
            }
        case "ADD_PROPERTY_COLUMN":
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    propertyColumnIds: state.propertyColumnIds.concat([
                        action.propertyId
                    ])
                });
            }
        case "REMOVE_PROPERTY_COLUMN":
            {
                var propertyColumnIds = state.propertyColumnIds.filter(function(property) {
                    return property !== action.propertyId;
                });
                // If we're currently sorting on the column we're removing, clear the sort method as well
                if (state.sort === (0,properties/* getSortKeyForProperty */.g)(action.propertyId)) {
                    return _objectSpreadProps(_objectSpread({}, state), {
                        propertyColumnIds: propertyColumnIds,
                        sort: undefined
                    });
                }
                return _objectSpreadProps(_objectSpread({}, state), {
                    propertyColumnIds: propertyColumnIds
                });
            }
        default:
            {
                return state;
            }
    }
};

// EXTERNAL MODULE: ./src/routes/context.tsx
var context = __webpack_require__(65620);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(42281);
// EXTERNAL MODULE: ./src/hooks/experiments.ts
var experiments = __webpack_require__(60392);
;// CONCATENATED MODULE: ./src/areas/product-collection/utils/product-collections.ts
function product_collections_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_collections_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_collections_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_collections_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_collections_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_collections_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var mergeIntoQueryArray = function(arr, obj, prop) {
    var currentObj = arr.find(function(item) {
        return item[prop] === obj[prop];
    });
    if (currentObj) {
        return arr.map(function(item) {
            return item[prop] === obj[prop] ? product_collections_objectSpread({}, item, obj) : item;
        });
    }
    return arr.concat(obj);
};
// AGGREGATION_RECEIVE
var aggregationReceive = function(productCollection, aggData) {
    var ref;
    var slice = productCollection === null || productCollection === void 0 ? void 0 : (ref = productCollection.slices) === null || ref === void 0 ? void 0 : ref.find(function(s) {
        return (s === null || s === void 0 ? void 0 : s.__typename) === "FilterSlice";
    });
    if (!slice) {
        return productCollection;
    }
    if (slice.__typename === "FilterSlice") {
        // There is a memo on the sections that we need to bail out from
        slice.sections = [].concat(slice.sections.map(function(section) {
            var sectionUpdate = aggData.find(function(param) {
                var id = param.id;
                return section.id === id;
            });
            if (!sectionUpdate) {
                return section;
            }
            var result = product_collections_objectSpread({}, section, sectionUpdate);
            return result;
        }));
    }
    return productCollection;
};
var getProductCollectionPathKey = function(state) {
    var ref;
    var filters = ((state === null || state === void 0 ? void 0 : state.filters) || []).map(function(filter) {
        return filter.type === "range" ? product_collections_objectSpreadProps(product_collections_objectSpread({}, filter), {
            from: "",
            to: ""
        }) : filter;
    });
    return "".concat(getStringQuery(filtersToQueryObject(filters)), ":").concat((state === null || state === void 0 ? void 0 : (ref = state.query) === null || ref === void 0 ? void 0 : ref.offset) || 0);
};

// EXTERNAL MODULE: ./src/components/advized/index.tsx
var advized = __webpack_require__(69988);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/category-description/index.tsx + 1 modules
var category_description = __webpack_require__(7688);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var viewport_context = __webpack_require__(50238);
// EXTERNAL MODULE: ./src/components/word-cloud/index.tsx + 1 modules
var word_cloud = __webpack_require__(55330);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(79393);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/areas/product-collection/tracking.ts + 2 modules
var tracking = __webpack_require__(91567);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/secondary-navigation/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    columns: 3 auto;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    columns: 2 auto;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  width: 100%;\n  min-width: 100%;\n  columns: 4 auto;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  a > span,\n  button {\n    line-height: 1.2rem;\n    color: ",
        ";\n    cursor: pointer;\n    font-weight: 400;\n    &:hover {\n      color: ",
        ";\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: auto;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    align-items: center;\n    justify-content: flex-end;\n    flex: 0 1 auto;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ListItem = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-1"
})(_templateObject1());
var HeaderLink = (0,styled_components_browser_esm["default"])(text_variants.BodySmallText).withConfig({
    displayName: "HeaderLink",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.text.linkExternal;
}, function(p) {
    return p.theme.text.linkExternalHover;
});
var NavigationLinks = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "NavigationLinks",
    componentId: "sc-0-3"
})(_templateObject5(), base/* media.mediumDown */.BC.mediumDown(_templateObject3()), base/* media.smallOnly */.BC.smallOnly(_templateObject4()));
/* stylelint-disable no-descending-specificity */ var NavigationLink = styled_components_browser_esm["default"].li.withConfig({
    displayName: "NavigationLink",
    componentId: "sc-0-4"
})(_templateObject6(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
    return p.theme.text.linkInternal;
}, function(p) {
    return p.theme.text.linkInternalHover;
});
/* stylelint-enable no-descending-specificity */ var HorizontalScroll = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HorizontalScroll",
    componentId: "sc-0-5"
})(_templateObject7());
var PanelHeaderRow = (0,styled_components_browser_esm["default"])(variants.Row).withConfig({
    displayName: "PanelHeaderRow",
    componentId: "sc-0-6"
})(_templateObject8(), function(p) {
    return p.theme.lines.secondary;
});
var ShowAllCategoriesRow = (0,styled_components_browser_esm["default"])(variants.Row).withConfig({
    displayName: "ShowAllCategoriesRow",
    componentId: "sc-0-7"
})(_templateObject9());

;// CONCATENATED MODULE: ./src/areas/product-collection/components/secondary-navigation/sitemap-link.tsx




var SitemapLink = function(param) {
    var productCollection = param.productCollection;
    var ref;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), linkTo = ref1.linkTo, t = ref1.t;
    var productCollectionUrl = productCollection === null || productCollection === void 0 ? void 0 : productCollection.url;
    var sitemapUrl = productCollectionUrl ? linkTo("productCollectionSitemap", {
        baseUrl: productCollectionUrl
    }) : null;
    var headerBlockSlice = productCollection === null || productCollection === void 0 ? void 0 : (ref = productCollection.slices) === null || ref === void 0 ? void 0 : ref.find(function(slice) {
        return slice.__typename === "HeaderBlockSlice";
    });
    var productCollectionTitle = headerBlockSlice ? headerBlockSlice.title : "";
    return sitemapUrl && productCollectionTitle ? /*#__PURE__*/ react.createElement(HeaderLink, {
        "data-test": "SecondaryNavigationSitemapLink",
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: sitemapUrl
        }
    }, t("category", "product-collection.sitemap-link", {
        productCollectionTitle: productCollectionTitle
    })) : null;
};
/* harmony default export */ var sitemap_link = (SitemapLink);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/secondary-navigation/index.tsx









var SecondaryNavigationSlice = function(props) {
    var productCollection = props.productCollection, navigationItems = props.navigationItems;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var onClick = (0,react.useCallback)(function(event, index) {
        window.scrollTo(0, 0);
        var href = event.currentTarget.getAttribute("href");
        if (href) {
            (0,tracking/* trackProductCollectionSecondaryNavigationClick */.ds)(href);
            (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                scope: tracking_tracking/* InternalNavigationScope.SECONDARY_NAVIGATION */.U.SECONDARY_NAVIGATION,
                nextPage: href,
                index: index
            });
        }
    }, []);
    return navigationItems.length ? /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(PanelHeaderRow, null, /*#__PURE__*/ react.createElement(panel/* PanelHeader */.V9, null, /*#__PURE__*/ react.createElement(text_variants.H3Text, null, t("category", "product-collection.related-categories"))), /*#__PURE__*/ react.createElement(ShowAllCategoriesRow, {
        containerProps: {
            "data-test": "ShowAllCategoriesLink"
        }
    }, /*#__PURE__*/ react.createElement(sitemap_link, {
        productCollection: productCollection
    }))), /*#__PURE__*/ react.createElement(HorizontalScroll, null, /*#__PURE__*/ react.createElement(NavigationLinks, {
        "data-test": "SecondaryNavigationLinkList"
    }, navigationItems.map(function(param, index) {
        var title = param.title, url = param.url;
        return /*#__PURE__*/ react.createElement(NavigationLink, {
            key: url,
            "data-test": "SecondaryNavigationLink"
        }, /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
            to: url,
            onClick: function(e) {
                return onClick(e, index);
            }
        }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, title)));
    }))))) : null;
};
/* harmony default export */ var secondary_navigation = (SecondaryNavigationSlice);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/hooks/compare-products-selection.ts
var compare_products_selection = __webpack_require__(51836);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(22899);
// EXTERNAL MODULE: ./src/components/compare-products-basket/index.tsx + 1 modules
var compare_products_basket = __webpack_require__(62960);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(21068);
// EXTERNAL MODULE: ./src/areas/product-collection/utils/property-columns.ts
var property_columns = __webpack_require__(28978);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/constants.ts
// We only show a limited number of featured properties by default in the table layout.
// This determines how many we take (from the start of the list).
var DEFAULT_PROPERTY_COLUMN_COUNT = 2;
var FEEDBACK_PROMPT_POSITION = 5;

// EXTERNAL MODULE: ./src/areas/product-collection/components/products/highlighted-search-result.tsx
var highlighted_search_result = __webpack_require__(85029);
// EXTERNAL MODULE: ./src/hooks/resize-observer.ts
var resize_observer = __webpack_require__(32495);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-table/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n          min-width: 100%;\n        "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n          width: 100%;\n        "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n  margin-bottom: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  visibility: ",
        ";\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n      &:hover,\n      :focus {\n        box-shadow: inset 0 -2px 0 ",
        ";\n        ",
        " {\n          visibility: visible;\n        }\n      }\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n      position: sticky;\n      top: ",
        ";\n      left: 0;\n\n      background: ",
        ";\n      z-index: 6;\n\n      &:first-of-type {\n        z-index: 8;\n      }\n\n      &:after {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: -1px;\n        width: 30px;\n        transform: translateX(100%);\n        transition: box-shadow 0.3s;\n        content: '';\n        pointer-events: none;\n        ",
        "\n      }\n    "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  box-shadow: inset 0 -1px 0 ",
        ";\n  font-size: ",
        ";\n  text-align: start;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: block;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        ":first-child ",
        " {\n    padding-left: ",
        ";\n  }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  padding: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  align-items: center;\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n  vertical-align: top;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var Table = styled_components_browser_esm["default"].table.withConfig({
    displayName: "Table",
    componentId: "sc-0-0"
})(styles_templateObject2(), function(props) {
    return props.scrollable ? (0,styled_components_browser_esm.css)(styles_templateObject()) : (0,styled_components_browser_esm.css)(styles_templateObject1());
}, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var SortIconContainer = styled_components_browser_esm["default"].span.withConfig({
    displayName: "SortIconContainer",
    componentId: "sc-0-1"
})(styles_templateObject3(), function(param) {
    var show = param.show;
    return show ? "visible" : "hidden";
});
var indicateNewColumnAnimation = base/* animations.highlightNewContentAnimation */.sF.highlightNewContentAnimation();
// Track the horizontal padding used in the header cell in order to be able to set a better default
// minimum width for each column programmatically (see table-header.tsx)
var TH_HORIZONTAL_PADDING = base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
var Th = styled_components_browser_esm["default"].th.withConfig({
    displayName: "",
    componentId: "sc-0-2"
})(styles_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.lines.secondary;
}, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, function(param) {
    var canBeSorted = param.canBeSorted, theme = param.theme;
    return canBeSorted && (0,styled_components_browser_esm.css)(styles_templateObject4(), theme.colors.yellove500, SortIconContainer);
}, function(param) {
    var indicateNewColumn = param.indicateNewColumn;
    return indicateNewColumn && indicateNewColumnAnimation;
}, function(p) {
    return p.sticky && (0,styled_components_browser_esm.css)(styles_templateObject5(), base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem, p.theme.colors.base0, p.scrolled && "box-shadow: inset 10px 0 8px -8px rgb(0, 0, 0, 0.15);");
});
var ClickableHeader = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ClickableHeader",
    componentId: "sc-0-3"
})(styles_templateObject7());
var HeaderTr = styled_components_browser_esm["default"].tr.withConfig({
    displayName: "HeaderTr",
    componentId: "sc-0-4"
})(styles_templateObject8(), Th, ClickableHeader, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var HeaderText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "HeaderText",
    componentId: "sc-0-5"
})(styles_templateObject9(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, TH_HORIZONTAL_PADDING, TH_HORIZONTAL_PADDING);
/**
 * When the table is scrollable, the ad should stay in place independently of the table.
 */ var StickyAdRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StickyAdRow",
    componentId: "sc-0-6"
})(_templateObject10());
var AdPositioningContext = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AdPositioningContext",
    componentId: "sc-0-7"
})(_templateObject11());
var AdTr = styled_components_browser_esm["default"].tr.withConfig({
    displayName: "AdTr",
    componentId: "sc-0-8"
})(_templateObject12());
var AdTd = styled_components_browser_esm["default"].td.withConfig({
    displayName: "AdTd",
    componentId: "sc-0-9"
})(_templateObject13());

// EXTERNAL MODULE: ./packages/react-ads/dist/module.js + 1 modules
var dist_module = __webpack_require__(6895);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-table/ads-container.tsx
function ads_container_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ads_container_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ads_container_arrayLikeToArray(arr);
}
function ads_container_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ads_container_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ads_container_toConsumableArray(arr) {
    return ads_container_arrayWithoutHoles(arr) || ads_container_iterableToArray(arr) || ads_container_unsupportedIterableToArray(arr) || ads_container_nonIterableSpread();
}
function ads_container_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ads_container_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ads_container_arrayLikeToArray(o, minLen);
}




var DEFAULT_AD_ROW_HEIGHT = 240;
var MIN_ROW_TO_SHOW_AD = 10;
var INDEX_FOR_AD = 2;
var ContainerAdsTable = function(param) {
    var children = param.children, numOfColumns = param.numOfColumns, _showAds = param.showAds, showAds = _showAds === void 0 ? true : _showAds;
    var shouldShowAd = showAds && react.Children.count(children) >= MIN_ROW_TO_SHOW_AD;
    var ref = (0,resize_observer/* useResizeObserver */.y)(), tmp = ref.height, adRowHeight = tmp === void 0 ? DEFAULT_AD_ROW_HEIGHT : tmp, stickyAdRowRef = ref.ref;
    var adTdStyle = (0,react.useMemo)(function() {
        return {
            height: adRowHeight
        };
    }, [
        adRowHeight
    ]);
    var childrenWithAd = (0,react.useMemo)(function() {
        var adRow = /*#__PURE__*/ react.createElement(AdTr, {
            key: "panorama_ad_".concat(INDEX_FOR_AD)
        }, /*#__PURE__*/ react.createElement(AdTd, {
            colSpan: numOfColumns,
            style: adTdStyle
        }, /*#__PURE__*/ react.createElement(StickyAdRow, {
            ref: stickyAdRowRef,
            key: "static-ads"
        }, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
            format: "panorama_1_wde",
            triggerPoint: 0
        }), /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
            format: "panorama_1",
            triggerPoint: 0
        }))));
        var arr = react.Children.toArray(children);
        return ads_container_toConsumableArray(arr.slice(0, INDEX_FOR_AD)).concat([
            adRow
        ], ads_container_toConsumableArray(arr.slice(INDEX_FOR_AD)));
    }, [
        children,
        adTdStyle,
        numOfColumns,
        stickyAdRowRef
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, shouldShowAd ? childrenWithAd : children);
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-table/new-column-indication.ts
function new_column_indication_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || new_column_indication_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function new_column_indication_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return new_column_indication_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return new_column_indication_arrayLikeToArray(o, minLen);
}

/**
 * Defines an effect that appears when a new column is added, and does two things in sequence:
 *  - Scrolls to reveal the new column
 *  - Indicates the new column
 *
 * The hook handles the first part, but leaves the second part for the consuming component to
 * handle. However, it returns a state variable (indicateNewColumn) to communicate when it's
 * time to indicate the column.
 */ function useNewColumnIndication(columnCount) {
    var ref = _slicedToArray((0,react.useState)(-1), 2), indicateNewColumn = ref[0], setIndicateNewColumn = ref[1];
    var previousColumnCount = (0,react.useRef)(columnCount);
    var timeout = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (columnCount > previousColumnCount.current) {
            clearTimeout(timeout.current);
            var el = document.documentElement;
            el.scrollTo({
                left: el.scrollWidth - el.clientWidth,
                behavior: "smooth"
            });
            timeout.current = setTimeout(function() {
                setIndicateNewColumn(columnCount - 1);
            }, 300);
        }
        previousColumnCount.current = columnCount;
    }, [
        columnCount
    ]);
    return {
        indicateNewColumn: indicateNewColumn
    };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(72321);
// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/question-filled/index.js
var question_filled = __webpack_require__(21832);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close-filled/index.js
var close_filled = __webpack_require__(25064);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/check-filled/index.js
var check_filled = __webpack_require__(6213);
;// CONCATENATED MODULE: ./src/components/property-value/components/styles.ts
function components_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function components_styles_templateObject() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    components_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function components_styles_templateObject1() {
    var data = components_styles_taggedTemplateLiteral([
        ""
    ]);
    components_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function components_styles_templateObject2() {
    var data = components_styles_taggedTemplateLiteral([
        ""
    ]);
    components_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function components_styles_templateObject3() {
    var data = components_styles_taggedTemplateLiteral([
        ""
    ]);
    components_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var BooleanPropertyValue = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BooleanPropertyValue",
    componentId: "sc-0-0"
})(components_styles_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var BOOLEAN_ICON_SIZE = 16;
var BooleanTrueIcon = (0,styled_components_browser_esm["default"])(check_filled.IconCheckFilled).attrs({
    size: BOOLEAN_ICON_SIZE,
    color: "positive500"
}).withConfig({
    displayName: "BooleanTrueIcon",
    componentId: "sc-0-1"
})(components_styles_templateObject1());
var BooleanFalseIcon = (0,styled_components_browser_esm["default"])(close_filled.IconCloseFilled).attrs({
    size: BOOLEAN_ICON_SIZE,
    color: "negative700"
}).withConfig({
    displayName: "BooleanFalseIcon",
    componentId: "sc-0-2"
})(components_styles_templateObject2());
var BooleanUnknownIcon = (0,styled_components_browser_esm["default"])(question_filled/* IconQuestionFilled */.k).attrs({
    size: BOOLEAN_ICON_SIZE,
    color: "base500"
}).withConfig({
    displayName: "BooleanUnknownIcon",
    componentId: "sc-0-3"
})(components_styles_templateObject3());

;// CONCATENATED MODULE: ./src/components/property-value/components/boolean-property-value.tsx


var boolean_property_value_BooleanPropertyValue = function(param) {
    var property = param.property, booleanTrueText = param.booleanTrueText, booleanFalseText = param.booleanFalseText;
    if (property.boolean === true) {
        return /*#__PURE__*/ react.createElement(BooleanPropertyValue, {
            "data-testid": "boolean-true-icon"
        }, /*#__PURE__*/ react.createElement(BooleanTrueIcon, null), "\xa0".concat(booleanTrueText));
    }
    if (property.boolean === false) {
        return /*#__PURE__*/ react.createElement(BooleanPropertyValue, {
            "data-testid": "boolean-false-icon"
        }, /*#__PURE__*/ react.createElement(BooleanFalseIcon, null), "\xa0".concat(booleanFalseText));
    }
    return /*#__PURE__*/ react.createElement(BooleanPropertyValue, {
        "data-testid": "boolean-unknown-icon"
    }, /*#__PURE__*/ react.createElement(BooleanUnknownIcon, null));
};

;// CONCATENATED MODULE: ./src/components/property-value/components/string-property-value.tsx

var StringPropertyValue = function(param) {
    var property = param.property;
    var _value = property.value, value = _value === void 0 ? null : _value, _unit = property.unit, unit = _unit === void 0 ? null : _unit;
    if (value === null) {
        return null;
    }
    if (unit === null) {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, value);
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, "".concat(value, "\xa0").concat(unit));
};

;// CONCATENATED MODULE: ./src/components/property-value/components/number-property-value.tsx

var NumberPropertyValue = function(param) {
    var property = param.property;
    var number = property.number, unit = property.unit;
    if (number === null) {
        return null;
    }
    if (unit === null) {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, number);
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, "".concat(number, "\xa0").concat(unit));
};

;// CONCATENATED MODULE: ./src/components/property-value/components/interval-property-value.tsx

var IntervalPropertyValue = function(param) {
    var property = param.property;
    var from = property.from, to = property.to, unit = property.unit;
    if (from === null && to === null) {
        return null;
    }
    var unitSuffix = unit === null ? "" : "\xa0".concat(unit);
    if (from === null) {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, "".concat(to).concat(unitSuffix));
    }
    if (to === null || from === to) {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, "".concat(from).concat(unitSuffix));
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, "".concat(from, "\xa0-\xa0").concat(to).concat(unitSuffix));
};

;// CONCATENATED MODULE: ./src/components/property-value/components/list-property-value.tsx

var ListPropertyValue = function(param) {
    var property = param.property;
    var ref;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, (ref = property.values) === null || ref === void 0 ? void 0 : ref.filter(Boolean).join(", "));
};

;// CONCATENATED MODULE: ./src/components/property-value/components/property-value.tsx






function unsupportedPropertyType(_property) {
    return null;
}
var PropertyValue = function(param) {
    var property = param.property, booleanTrueText = param.booleanTrueText, booleanFalseText = param.booleanFalseText;
    switch(property.type){
        case "boolean":
            return /*#__PURE__*/ react.createElement(boolean_property_value_BooleanPropertyValue, {
                property: property,
                booleanTrueText: booleanTrueText,
                booleanFalseText: booleanFalseText
            });
        case "string":
            return /*#__PURE__*/ react.createElement(StringPropertyValue, {
                property: property
            });
        case "integer":
        case "decimal":
            return /*#__PURE__*/ react.createElement(NumberPropertyValue, {
                property: property
            });
        case "interval":
            return /*#__PURE__*/ react.createElement(IntervalPropertyValue, {
                property: property
            });
        case "list":
            return /*#__PURE__*/ react.createElement(ListPropertyValue, {
                property: property
            });
        default:
            return unsupportedPropertyType(property);
    }
};

;// CONCATENATED MODULE: ./src/components/property-value/index.tsx



/**
 * The automatic types we get from our GraphQL schema isn't compatible with TS discriminated
 * unions, so we do some wrangling here to make it more usable. Should still be fairly typesafe.
 */ function sanitizeProperty(property) {
    var type = property.type;
    switch(type){
        case "boolean":
            {
                var _boolean = property.boolean, boolean = _boolean === void 0 ? null : _boolean;
                return {
                    type: type,
                    boolean: boolean
                };
            }
        case "string":
            {
                var _value = property.value, value = _value === void 0 ? null : _value, _unit = property.unit, unit = _unit === void 0 ? null : _unit;
                return {
                    type: type,
                    value: value,
                    unit: unit
                };
            }
        case "integer":
        case "decimal":
            {
                var _number = property.number, number = _number === void 0 ? null : _number, _unit1 = property.unit, unit1 = _unit1 === void 0 ? null : _unit1;
                return {
                    type: type,
                    number: number,
                    unit: unit1
                };
            }
        case "interval":
            {
                var _from = property.from, from = _from === void 0 ? null : _from, _to = property.to, to = _to === void 0 ? null : _to, _unit2 = property.unit, unit2 = _unit2 === void 0 ? null : _unit2;
                return {
                    type: type,
                    from: from,
                    to: to,
                    unit: unit2
                };
            }
        case "list":
            {
                var _values = property.values, values = _values === void 0 ? null : _values;
                return {
                    type: type,
                    values: values
                };
            }
        default:
            return null;
    }
}
var property_value_PropertyValue = function(param) {
    var property = param.property;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var sanitizedProperty = sanitizeProperty(property);
    if (!sanitizedProperty) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(PropertyValue, {
        property: sanitizedProperty,
        booleanTrueText: t("category", "property.boolean-true"),
        booleanFalseText: t("category", "property.boolean-false")
    });
};

// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
// EXTERNAL MODULE: ./src/areas/product/utils/price-list/types.ts
var price_list_types = __webpack_require__(34057);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(75695);
;// CONCATENATED MODULE: ./src/components/shipping-label/styles.ts
function shipping_label_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function shipping_label_styles_templateObject() {
    var data = shipping_label_styles_taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n    "
    ]);
    shipping_label_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function shipping_label_styles_templateObject1() {
    var data = shipping_label_styles_taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    shipping_label_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ShippingLabel = (0,styled_components_browser_esm["default"])(price_label/* PriceLabel */.l).withConfig({
    displayName: "ShippingLabel",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(shipping_label_styles_templateObject1(), props.compact && (0,styled_components_browser_esm.css)(shipping_label_styles_templateObject(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall));
});

;// CONCATENATED MODULE: ./src/components/shipping-label/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function shipping_label_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = shipping_label_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function shipping_label_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var shipping_label_ShippingLabel = function(_param) {
    var className = _param.className, _compact = _param.compact, compact = _compact === void 0 ? false : _compact, _emphasis = _param.emphasis, emphasis = _emphasis === void 0 ? text_variants.FontEmphasis.MEDIUM : _emphasis, exclShipping = _param.exclShipping, shippingInfo = _param.shippingInfo, priceDisplay = _param.priceDisplay, rest = shipping_label_objectWithoutProperties(_param, [
        "className",
        "compact",
        "emphasis",
        "exclShipping",
        "shippingInfo",
        "priceDisplay"
    ]);
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var shippingValue;
    if (shippingInfo === undefined || shippingInfo === null) {
        shippingValue = t("product", "price.unknown-shipping");
    } else if (shippingInfo === 0) {
        shippingValue = t("product", "price.free-shipping");
    } else {
        shippingValue = priceDisplay === price_list_types/* PriceDisplayEnum.PRICE_INCLUDES_SHIPPING */.wB.PRICE_INCLUDES_SHIPPING ? t("product", "price.excluding-shipping", {
            price: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
                key: "currency",
                price: exclShipping
            })
        }) : t("product", "price.including-shipping", {
            price: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
                key: "currency",
                price: exclShipping + shippingInfo
            })
        });
    }
    return /*#__PURE__*/ react.createElement(ShippingLabel, _extends({
        className: className,
        value: shippingValue,
        emphasis: emphasis,
        compact: compact,
        weight: text_variants.FontWeight.NORMAL
    }, rest));
};

// EXTERNAL MODULE: ./src/components/stock-status/index.tsx + 1 modules
var stock_status = __webpack_require__(73209);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(71551);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./src/components/badges/deals-badge/index.tsx + 1 modules
var deals_badge = __webpack_require__(48285);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
// EXTERNAL MODULE: ./src/components/product-checkbox/index.tsx + 1 modules
var product_checkbox = __webpack_require__(53692);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-table/styles-row.tsx
function styles_row_extends() {
    styles_row_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return styles_row_extends.apply(this, arguments);
}
function styles_row_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = styles_row_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function styles_row_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function styles_row_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_row_templateObject() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: inline;\n  padding: ",
        " ",
        ";\n  text-align: left;\n"
    ]);
    styles_row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_row_templateObject1() {
    var data = styles_row_taggedTemplateLiteral([
        "\n      position: sticky;\n      z-index: 4;\n      max-width: 280px;\n      left: 0;\n      background: ",
        ";\n\n      &:after {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: -1px;\n        width: 30px;\n        transform: translateX(100%);\n        transition: box-shadow 0.3s;\n        content: '';\n        pointer-events: none;\n        ",
        "\n      }\n    "
    ]);
    styles_row_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_row_templateObject2() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  position: relative;\n  & > a {\n    display: block;\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    styles_row_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_row_templateObject3() {
    var data = styles_row_taggedTemplateLiteral([
        "\n      ",
        "::before {\n        ",
        "\n      }\n    "
    ]);
    styles_row_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_row_templateObject4() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  ",
        "\n\n  @media (pointer: fine) {\n    &:hover {\n      ",
        "::after {\n        ",
        "\n      }\n    }\n  }\n  td:last-child a {\n    padding-right: 0;\n  }\n\n  background-color: ",
        ";\n"
    ]);
    styles_row_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_row_templateObject5() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  font: inherit;\n  font-weight: 600;\n  font-size: ",
        ";\n  margin-bottom: 0;\n  flex: 1;\n"
    ]);
    styles_row_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_row_templateObject6() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n"
    ]);
    styles_row_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_row_templateObject7() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  height: 32px;\n  width: 32px;\n  margin-right: ",
        ";\n"
    ]);
    styles_row_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_row_templateObject8() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_row_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_row_templateObject9() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_row_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_row_templateObject10() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    styles_row_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_row_templateObject11() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  && {\n    box-sizing: border-box;\n    display: flex;\n    flex: 1 0 auto;\n    max-width: 100%;\n    align-items: center;\n  }\n"
    ]);
    styles_row_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_row_templateObject12() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    styles_row_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_row_templateObject13() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  max-width: 200px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"
    ]);
    styles_row_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  max-width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  ",
        ":hover & {\n    ",
        "\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = styles_row_taggedTemplateLiteral([
        "\n  margin: auto;\n  width: fit-content;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}







var styles_row_indicateNewColumnAnimation = base/* animations.highlightNewContentAnimation */.sF.highlightNewContentAnimation();
var TdLink = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "TdLink",
    componentId: "sc-0-0"
})(styles_row_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RawTd = styled_components_browser_esm["default"].td.withConfig({
    displayName: "RawTd",
    componentId: "sc-0-1"
})(styles_row_templateObject2(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, function(param) {
    var theme = param.theme;
    return theme.lines.secondary;
}, function(param) {
    var indicateNewColumn = param.indicateNewColumn;
    return indicateNewColumn && styles_row_indicateNewColumnAnimation;
}, function(p) {
    return p.sticky && (0,styled_components_browser_esm.css)(styles_row_templateObject1(), p.theme.bg.primary, p.scrolled && "box-shadow: inset 10px 0 8px -8px rgb(0, 0, 0, 0.15);");
});
var Tr = styled_components_browser_esm["default"].tr.withConfig({
    displayName: "",
    componentId: "sc-0-2"
})(styles_row_templateObject4(), function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(styles_row_templateObject3(), TdLink, base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
}, TdLink, base/* styledUtils.overlay */.au.overlay(), function(p) {
    return p.highlight ? p.theme.colors.yellove100 : p.theme.colors.base0;
});
var ProductNameTable = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "ProductNameTable",
    componentId: "sc-0-3"
})(styles_row_templateObject5(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var Price = (0,styled_components_browser_esm["default"])(price_label/* PriceLabel */.l).withConfig({
    displayName: "Price",
    componentId: "sc-0-4"
})(styles_row_templateObject6(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal);
var ImageLayout = (0,styled_components_browser_esm.css)(styles_row_templateObject7(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Image = (0,styled_components_browser_esm["default"])(product_image/* ProductImage */.q).withConfig({
    displayName: "Image",
    componentId: "sc-0-5"
})(styles_row_templateObject8(), ImageLayout);
var ImagePlaceholder = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ImagePlaceholder",
    componentId: "sc-0-6"
})(styles_row_templateObject9(), ImageLayout);
var Td = function(_param) /*#__PURE__*/ {
    var children = _param.children, to = _param.to, indicateNewColumn = _param.indicateNewColumn, rest = styles_row_objectWithoutProperties(_param, [
        "children",
        "to",
        "indicateNewColumn"
    ]);
    return react.createElement(RawTd, {
        indicateNewColumn: indicateNewColumn
    }, /*#__PURE__*/ react.createElement(TdLink, styles_row_extends({
        to: to
    }, rest), children));
};
var NameTd = RawTd;
var NameWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NameWrapper",
    componentId: "sc-0-7"
})(styles_row_templateObject10());
var NameLink = (0,styled_components_browser_esm["default"])(TdLink).withConfig({
    displayName: "NameLink",
    componentId: "sc-0-8"
})(styles_row_templateObject11());
var CampaignBadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CampaignBadgeWrapper",
    componentId: "sc-0-9"
})(styles_row_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var PropertyTd = (0,styled_components_browser_esm["default"])(Td).withConfig({
    displayName: "PropertyTd",
    componentId: "sc-0-10"
})(styles_row_templateObject13());
var PropertyContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PropertyContainer",
    componentId: "sc-0-11"
})(_templateObject14());
var CompareCheckbox = (0,styled_components_browser_esm["default"])(product_checkbox/* ProductCheckbox */.WX).withConfig({
    displayName: "CompareCheckbox",
    componentId: "sc-0-12"
})(_templateObject15(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Tr, product_checkbox/* productCheckboxHoverStyle */.lo);
var PriceDealContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceDealContainer",
    componentId: "sc-0-13"
})(_templateObject16());
var Center = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Center",
    componentId: "sc-0-14"
})(_templateObject17());

// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
// EXTERNAL MODULE: ./src/components/product-card-old/components/sponsor-text.tsx
var sponsor_text = __webpack_require__(54305);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-table/product-row.tsx
function product_row_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_row_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_row_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_row_extends() {
    product_row_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return product_row_extends.apply(this, arguments);
}
function product_row_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_row_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_row_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_row_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_row_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_row_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_row_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function product_row_slicedToArray(arr, i) {
    return product_row_arrayWithHoles(arr) || product_row_iterableToArrayLimit(arr, i) || product_row_unsupportedIterableToArray(arr, i) || product_row_nonIterableRest();
}
function product_row_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_row_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_row_arrayLikeToArray(o, minLen);
}
















var product_row_ImagePlaceholder = /*#__PURE__*/ react.createElement(ImagePlaceholder, null);
var RatingTranslationKey = {
    domain: "product",
    key: "product-card.n-ratings"
};
var PropertyColumnItem = function(param) {
    var column = param.column, indicateNewColumn = param.indicateNewColumn, product = param.product, linkProps = param.linkProps;
    var ref;
    var ref1 = product_row_slicedToArray((0,react.useState)(false), 2), visible = ref1[0], setVisible = ref1[1];
    return /*#__PURE__*/ react.createElement(PropertyTd, product_row_extends({
        key: column.id,
        onMouseEnter: function() {
            return setVisible(true);
        },
        onMouseLeave: function() {
            return setVisible(false);
        },
        indicateNewColumn: indicateNewColumn
    }, linkProps), /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        forcedVisible: visible,
        placement: ui/* Direction.Left */.Nm.Left,
        title: ((ref = getProductProperty(product, column.id)) === null || ref === void 0 ? void 0 : ref.pretty) || ""
    }, /*#__PURE__*/ react.createElement(ProductPropertyValue, {
        product: product,
        column: column
    })));
};
var ProductRow = function(param) {
    var product = param.product, propertyColumns = param.propertyColumns, isSelectingProducts = param.isSelectingProducts, selectedProducts = param.selectedProducts, selectProductById = param.selectProductById, deselectProductById = param.deselectProductById, indicateNewColumn = param.indicateNewColumn, highlightedName = param.highlightedName, onClick = param.onClick, stickyFirstColumn = param.stickyFirstColumn, hasScrolled = param.hasScrolled, isSidebarOpen = param.isSidebarOpen;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var isSelected = selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.some(function(p) {
        return p.id === product.id;
    });
    var onSelect = (0,react.useCallback)(function() {
        if (selectProductById) {
            selectProductById(product.id);
        }
    }, [
        product.id,
        selectProductById
    ]);
    var onDeselect = (0,react.useCallback)(function() {
        if (deselectProductById) {
            deselectProductById(product.id);
        }
    }, [
        product.id,
        deselectProductById
    ]);
    var onToggleSelected = isSelected ? onDeselect : onSelect;
    var onClickHandler = (0,react.useCallback)(function() {
        (0,tracking/* trackProductCollectionProductClick */.kQ)(product.id);
        onClick === null || onClick === void 0 ? void 0 : onClick(product.pathName);
    }, [
        product,
        onClick
    ]);
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var pathName = product.pathName, sponsor = product.sponsor;
    var linkUrl = sponsor ? linkTo("product", product) : pathName;
    var linkProps = (0,react.useMemo)(function() {
        var baseLinkProps = {
            "aria-label": product.name,
            "data-test": "ProductListItem"
        };
        return isSelectingProducts ? product_row_objectSpreadProps(product_row_objectSpread({}, baseLinkProps), {
            onClick: onToggleSelected
        }) : product_row_objectSpreadProps(product_row_objectSpread({}, baseLinkProps), {
            onClick: onClickHandler,
            to: linkUrl
        });
    }, [
        product.name,
        linkUrl,
        isSelectingProducts,
        onToggleSelected,
        onClickHandler
    ]);
    var getShippingInfo = function() {
        if (product.priceSummary.includeShipping == null) return undefined;
        return product.priceSummary.includeShipping - (product.priceSummary.regular || 0);
    };
    var isSponsored = Boolean(product.sponsor);
    (0,react.useEffect)(function() {
        if (isSponsored) {
            (0,data_layer/* pushEvent */.A)("temp_view_sponsored_product_card", {
                productId: product.id
            });
        }
    }, [
        product.id,
        isSponsored
    ]);
    return /*#__PURE__*/ react.createElement(Tr, {
        selected: isSelected
    }, /*#__PURE__*/ react.createElement(NameTd, {
        sticky: stickyFirstColumn,
        scrolled: hasScrolled,
        sidebarOpen: isSidebarOpen
    }, /*#__PURE__*/ react.createElement(NameWrapper, null, isSelectingProducts && /*#__PURE__*/ react.createElement(CompareCheckbox, {
        selected: isSelected,
        onSelect: onSelect,
        onDeselect: onDeselect,
        "aria-label": product.name
    }), /*#__PURE__*/ react.createElement(NameLink, product_row_extends({}, linkProps), /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        offset: 0,
        placeholder: product_row_ImagePlaceholder
    }, /*#__PURE__*/ react.createElement(Image, {
        name: product.name,
        src: product.media && product.media.first || "",
        fallback: ((ref = product.category) === null || ref === void 0 ? void 0 : ref.logo) || undefined
    })), /*#__PURE__*/ react.createElement("div", null, product.sponsor && /*#__PURE__*/ react.createElement(sponsor_text/* SponsorText */.k, null), /*#__PURE__*/ react.createElement(ProductNameTable, null, highlightedName || product.name))))), /*#__PURE__*/ react.createElement(Td, product_row_extends({}, linkProps), /*#__PURE__*/ react.createElement(PriceDealContainer, null, product.priceSummary.regular ? /*#__PURE__*/ react.createElement(Price, {
        value: product.priceSummary.regular
    }) : /*#__PURE__*/ react.createElement("span", null, "\xa0"), ((ref1 = product.dealInfo) === null || ref1 === void 0 ? void 0 : ref1.dealPercentage) && ((ref2 = product.priceSummary) === null || ref2 === void 0 ? void 0 : ref2.regular) ? /*#__PURE__*/ react.createElement(CampaignBadgeWrapper, null, /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
        "data-testid": "DealsBadge",
        priceDrop: (ref3 = product.dealInfo) === null || ref3 === void 0 ? void 0 : ref3.dealPercentage,
        price: (ref4 = product.priceSummary) === null || ref4 === void 0 ? void 0 : ref4.regular,
        popoverUniqueId: product.id || 0
    })) : null), /*#__PURE__*/ react.createElement(shipping_label_ShippingLabel, {
        exclShipping: product.priceSummary.regular || 0,
        priceDisplay: price_list_types/* PriceDisplayEnum.PRICE */.wB.PRICE,
        shippingInfo: getShippingInfo(),
        compact: true
    })), /*#__PURE__*/ react.createElement(Td, product_row_extends({}, linkProps), /*#__PURE__*/ react.createElement(stock_status/* StockStatus */.B, {
        status: product.stockStatus || undefined
    })), /*#__PURE__*/ react.createElement(Td, product_row_extends({}, linkProps), /*#__PURE__*/ react.createElement(rating/* default */.Z, {
        rate: ((ref5 = product.aggregatedRating) === null || ref5 === void 0 ? void 0 : ref5.score) || product.userReviewSummary.rating,
        count: ((ref6 = product.aggregatedRating) === null || ref6 === void 0 ? void 0 : ref6.count) || product.userReviewSummary.count,
        singleStar: true,
        showRate: true,
        showCounter: true,
        countTranslation: RatingTranslationKey
    })), /*#__PURE__*/ react.createElement(Td, product_row_extends({}, linkProps), typeof ((ref7 = product.popularity) === null || ref7 === void 0 ? void 0 : ref7.inCategory) === "number" && /*#__PURE__*/ react.createElement(Center, null, /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "GREY",
        key: "categoryRank",
        text: (ref8 = product.popularity) === null || ref8 === void 0 ? void 0 : ref8.inCategory
    }))), propertyColumns.map(function(column, index) {
        return /*#__PURE__*/ react.createElement(PropertyColumnItem, {
            key: column.id,
            column: column,
            product: product,
            indicateNewColumn: indicateNewColumn === index + 5,
            linkProps: linkProps
        });
    }));
};
var ProductPropertyValue = function(param) {
    var product = param.product, column = param.column;
    // Some property columns are not actual properties, but we still treat them as such for the
    // most part. This handles how to render the values for those on a case-by-case basis.
    if (column.__typename === "ProductCollectionSimulatedPropertyColumn") {
        switch(column.id){
            case "brand":
                var ref;
                return /*#__PURE__*/ react.createElement("div", null, (ref = product.brand) === null || ref === void 0 ? void 0 : ref.name);
            case "deal_diff_percentage":
                var ref1, ref2, ref3, ref4;
                // eslint-disable-next-line no-case-declarations
                return (product === null || product === void 0 ? void 0 : (ref1 = product.dealInfo) === null || ref1 === void 0 ? void 0 : ref1.dealPercentage) && ((ref2 = product.priceSummary) === null || ref2 === void 0 ? void 0 : ref2.regular) ? /*#__PURE__*/ react.createElement(CampaignBadgeWrapper, null, /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
                    "data-testid": "DealsBadge",
                    priceDrop: (ref3 = product.dealInfo) === null || ref3 === void 0 ? void 0 : ref3.dealPercentage,
                    price: (ref4 = product.priceSummary) === null || ref4 === void 0 ? void 0 : ref4.regular,
                    popoverUniqueId: product.id || 0
                })) : null;
            case "days_since_indexing":
                return /*#__PURE__*/ react.createElement("div", null, product.indexingDate);
            default:
                return null;
        }
    }
    var property = getProductProperty(product, column.id);
    if (!property) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(PropertyContainer, null, /*#__PURE__*/ react.createElement(property_value_PropertyValue, {
        property: property
    }));
};
function getProductProperty(product, propertyId) {
    var ref, ref1;
    var productProperties = ((ref = product.properties) === null || ref === void 0 ? void 0 : ref.nodes) && Array.isArray((ref1 = product.properties) === null || ref1 === void 0 ? void 0 : ref1.nodes) ? product.properties.nodes : [];
    return productProperties.find(function(p) {
        return p.id === propertyId;
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/dropdown-down/index.js
var dropdown_down = __webpack_require__(7920);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/dropdown-up/index.js
var dropdown_up = __webpack_require__(58425);
// EXTERNAL MODULE: ./src/components/truncated/index.tsx
var truncated = __webpack_require__(16732);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-table/table-header.tsx
function table_header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function table_header_extends() {
    table_header_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return table_header_extends.apply(this, arguments);
}
function table_header_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            table_header_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function table_header_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function table_header_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        table_header_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function table_header_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = table_header_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function table_header_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var SORT_ICON_SIZE = 24;
var SORT_DIRECTION_SYMBOLS = {
    asc: /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, {
        size: SORT_ICON_SIZE
    }),
    desc: /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, {
        size: SORT_ICON_SIZE
    })
};
var SortHeader = function(param) {
    var name = param.name, sortKey = param.sortKey, currentSort = param.currentSort, sortDirection = param.sortDirection;
    var isSelected = sortKey === currentSort;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var queryParamDirection = sortDirection === "asc" ? "desc" : "asc";
    var queryParams = (0,product_collection_urls_dist.getSortedQuery)(table_header_objectSpreadProps(table_header_objectSpread({}, dist_default().parse(location.search.replace(/^\?/, ""))), {
        offset: undefined,
        sort: sortKey,
        direction: isSelected ? queryParamDirection : undefined
    }));
    return /*#__PURE__*/ react.createElement(ClickableHeader, {
        to: "".concat(location.pathname, "?").concat(dist_default().stringify(queryParams))
    }, /*#__PURE__*/ react.createElement(HeaderText, null, /*#__PURE__*/ react.createElement(truncated/* Truncated */.J, null, name), /*#__PURE__*/ react.createElement(SortIconContainer, {
        show: isSelected
    }, SORT_DIRECTION_SYMBOLS[isSelected ? sortDirection : "desc"])));
};
var TableHeader = function(_param) {
    var columns = _param.columns, indicateNewColumn = _param.indicateNewColumn, scrolled = _param.scrolled, props = table_header_objectWithoutProperties(_param, [
        "columns",
        "indicateNewColumn",
        "scrolled"
    ]);
    return /*#__PURE__*/ react.createElement("thead", null, /*#__PURE__*/ react.createElement(HeaderTr, null, columns.map(function(column, index) {
        return /*#__PURE__*/ react.createElement(TableHeaderColumn, table_header_extends({
            key: column.name
        }, props, {
            column: column,
            indicateNewColumn: indicateNewColumn === index,
            minWidth: index === 0 ? "300px" : undefined,
            scrolled: index === 0 && scrolled
        }));
    })));
};
var TableHeaderColumn = function(param) {
    var column = param.column, currentSort = param.currentSort, sortDirection = param.sortDirection, indicateNewColumn = param.indicateNewColumn, minWidth = param.minWidth, sticky = param.sticky, scrolled = param.scrolled, sidebarOpen = param.sidebarOpen;
    var name = column.name, sortKey = column.sortKey;
    return /*#__PURE__*/ react.createElement(Th, {
        canBeSorted: !!sortKey,
        indicateNewColumn: indicateNewColumn,
        "data-test": "ProductListColumnHeader",
        style: {
            minWidth: minWidth
        },
        sticky: sticky,
        scrolled: scrolled,
        sidebarOpen: sidebarOpen
    }, sortKey ? /*#__PURE__*/ react.createElement(SortHeader, table_header_extends({}, {
        sortKey: sortKey,
        name: name,
        currentSort: currentSort,
        sortDirection: sortDirection
    })) : /*#__PURE__*/ react.createElement(HeaderText, null, /*#__PURE__*/ react.createElement(truncated/* Truncated */.J, null, name)));
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-table/layout-table.tsx
function layout_table_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function layout_table_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function layout_table_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return layout_table_arrayLikeToArray(arr);
}
function layout_table_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function layout_table_extends() {
    layout_table_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return layout_table_extends.apply(this, arguments);
}
function layout_table_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function layout_table_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function layout_table_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function layout_table_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function layout_table_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            layout_table_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function layout_table_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function layout_table_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        layout_table_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function layout_table_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = layout_table_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function layout_table_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function layout_table_slicedToArray(arr, i) {
    return layout_table_arrayWithHoles(arr) || layout_table_iterableToArrayLimit(arr, i) || layout_table_unsupportedIterableToArray(arr, i) || layout_table_nonIterableRest();
}
function layout_table_toConsumableArray(arr) {
    return layout_table_arrayWithoutHoles(arr) || layout_table_iterableToArray(arr) || layout_table_unsupportedIterableToArray(arr) || layout_table_nonIterableSpread();
}
function layout_table_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return layout_table_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return layout_table_arrayLikeToArray(o, minLen);
}













var defaultColumns = [
    {
        translation: "product-list.name-column-heading",
        sortKey: "name"
    },
    {
        translation: "product-list.price-column-heading",
        sortKey: "price"
    },
    {
        translation: "product-list.stock-column-heading",
        sortKey: "property.in_stock"
    },
    {
        translation: "product-list.rating-column-heading",
        sortKey: "user_reviews"
    },
    {
        translation: "sort.popularity",
        sortKey: "popularity"
    }
];
var TableLayout = function(_param) {
    var products = _param.products, currentSort = _param.currentSort, sortDirection = _param.sortDirection, propertyColumns = _param.propertyColumns, productComparisonProps = layout_table_objectWithoutProperties(_param, [
        "products",
        "currentSort",
        "sortDirection",
        "propertyColumns"
    ]);
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var hasSponsoredProduct = products.some(function(param) {
        var sponsor = param.sponsor;
        return !!sponsor;
    });
    var columns = (0,react.useMemo)(function() {
        var getTranslation = function(translation) {
            var translationForCommon = t("common", translation);
            if (translationForCommon !== translation) {
                return translationForCommon;
            }
            return t("category", translation);
        };
        return layout_table_toConsumableArray(defaultColumns.map(function(column) {
            return layout_table_objectSpreadProps(layout_table_objectSpread({}, column), {
                name: getTranslation(column.translation)
            });
        })).concat(layout_table_toConsumableArray(propertyColumns.map(function(column) {
            return {
                name: (0,property_columns/* getPropertyColumnName */.t)(column, t),
                sortKey: (0,properties/* getSortKeyForProperty */.g)(column.id)
            };
        })));
    }, [
        propertyColumns,
        t
    ]);
    var indicateNewColumn = useNewColumnIndication(columns.length).indicateNewColumn;
    var ref1 = layout_table_slicedToArray((0,react.useState)(false), 2), scrolled = ref1[0], setScrolled = ref1[1];
    (0,react.useEffect)(function() {
        var checkScrolled = function() {
            setScrolled(window.scrollX > 0);
        };
        window.addEventListener("scroll", checkScrolled, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", checkScrolled);
        };
    }, []);
    var tab = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.tab;
    });
    var isSidebarOpen = tab != null && tab !== "none";
    var table = /*#__PURE__*/ react.createElement(Table, {
        scrollable: propertyColumns.length > DEFAULT_PROPERTY_COLUMN_COUNT,
        cellSpacing: "0",
        "data-test": "ProductLayoutTable"
    }, /*#__PURE__*/ react.createElement(TableHeader, {
        currentSort: currentSort,
        sortDirection: sortDirection,
        columns: columns,
        indicateNewColumn: indicateNewColumn,
        sticky: true,
        scrolled: scrolled,
        sidebarOpen: isSidebarOpen
    }), /*#__PURE__*/ react.createElement("tbody", null, /*#__PURE__*/ react.createElement(ContainerAdsTable, {
        numOfColumns: 4 + propertyColumns.length,
        showAds: !hasSponsoredProduct
    }, products.map(function(product, index) {
        return /*#__PURE__*/ react.createElement(ProductRow, layout_table_extends({
            key: product.id,
            product: product,
            propertyColumns: propertyColumns,
            indicateNewColumn: indicateNewColumn,
            highlightedName: product.highlight ? /*#__PURE__*/ react.createElement(highlighted_search_result/* default */.Z, null, product.highlight) : undefined,
            onClick: function(link) {
                if (product.sponsor) {
                    var ref;
                    (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking_tracking/* InternalNavigationScope.SPONSORED_PRODUCT_CARD */.U.SPONSORED_PRODUCT_CARD,
                        nextPage: product.pathName,
                        index: index
                    });
                    (ref = window.pjsession) === null || ref === void 0 ? void 0 : ref.track("sponsored_product", {
                        clientId: "1331",
                        market: market.code.toUpperCase(),
                        event_data: {
                            product_id: String(product.id)
                        }
                    });
                } else {
                    (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking_tracking/* InternalNavigationScope.TABLE_LAYOUT_PRODUCT_CARD */.U.TABLE_LAYOUT_PRODUCT_CARD,
                        nextPage: link,
                        index: index
                    });
                }
            },
            stickyFirstColumn: true,
            hasScrolled: scrolled,
            isSidebarOpen: isSidebarOpen
        }, productComparisonProps));
    }))));
    return /*#__PURE__*/ react.createElement(AdPositioningContext, null, table);
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/layout-table/index.tsx


// EXTERNAL MODULE: ./src/areas/product-collection/components/products/layout-compact-list/index.tsx + 2 modules
var layout_compact_list = __webpack_require__(64983);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/layout-grid/index.tsx + 16 modules
var layout_grid = __webpack_require__(7830);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/layout-list/index.tsx + 2 modules
var layout_list = __webpack_require__(77951);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/components/scroll/index.ts + 2 modules
var components_scroll = __webpack_require__(40763);
// EXTERNAL MODULE: ./src/areas/category/components/category-information/index.tsx + 1 modules
var category_information = __webpack_require__(90912);
;// CONCATENATED MODULE: ./src/components/layout-buttons/constants.ts
var ICON_SIZE = 40;

// EXTERNAL MODULE: ./src/areas/product-collection/components/productOffersContainer/pagination.tsx
var pagination = __webpack_require__(95779);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(32741);
// EXTERNAL MODULE: ./src/areas/product-collection/components/productOffersContainer/styles.ts
var styles = __webpack_require__(66646);
// EXTERNAL MODULE: ./src/areas/product-collection/filter-tracking.ts
var filter_tracking = __webpack_require__(14367);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(56853);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(83830);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js
var throttle = __webpack_require__(38209);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/productOffersContainer/search-input.tsx
function search_input_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_input_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function search_input_extends() {
    search_input_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return search_input_extends.apply(this, arguments);
}
function search_input_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function search_input_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_input_slicedToArray(arr, i) {
    return search_input_arrayWithHoles(arr) || search_input_iterableToArrayLimit(arr, i) || search_input_unsupportedIterableToArray(arr, i) || search_input_nonIterableRest();
}
function search_input_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_input_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_input_arrayLikeToArray(o, minLen);
}













var debouncedDispatch = debounce_default()(function(query, dispatch) {
    dispatch({
        type: "FILTER_NAME_SEARCH_UPDATE",
        query: query
    });
}, 800);
var getQueryFromFilters = function(filters) {
    var nameSearchFilter = filters === null || filters === void 0 ? void 0 : filters.find(function(f) {
        return "type" in f && f.type === "name-search";
    });
    return nameSearchFilter ? nameSearchFilter.query : "";
};
var useSearchQuery = function() {
    var ref = (0,react.useContext)(context/* default */.Z), filters = ref.currentRouteState.filters;
    var ref1 = search_input_slicedToArray((0,react.useState)(getQueryFromFilters(filters)), 2), query = ref1[0], setQuery = ref1[1];
    (0,react.useEffect)(function() {
        return setQuery(getQueryFromFilters(filters));
    }, [
        setQuery,
        filters
    ]);
    return [
        query,
        setQuery
    ];
};
var productCollectionFilterContextValue = {
    filterLayout: "product-name-search"
};
var SearchInput = function(param) {
    var alwaysOpen = param.alwaysOpen, inputWidth = param.inputWidth, ref = param.inputRef, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var dispatch = (0,react.useContext)(context/* default */.Z).dispatch;
    var ref1 = search_input_slicedToArray(useSearchQuery(), 2), query = ref1[0], setQuery = ref1[1];
    var trackFilterSelect = (0,filter_tracking/* useTrackFilterSelect */.o$)({
        type: "product-name-search",
        title: "product-name-search",
        property: "product-name-search"
    }).trackFilterSelect;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var trackFilterSelectWithThrottle = (0,react.useCallback)(// Only send an event every 4s.
    throttle_default()(trackFilterSelect, 4000), [
        trackFilterSelect
    ]);
    var hasQuery = query.length > 0;
    var ref2 = search_input_slicedToArray((0,react.useState)(false), 2), focused = ref2[0], setFocused = ref2[1];
    var isFocused = focused || alwaysOpen;
    var onFocus = (0,react.useCallback)(function() {
        return setFocused(true);
    }, [
        setFocused
    ]);
    var onBlur = (0,react.useCallback)(function() {
        return setFocused(false);
    }, [
        setFocused
    ]);
    var inputRef = ref !== null && ref !== void 0 ? ref : /*#__PURE__*/ (0,react.createRef)();
    var onOpen = (0,react.useCallback)(function() {
        var ref;
        return (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        inputRef
    ]);
    var onUpdate = (0,react.useCallback)(function(value) {
        setQuery(value);
        if (value.length === 0 || value.length > 2) {
            trackFilterSelectWithThrottle({
                value: value
            });
            debouncedDispatch(value, dispatch);
        }
    }, [
        dispatch,
        setQuery,
        trackFilterSelectWithThrottle
    ]);
    var onInputChange = (0,react.useCallback)(function(e) {
        return onUpdate(e.target.value);
    }, [
        onUpdate
    ]);
    var onClear = (0,react.useCallback)(function() {
        if (inputRef.current) {
            inputRef.current.value = "";
            inputRef.current.focus();
        }
        onUpdate("");
    }, [
        onUpdate,
        inputRef
    ]);
    return /*#__PURE__*/ react.createElement(styles/* SearchInput */.Mj, {
        iconSize: ICON_SIZE,
        "data-test": "SearchInput",
        className: className
    }, /*#__PURE__*/ react.createElement(styles/* SearchTextWrapper */._U, {
        expanded: isFocused || hasQuery,
        iconSize: ICON_SIZE,
        inputWidth: inputWidth
    }, /*#__PURE__*/ react.createElement(inputs/* TextInput */.oi, {
        name: "query",
        variant: "rounded",
        value: query,
        inputRef: inputRef,
        placeholder: t("category", "product-search.placeholder"),
        onChange: onInputChange,
        onBlur: onBlur,
        onFocus: onFocus,
        className: "search-input-text"
    })), !isFocused && !hasQuery && /*#__PURE__*/ react.createElement(styles/* SearchInputIcon */.r7, {
        "data-test": "SearchInputIcon",
        positionAbsolute: true,
        onClick: onOpen,
        iconSize: ICON_SIZE
    }, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Left */.Nm.Left,
        title: t("category", "product-search.placeholder")
    }, /*#__PURE__*/ react.createElement(magnifier/* IconMagnifier */.j, null))), hasQuery && /*#__PURE__*/ react.createElement(styles/* SearchInputIcon */.r7, {
        "data-test": "SearchInputClearIcon",
        positionAbsolute: true,
        onClick: onClear,
        iconSize: ICON_SIZE
    }, /*#__PURE__*/ react.createElement(icon_close.IconClose, {
        size: 16
    })));
};
var SearchInputHOC = function(props) {
    return /*#__PURE__*/ react.createElement(filter_tracking/* ProductCollectionFilterContext.Provider */.Yd.Provider, {
        value: productCollectionFilterContextValue
    }, /*#__PURE__*/ react.createElement(SearchInput, search_input_extends({}, props)));
};
/* harmony default export */ var search_input = (SearchInputHOC);

// EXTERNAL MODULE: ./src/components/layout-buttons/index.tsx + 2 modules
var layout_buttons = __webpack_require__(42081);
// EXTERNAL MODULE: ./src/components/products-header/index.tsx + 4 modules
var products_header = __webpack_require__(63536);
// EXTERNAL MODULE: ./src/globals/helpers/format-number.ts
var format_number = __webpack_require__(4398);
// EXTERNAL MODULE: ./src/areas/product-collection/components/productOffersContainer/overlay-sort.tsx
var overlay_sort = __webpack_require__(41471);
// EXTERNAL MODULE: ./src/areas/product-collection/components/toggle-button/index.tsx + 2 modules
var toggle_button = __webpack_require__(97908);
// EXTERNAL MODULE: ./src/areas/product-collection/components/productOffersContainer/sort-options.tsx
var sort_options = __webpack_require__(31618);
// EXTERNAL MODULE: ./src/components/no-results/index.tsx + 1 modules
var no_results = __webpack_require__(2836);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/sort/index.js
var sort = __webpack_require__(66131);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/filter/index.js
var filter = __webpack_require__(38077);
;// CONCATENATED MODULE: ./src/areas/product-collection/filter-context.tsx

var FilterContext = /*#__PURE__*/ react.createContext({});

// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./src/globals/tracking/filter.ts
var tracking_filter = __webpack_require__(15301);
// EXTERNAL MODULE: ./src/components/text-link/index.tsx + 1 modules
var text_link = __webpack_require__(30943);
// EXTERNAL MODULE: ./src/hooks/use-feedback.ts
var use_feedback = __webpack_require__(19265);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/productOffersContainer/index.tsx
function productOffersContainer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function productOffersContainer_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function productOffersContainer_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function productOffersContainer_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function productOffersContainer_slicedToArray(arr, i) {
    return productOffersContainer_arrayWithHoles(arr) || productOffersContainer_iterableToArrayLimit(arr, i) || productOffersContainer_unsupportedIterableToArray(arr, i) || productOffersContainer_nonIterableRest();
}
function productOffersContainer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return productOffersContainer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return productOffersContainer_arrayLikeToArray(o, minLen);
}





























var ProductOffersContainer = function(param) {
    var productCollectionName = param.productCollectionName, pageInfo = param.pageInfo, productsCount = param.productsCount, availableSorts = param.availableSorts, availableSortsTranslations = param.availableSortsTranslations, currentSort = param.currentSort, onLayoutChange = param.onLayoutChange, layout = param.layout, storeCount = param.storeCount, legalText = param.legalText, children = param.children, maxHitsAmount = param.maxHitsAmount, compareProductsToggle = param.compareProductsToggle, supportedViewModes = param.supportedViewModes;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var dispatch = (0,react.useContext)(context/* default */.Z).dispatch;
    var location = (0,react_router/* useLocation */.TH)();
    var ref1 = productOffersContainer_slicedToArray((0,react.useState)(false), 2), mobileSortOpen = ref1[0], setMobileSortOpen = ref1[1];
    var searchInputRef = /*#__PURE__*/ (0,react.createRef)();
    var ref2 = productOffersContainer_slicedToArray(useSearchQuery(), 1), query = ref2[0];
    var ref3 = productOffersContainer_slicedToArray((0,react.useState)(query !== ""), 2), showSearch = ref3[0], setShowSearch = ref3[1];
    var loadFeedback = (0,use_feedback/* useFeedback */.Z)().loadFeedback;
    (0,react.useEffect)(function() {
        return setShowSearch(query !== "" || showSearch);
    }, [
        query,
        showSearch
    ]);
    var sortClick = (0,react.useCallback)(function(sort, currentSortName) {
        (0,tracking_filter/* trackSortingSelectEvent */.Em)({
            value: sort,
            property: currentSortName,
            scope: tracking_filter/* PageScope.CATEGORY */.VN.CATEGORY,
            category: productCollectionName
        });
        dispatch({
            type: "SORT_CHANGE",
            sort: sort,
            location: location
        });
    }, [
        productCollectionName,
        dispatch,
        location
    ]);
    var paginationClick = (0,react.useCallback)(function(clickedOffset) {
        dispatch({
            type: "PAGINATION",
            clickedOffset: clickedOffset,
            location: location
        });
    }, [
        dispatch,
        location
    ]);
    var onClickSearch = (0,react.useCallback)(function() {
        var visible = query !== "" || !showSearch;
        setShowSearch(visible);
        if (visible && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [
        setShowSearch,
        showSearch,
        query,
        searchInputRef
    ]);
    var headerElement = (0,react.useMemo)(function() {
        return /*#__PURE__*/ react.createElement(products_header/* ProductsHeader */.i, {
            dataBotify: "ProductCollectionProductCount",
            displayOptions: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, compareProductsToggle), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(search_input, null)), /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(styles/* SearchInputIcon */.r7, {
                "data-test": "SearchInputIcon",
                onClick: onClickSearch,
                iconSize: ICON_SIZE
            }, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
                placement: ui/* Direction.Left */.Nm.Left,
                title: t("category", "product-search.placeholder")
            }, /*#__PURE__*/ react.createElement(magnifier/* IconMagnifier */.j, null)))), /*#__PURE__*/ react.createElement(layout_buttons/* default */.Z, {
                layoutModes: supportedViewModes,
                activeLayout: layout,
                setLayout: onLayoutChange
            })),
            sortOptions: /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(sort_options/* default */.Z, {
                onClick: sortClick,
                currentSort: currentSort,
                availableSorts: availableSorts,
                availableSortsTranslations: availableSortsTranslations
            })),
            title: t("category", "products.count", {
                n: productsCount,
                count: (0,format_number/* default */.Z)(productsCount, market.code)
            })
        }, /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(hideable.Hideable, {
            collapse: ui/* Axis.Y */.RD.Y,
            visible: showSearch,
            renderWhenHidden: true
        }, /*#__PURE__*/ react.createElement(search_input, {
            alwaysOpen: true,
            inputWidth: "100%",
            inputRef: searchInputRef
        }))));
    }, [
        availableSorts,
        availableSortsTranslations,
        compareProductsToggle,
        currentSort,
        layout,
        market.code,
        onClickSearch,
        onLayoutChange,
        productsCount,
        searchInputRef,
        showSearch,
        supportedViewModes,
        t,
        sortClick
    ]);
    var footerElement = (0,react.useMemo)(function() {
        return /*#__PURE__*/ react.createElement(components_scroll/* ScrollLink */.Rv, {
            to: "Products"
        }, /*#__PURE__*/ react.createElement(pagination/* default */.Z, {
            pageInfo: pageInfo,
            total: Math.min(productsCount, maxHitsAmount),
            onClick: paginationClick
        }));
    }, [
        pageInfo,
        productsCount,
        maxHitsAmount,
        paginationClick
    ]);
    var toggleMobileSort = (0,react.useCallback)(function() {
        setMobileSortOpen(!mobileSortOpen);
    }, [
        mobileSortOpen
    ]);
    var onClose = (0,react.useCallback)(function() {
        setMobileSortOpen(false);
    }, []);
    var showTooManyHitsNotice = productsCount > maxHitsAmount && (pageInfo.offset || 0) + (pageInfo.limit || 0) >= maxHitsAmount;
    var ref4 = (0,react.useContext)(FilterContext), mobileFilterOpen = ref4.mobileFilterOpen, setMobileFilterOpen = ref4.setMobileFilterOpen, count = ref4.count;
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "Products"
    }, /*#__PURE__*/ react.createElement(styles/* Wrapper */.im, null, mobileSortOpen && /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(overlay_sort/* default */.Z, {
        currentSort: currentSort,
        onClose: onClose,
        sortOptions: availableSorts,
        sortTranslations: availableSortsTranslations,
        productCollectionName: productCollectionName
    }))), /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, headerElement, productsCount === 0 && /*#__PURE__*/ react.createElement(no_results/* NoResults */.X, {
        title: t("category", "product-collection.no-results-title")
    }), productsCount > 0 && /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(styles/* MobileWrapper */.nv, null, /*#__PURE__*/ react.createElement(styles/* StyledFilterButton */.EP, {
        count: count,
        icon: /*#__PURE__*/ react.createElement(filter/* IconFilter */.w, {
            size: 18
        }),
        onToggle: function() {
            return setMobileFilterOpen(!mobileFilterOpen);
        },
        title: t("filter", "filter.title")
    }), /*#__PURE__*/ react.createElement(styles/* CompareSortWrapper */.r_, null, compareProductsToggle, /*#__PURE__*/ react.createElement(toggle_button/* ToggleButton */.C, {
        variant: toggle_button/* VariantEnum.OUTLINED */.y.OUTLINED,
        icon: /*#__PURE__*/ react.createElement(sort/* IconSort */.M, {
            size: 24
        }),
        onToggle: toggleMobileSort,
        truncate: true,
        "data-test": "SortOrderButton"
    })))), children, showTooManyHitsNotice && /*#__PURE__*/ react.createElement(styles/* Notice */.qX, null, t("category", "product-collection.too-many-hits-notice", {
        maxHitsAmount: maxHitsAmount
    })), footerElement, /*#__PURE__*/ react.createElement(styles/* Feedback */.x2, null, /*#__PURE__*/ react.createElement(text_link/* TextLink */.h, {
        onClick: function() {
            return loadFeedback();
        }
    }, t("feedback", "dialog.prompt-button"))), legalText && /*#__PURE__*/ react.createElement(category_information/* default */.Z, {
        statistics: typeof storeCount === "number" ? {
            productsCount: productsCount,
            storesCount: storeCount
        } : undefined
    }))));
};
/* harmony default export */ var productOffersContainer = (ProductOffersContainer);

// EXTERNAL MODULE: ./src/components/compare-products-toggle/index.tsx + 1 modules
var compare_products_toggle = __webpack_require__(25687);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/styles.ts
function products_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function products_styles_templateObject() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  padding-bottom: ",
        ";\n"
    ]);
    products_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function products_styles_templateObject1() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 0 1 auto;\n"
    ]);
    products_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function products_styles_templateObject2() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  margin: auto;\n"
    ]);
    products_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var ProductsWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductsWrapper",
    componentId: "sc-0-0"
})(products_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CompareProductsToggle = (0,styled_components_browser_esm["default"])(compare_products_toggle/* default */.Z).withConfig({
    displayName: "CompareProductsToggle",
    componentId: "sc-0-1"
})(products_styles_templateObject1());
var AdPlacementAligned = (0,styled_components_browser_esm["default"])(dist_module/* AdPlacement */.ZD).withConfig({
    displayName: "AdPlacementAligned",
    componentId: "sc-0-2"
})(products_styles_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/tracking.ts

var trackProductCollectionLayoutChangeClick = function(from, to) {
    var fromAndToLayout = "".concat(from, " -> ").concat(to);
    (0,data_layer/* pushEvent */.A)("ProductCollectionLayoutChangeClick", {
        fromAndToLayout: fromAndToLayout
    });
    (0,data_layer/* pushEvent */.A)("LayoutChange", {
        from: from,
        to: to
    });
};

// EXTERNAL MODULE: ./src/contexts/wide-context.tsx
var wide_context = __webpack_require__(96192);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/products/index.tsx
function products_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function products_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return products_arrayLikeToArray(arr);
}
function products_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function products_extends() {
    products_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return products_extends.apply(this, arguments);
}
function products_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function products_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function products_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function products_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function products_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        products_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function products_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = products_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function products_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function products_toConsumableArray(arr) {
    return products_arrayWithoutHoles(arr) || products_iterableToArray(arr) || products_unsupportedIterableToArray(arr) || products_nonIterableSpread();
}
function products_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return products_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return products_arrayLikeToArray(o, minLen);
}




















var Products = function(_param) {
    var products = _param.products, currentSort = _param.currentSort, sortDirection = _param.sortDirection, propertyColumns = _param.propertyColumns, availableSorts = _param.availableSorts, id = _param.id, activeLayout = _param.activeLayout, expert = _param.expert, productCollection = _param.productCollection, preferredViewMode = _param.preferredViewMode, productContainerProps = products_objectWithoutProperties(_param, [
        "products",
        "currentSort",
        "sortDirection",
        "propertyColumns",
        "availableSorts",
        "id",
        "activeLayout",
        "expert",
        "productCollection",
        "preferredViewMode"
    ]);
    var ref;
    var ref1 = (0,react.useContext)(viewport/* ViewportContext */.R), isMobile = ref1.isMobile, isTablet = ref1.isTablet;
    var setIsWide = (0,react.useContext)(wide_context/* WideContext */.Y).setIsWide;
    var ref2 = (0,app_context/* useAppContext */.bp)(), linkTo = ref2.linkTo, t = ref2.t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,compare_products_selection/* useCompareProductsSelection */.C)(), isSelectingProducts = ref3.isSelectingProducts, selectedProducts = ref3.selectedProducts, startProductSelection = ref3.startProductSelection, abortProductSelection = ref3.abortProductSelection, selectProduct = ref3.selectProduct, deselectProduct = ref3.deselectProduct;
    var abortProductSelectionFromCompareButton = (0,react.useCallback)(function() {
        return abortProductSelection();
    }, [
        abortProductSelection
    ]);
    var abortProductSelectionFromBasket = (0,react.useCallback)(function() {
        return abortProductSelection();
    }, [
        abortProductSelection
    ]);
    var selectProductById = (0,react.useCallback)(function(productId) {
        var selectedProduct = products.find(function(p) {
            return p.id === productId;
        });
        if (selectedProduct) {
            selectProduct(selectedProduct);
        }
    }, [
        products,
        selectProduct
    ]);
    var deselectProductById = (0,react.useCallback)(function(productId) {
        var deselectedProduct = products.find(function(p) {
            return p.id === productId;
        });
        if (deselectedProduct) {
            deselectProduct(deselectedProduct);
        }
    }, [
        products,
        deselectProduct
    ]);
    var availableSortOptions = products_toConsumableArray(availableSorts).concat("property.in_stock").concat(propertyColumns.map(function(column) {
        return column.id;
    }).map(properties/* getSortKeyForProperty */.g));
    var availableSortOptionsTranslationTable = propertyColumns.reduce(function(prev, item) {
        return products_objectSpreadProps(products_objectSpread({}, prev), products_defineProperty({}, item.id, (0,property_columns/* getPropertyColumnName */.t)(item, t)));
    }, {});
    /**
   * Select a suitable category to use as the "comparison category", ie. the context within which
   * you're comparing products.
   */ var categories = productCollection.categories, categoryPath = productCollection.categoryPath;
    var comparisonCategory = (categories === null || categories === void 0 ? void 0 : categories.length) === 1 ? categories[0] : categoryPath[categoryPath.length - 1];
    var showTitle = !(isMobile || isTablet);
    var compareProductsToggle = (0,react.useMemo)(function() {
        return /*#__PURE__*/ react.createElement(CompareProductsToggle, {
            active: isSelectingProducts,
            activate: startProductSelection,
            deactivate: abortProductSelectionFromCompareButton,
            showTitle: showTitle
        });
    }, [
        isSelectingProducts,
        startProductSelection,
        abortProductSelectionFromCompareButton,
        showTitle
    ]);
    var productComparisonProps = {
        isSelectingProducts: isSelectingProducts,
        selectedProducts: selectedProducts,
        selectProductById: selectProductById,
        deselectProductById: deselectProductById
    };
    var supportedViewModes = [
        types/* LayoutMode.GRID */.X.GRID,
        types/* LayoutMode.LIST */.X.LIST
    ].concat(products_toConsumableArray(isMobile || isTablet ? [
        types/* LayoutMode.COMPACT_LIST */.X.COMPACT_LIST
    ] : [
        types/* LayoutMode.TABLE */.X.TABLE
    ]));
    var hasExpertContent = expert && ((ref = productContainerProps.pageInfo) === null || ref === void 0 ? void 0 : ref.offset) === 0;
    var tableView = isMobile || isTablet ? /*#__PURE__*/ react.createElement(layout_compact_list/* CompactListLayout */.u, products_extends({
        onClick: tracking/* trackProductCollectionProductClick */.kQ,
        products: products
    }, productComparisonProps)) : /*#__PURE__*/ react.createElement(TableLayout, products_extends({
        propertyColumns: propertyColumns
    }, {
        products: products,
        currentSort: currentSort,
        sortDirection: sortDirection
    }, productComparisonProps));
    /**
   * Tracks the layout change
   * Sets the new layout
   * @param newLayout LayoutMode
   */ var changeLayout = function(newLayout) {
        var convertLayoutToNonMobile = function(layout) {
            return layout === types/* LayoutMode.COMPACT_LIST */.X.COMPACT_LIST ? types/* LayoutMode.TABLE */.X.TABLE : layout;
        };
        trackProductCollectionLayoutChangeClick(convertLayoutToNonMobile(activeLayout), convertLayoutToNonMobile(newLayout));
        dispatch((0,actions/* setProductCollectionLayout */.l2)(newLayout));
    };
    (0,react.useEffect)(function() {
        setIsWide(activeLayout === types/* LayoutMode.TABLE */.X.TABLE);
        return function() {
            setIsWide(false);
        };
    }, [
        activeLayout,
        setIsWide
    ]);
    return /*#__PURE__*/ react.createElement(ProductsWrapper, null, /*#__PURE__*/ react.createElement(productOffersContainer, products_extends({}, products_objectSpreadProps(products_objectSpread({}, productContainerProps), {
        id: id,
        currentSort: currentSort
    }), {
        productCollectionName: productCollection.name,
        layout: activeLayout,
        onLayoutChange: changeLayout,
        compareProductsToggle: compareProductsToggle,
        availableSorts: availableSortOptions,
        availableSortsTranslations: availableSortOptionsTranslationTable,
        supportedViewModes: supportedViewModes
    }), productContainerProps.productsCount > 0 && activeLayout === types/* LayoutMode.GRID */.X.GRID && /*#__PURE__*/ react.createElement(layout_grid/* GridLayout */.M, products_extends({
        expert: hasExpertContent ? expert : null,
        onClick: tracking/* trackProductCollectionProductClick */.kQ,
        products: products
    }, productComparisonProps)), productContainerProps.productsCount > 0 && (activeLayout === types/* LayoutMode.TABLE */.X.TABLE || activeLayout === types/* LayoutMode.COMPACT_LIST */.X.COMPACT_LIST) && tableView, productContainerProps.productsCount > 0 && activeLayout === types/* LayoutMode.LIST */.X.LIST && /*#__PURE__*/ react.createElement(layout_list/* ListLayout */.P, products_extends({
        onClick: tracking/* trackProductCollectionProductClick */.kQ,
        products: products
    }, productComparisonProps))), /*#__PURE__*/ react.createElement("aside", {
        "data-testid": "bottom-ads"
    }, /*#__PURE__*/ react.createElement(AdPlacementAligned, {
        format: "panorama_2_wde",
        triggerPoint: 0
    }), /*#__PURE__*/ react.createElement(AdPlacementAligned, {
        format: "panorama_3"
    })), isSelectingProducts && /*#__PURE__*/ react.createElement(compare_products_basket/* default */.Z, {
        products: selectedProducts,
        compareUrl: selectedProducts.length > 1 ? linkTo("productCompare", {
            category: comparisonCategory,
            products: selectedProducts
        }) : undefined,
        onEmpty: abortProductSelectionFromBasket,
        onProductDelete: deselectProductById
    }));
};
/* harmony default export */ var products = (Products);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(10422);
// EXTERNAL MODULE: ./src/components/secondary-search-field/index.tsx
var secondary_search_field = __webpack_require__(10215);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/filter/global-property-search.ts
function global_property_search_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function global_property_search_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function global_property_search_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function global_property_search_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function global_property_search_slicedToArray(arr, i) {
    return global_property_search_arrayWithHoles(arr) || global_property_search_iterableToArrayLimit(arr, i) || global_property_search_unsupportedIterableToArray(arr, i) || global_property_search_nonIterableRest();
}
function global_property_search_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return global_property_search_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return global_property_search_arrayLikeToArray(o, minLen);
}




var SEARCH_THROTTLE = 500;
var debouncedSearch = debounce_default()(function(query, dispatch) {
    return dispatch({
        type: "GLOBAL_AGGREGATION_SEARCH",
        globalPropertySearch: query.length > 1 ? query : ""
    });
}, SEARCH_THROTTLE);
var useGlobalPropertySearch = function() {
    var dispatchAggregationAction = (0,react.useContext)(context/* default */.Z).dispatchAggregationAction;
    var market = (0,react.useContext)(app_context/* AppContext */.Il).market;
    var ref = global_property_search_slicedToArray((0,react.useState)(""), 2), filterSearchQuery = ref[0], setFilterSearchQuery = ref[1];
    var locale = market.locale.replace("_", "-");
    var isSearching = !!filterSearchQuery;
    var onSecondarySearchFieldChange = function(query) {
        setFilterSearchQuery(query || "");
        debouncedSearch(query || "", dispatchAggregationAction);
    };
    var filterByPropertySearch = (0,react.useCallback)(function(section) {
        var ref;
        if (!isSearching) {
            return true;
        }
        if (section.__typename === "ListSection" && (section === null || section === void 0 ? void 0 : (ref = section.items) === null || ref === void 0 ? void 0 : ref.length)) {
            return true;
        }
        var matchTitle = section.title.toLocaleLowerCase(locale).includes(filterSearchQuery === null || filterSearchQuery === void 0 ? void 0 : filterSearchQuery.toLocaleLowerCase(locale));
        return matchTitle;
    }, [
        filterSearchQuery,
        locale,
        isSearching
    ]);
    var hasSectionMatchingFilter = (0,react.useCallback)(function(group) {
        return group.sections.some(filterByPropertySearch);
    }, [
        filterByPropertySearch
    ]);
    return {
        isSearching: isSearching,
        filterSearchQuery: filterSearchQuery,
        filterByPropertySearch: filterByPropertySearch,
        hasSectionMatchingFilter: hasSectionMatchingFilter,
        onSecondarySearchFieldChange: onSecondarySearchFieldChange
    };
};

// EXTERNAL MODULE: ./src/areas/sidebar/constants.ts
var constants = __webpack_require__(90081);
// EXTERNAL MODULE: ./src/areas/product-collection/constants/index.ts
var product_collection_constants = __webpack_require__(15169);
// EXTERNAL MODULE: ./src/components/filter-overlay/constants.ts
var filter_overlay_constants = __webpack_require__(55586);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/filter/styles.tsx
function filter_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function filter_styles_templateObject() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n    margin-bottom: 0;\n  "
    ]);
    filter_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function filter_styles_templateObject1() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    filter_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function filter_styles_templateObject2() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  min-height: 100%;\n  font-size: 12px;\n"
    ]);
    filter_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function filter_styles_templateObject3() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin: 0;\n  padding: ",
        ";\n  padding-bottom: 0;\n"
    ]);
    filter_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function filter_styles_templateObject4() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n"
    ]);
    filter_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function filter_styles_templateObject5() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  list-style: none;\n"
    ]);
    filter_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function filter_styles_templateObject6() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"
    ]);
    filter_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function filter_styles_templateObject7() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  border-radius: ",
        ";\n  background: ",
        ";\n  padding: ",
        " ",
        ";\n  margin: ",
        " 0;\n  text-align: center;\n"
    ]);
    filter_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function filter_styles_templateObject8() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    filter_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function filter_styles_templateObject9() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  list-style: none;\n  width: 100%;\n"
    ]);
    filter_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  padding-bottom: ",
        ";\n  /* @TODO: No padding on SidebarContent? */\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  min-width: 0;\n  flex: 1 1 0;\n  background: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: ",
        ";\n  overflow-x: hidden;\n  overflow-y: scroll; /* has to be scroll, not auto */\n  -webkit-overflow-scrolling: touch;\n  /* Makes sure no content is hidden behind the \"apply filter\" area */\n  ::after {\n    content: '';\n    display: block;\n    height: ",
        "px;\n  }\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 0;\n  z-index: 1;\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  width: 100%;\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = filter_styles_taggedTemplateLiteral([
        ""
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}






var styles_Wrapper = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(filter_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(filter_styles_templateObject()));
var Filter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Filter",
    componentId: "sc-0-1"
})(filter_styles_templateObject2(), base/* colors.backgroundDarkGray */.O9.backgroundDarkGray);
var FilterTitle = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "FilterTitle",
    componentId: "sc-0-2"
})(filter_styles_templateObject3(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var FilterSearchWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FilterSearchWrapper",
    componentId: "sc-0-3"
})(filter_styles_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Group = styled_components_browser_esm["default"].li.withConfig({
    displayName: "Group",
    componentId: "sc-0-4"
})(filter_styles_templateObject5());
var GroupTitle = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "GroupTitle",
    componentId: "sc-0-5"
})(filter_styles_templateObject6(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal);
var NoContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NoContent",
    componentId: "sc-0-6"
})(filter_styles_templateObject7(), base/* layout.borderRadius */.bK.borderRadius, function(p) {
    return p.theme.bg.secondary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var SectionSeparator = styled_components_browser_esm["default"].li.attrs({
    role: "presentation"
}).withConfig({
    displayName: "SectionSeparator",
    componentId: "sc-0-7"
})(filter_styles_templateObject8(), base/* colors.borderLightGray */.O9.borderLightGray);
var SectionList = (0,styled_components_browser_esm["default"])(variants.Column).attrs({
    styledComponentProps: {
        as: "ul"
    },
    separator: /*#__PURE__*/ react.createElement(SectionSeparator, null)
}).withConfig({
    displayName: "SectionList",
    componentId: "sc-0-8"
})(filter_styles_templateObject9());
var SectionListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "SectionListItem",
    componentId: "sc-0-9"
})(styles_templateObject10(), function(p) {
    return p.noPadding ? "0" : base/* layout.measurements.spacing100 */.bK.measurements.spacing100;
});
var MobileFilterDialog = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MobileFilterDialog",
    componentId: "sc-0-10"
})(styles_templateObject11(), function(p) {
    return p.theme.bg.primary;
}, zindex/* zindex.menu.filter */.Y.menu.filter, filter_overlay_constants/* applyFilterAreaHeight */.e);
var MobileFilterHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MobileFilterHeader",
    componentId: "sc-0-11"
})(styles_templateObject12());
var FilterSectionButtonList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FilterSectionButtonList",
    componentId: "sc-0-12"
})(styles_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var MobileSectionSeparator = (0,styled_components_browser_esm["default"])(SectionSeparator).attrs({
    as: "div"
}).withConfig({
    displayName: "MobileSectionSeparator",
    componentId: "sc-0-13"
})(styles_templateObject14());
var MobileSectionList = (0,styled_components_browser_esm["default"])(SectionList).attrs({
    styledComponentProps: {
        as: "div"
    },
    separator: /*#__PURE__*/ react.createElement(MobileSectionSeparator, null)
}).withConfig({
    displayName: "MobileSectionList",
    componentId: "sc-0-14"
})(styles_templateObject15());

// EXTERNAL MODULE: ./src/areas/product-collection/components/filter-section/index.tsx
var filter_section = __webpack_require__(6462);
// EXTERNAL MODULE: ./src/areas/product-collection/components/expandable-group/index.tsx + 1 modules
var expandable_group = __webpack_require__(26300);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/filter/group/styles.tsx
function group_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function group_styles_templateObject() {
    var data = group_styles_taggedTemplateLiteral([
        "\n  align-items: center;\n  border-radius: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  display: inline-flex;\n  font-weight: 600;\n  height: 20px;\n  justify-content: center;\n  margin: 0 ",
        ";\n  width: 20px;\n"
    ]);
    group_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function group_styles_templateObject1() {
    var data = group_styles_taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  width: 100%;\n"
    ]);
    group_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var AppliedFilterCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "AppliedFilterCount",
    componentId: "sc-0-0"
})(group_styles_templateObject(), function(param) {
    var inverted = param.inverted, theme = param.theme;
    return inverted ? theme.pill.inverted.bg : theme.pill.primary.bg;
}, function(param) {
    var inverted = param.inverted, theme = param.theme;
    return inverted ? theme.pill.inverted.text : theme.pill.primary.text;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var styles_FilterSectionButtonList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FilterSectionButtonList",
    componentId: "sc-0-1"
})(group_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product-collection/components/filter/group/index.tsx



var FilterSectionGroup = function(param) {
    var group = param.group, expanded = param.expanded, toggleExpanded = param.toggleExpanded, children = param.children, dark = param.dark;
    var onToggle = (0,react.useCallback)(function() {
        return toggleExpanded(group.title);
    }, [
        toggleExpanded,
        group.title
    ]);
    var appliedFilterCount = (0,react.useMemo)(function() {
        return group.filterCount > 0 ? /*#__PURE__*/ react.createElement(AppliedFilterCount, null, group.filterCount) : undefined;
    }, [
        group.filterCount
    ]);
    return /*#__PURE__*/ react.createElement(expandable_group/* ExpandableGroup */.i, {
        expanded: expanded,
        title: group.title,
        onToggle: onToggle,
        badge: appliedFilterCount,
        dark: dark
    }, children);
};
/* harmony default export */ var filter_group = (FilterSectionGroup);

;// CONCATENATED MODULE: ./src/areas/product-collection/components/filter/all-filter-sections.tsx
function all_filter_sections_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function all_filter_sections_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function all_filter_sections_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return all_filter_sections_arrayLikeToArray(arr);
}
function all_filter_sections_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function all_filter_sections_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function all_filter_sections_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function all_filter_sections_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function all_filter_sections_slicedToArray(arr, i) {
    return all_filter_sections_arrayWithHoles(arr) || all_filter_sections_iterableToArrayLimit(arr, i) || all_filter_sections_unsupportedIterableToArray(arr, i) || all_filter_sections_nonIterableRest();
}
function all_filter_sections_toConsumableArray(arr) {
    return all_filter_sections_arrayWithoutHoles(arr) || all_filter_sections_iterableToArray(arr) || all_filter_sections_unsupportedIterableToArray(arr) || all_filter_sections_nonIterableSpread();
}
function all_filter_sections_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return all_filter_sections_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return all_filter_sections_arrayLikeToArray(o, minLen);
}





// !!This component is used both on desktop and mobile property search!!
var AllFilterSections = function(param) {
    var sections = param.sections, filters = param.filters, isSearching = param.isSearching, filterByPropertySearch = param.filterByPropertySearch, hasSectionMatchingFilter = param.hasSectionMatchingFilter;
    var ref = react.useContext(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var ref1 = all_filter_sections_slicedToArray((0,react.useState)([]), 2), expandedGroups = ref1[0], setExpandedGroups = ref1[1];
    var toggleExpandedGroup = (0,react.useCallback)(function(id) {
        if (expandedGroups.includes(id)) {
            setExpandedGroups(expandedGroups.filter(function(groupId) {
                return groupId !== id;
            }));
        } else {
            setExpandedGroups(all_filter_sections_toConsumableArray(expandedGroups).concat([
                id
            ]));
        }
    }, [
        expandedGroups
    ]);
    var ungroupedSections = (0,react.useMemo)(function() {
        return (0,filter_section/* findUngroupedSections */.xj)(sections);
    }, [
        sections
    ]);
    var sectionGroups = (0,react.useMemo)(function() {
        return (0,filter_section/* findGroupedSections */.ij)(sections, filters, market.code);
    }, [
        sections,
        filters,
        market.code
    ]);
    return sections && sections.some(filter_section/* isValidSection */.uj) ? /*#__PURE__*/ react.createElement(react.Fragment, null, ungroupedSections.length > 0 && /*#__PURE__*/ react.createElement(SectionList, null, ungroupedSections.filter(filterByPropertySearch).map(function(section) {
        return /*#__PURE__*/ react.createElement(SectionListItem, {
            key: section.id
        }, /*#__PURE__*/ react.createElement(filter_section/* default */.ZP, {
            section: section,
            showTitle: true,
            disableSearch: isSearching
        }));
    })), sectionGroups.length > 0 && /*#__PURE__*/ react.createElement(SectionList, null, sectionGroups.filter(hasSectionMatchingFilter).map(function(group) {
        return /*#__PURE__*/ react.createElement(SectionListItem, {
            noPadding: true,
            key: group.title
        }, /*#__PURE__*/ react.createElement(filter_group, {
            group: group,
            expanded: expandedGroups.includes(group.title) || isSearching,
            toggleExpanded: toggleExpandedGroup,
            dark: true
        }, /*#__PURE__*/ react.createElement(SectionList, null, group.sections.filter(filterByPropertySearch).map(function(section) {
            return /*#__PURE__*/ react.createElement(SectionListItem, {
                key: section.id
            }, /*#__PURE__*/ react.createElement(filter_section/* default */.ZP, {
                section: section,
                showTitle: true,
                disableSearch: isSearching
            }));
        }))));
    }))) : /*#__PURE__*/ react.createElement(NoContent, null, t("filter", "filter.no-advanced-filters"));
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/filter/sidebar-filter.tsx
function sidebar_filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function sidebar_filter_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function sidebar_filter_extends() {
    sidebar_filter_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return sidebar_filter_extends.apply(this, arguments);
}
function sidebar_filter_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function sidebar_filter_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function sidebar_filter_slicedToArray(arr, i) {
    return sidebar_filter_arrayWithHoles(arr) || sidebar_filter_iterableToArrayLimit(arr, i) || sidebar_filter_unsupportedIterableToArray(arr, i) || sidebar_filter_nonIterableRest();
}
function sidebar_filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sidebar_filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sidebar_filter_arrayLikeToArray(o, minLen);
}











var SidebarFilterSection = function(_param) {
    var props = sidebar_filter_extends({}, _param);
    var t = react.useContext(app_context/* AppContext */.Il).t;
    var dispatch = react.useContext(context/* default */.Z).dispatch;
    var ref = sidebar_filter_slicedToArray((0,react.useState)(), 2), portalTarget = ref[0], setPortalTarget = ref[1];
    var sidebarTab = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.tab;
    });
    var showFilter = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.category.filter.showFilter || state.areas.sidebar.hasFilter;
    });
    var ref1 = useGlobalPropertySearch(), isSearching = ref1.isSearching, filterSearchQuery = ref1.filterSearchQuery, filterByPropertySearch = ref1.filterByPropertySearch, hasSectionMatchingFilter = ref1.hasSectionMatchingFilter, onSecondarySearchFieldChange = ref1.onSecondarySearchFieldChange;
    /**
   * The whole filter slice is rendered through a portal in order to keep it
   * within the route data structure while still being able to show it in the
   * sidebar. We have to do this little dance with local state and an effect
   * to make sure the portal target has been rendered before trying to render
   * into it.
   */ (0,react.useEffect)(function() {
        if (sidebarTab === constants/* SIDEBAR_STATE.FILTER */.$J.FILTER) {
            setTimeout(function() {
                setPortalTarget(document.getElementById(product_collection_constants/* FILTER_PORTAL_ID */._B));
            }, 0);
            dispatch({
                type: "SHOW_ALL_FILTERS"
            });
        }
    }, [
        sidebarTab,
        showFilter
    ]);
    if (!portalTarget) {
        return null;
    }
    return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ react.createElement(Filter, null, /*#__PURE__*/ react.createElement(FilterTitle, null, t("filter", "filter.title")), /*#__PURE__*/ react.createElement(FilterSearchWrapper, null, /*#__PURE__*/ react.createElement(secondary_search_field/* SecondarySearchField */.K, {
        fullWidth: true,
        value: filterSearchQuery,
        onChange: onSecondarySearchFieldChange,
        placeholder: t("filter", "properties.search-placeholder")
    })), /*#__PURE__*/ react.createElement(AllFilterSections, sidebar_filter_extends({}, props, {
        isSearching: isSearching,
        filterByPropertySearch: filterByPropertySearch,
        hasSectionMatchingFilter: hasSectionMatchingFilter
    }))), portalTarget);
};
/* harmony default export */ var sidebar_filter = (SidebarFilterSection);

// EXTERNAL MODULE: ./src/components/filter-overlay/index.tsx + 1 modules
var filter_overlay = __webpack_require__(15679);
// EXTERNAL MODULE: ./src/components/filter-overlay/components/section-items.tsx
var section_items = __webpack_require__(70258);
// EXTERNAL MODULE: ./src/areas/product-collection/hooks.ts
var hooks = __webpack_require__(48778);
// EXTERNAL MODULE: ./src/areas/product-collection/utils/filter.ts
var utils_filter = __webpack_require__(48105);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/filter/filter-mobile.tsx
function filter_mobile_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function filter_mobile_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function filter_mobile_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return filter_mobile_arrayLikeToArray(arr);
}
function filter_mobile_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function filter_mobile_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function filter_mobile_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function filter_mobile_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function filter_mobile_slicedToArray(arr, i) {
    return filter_mobile_arrayWithHoles(arr) || filter_mobile_iterableToArrayLimit(arr, i) || filter_mobile_unsupportedIterableToArray(arr, i) || filter_mobile_nonIterableRest();
}
function filter_mobile_toConsumableArray(arr) {
    return filter_mobile_arrayWithoutHoles(arr) || filter_mobile_iterableToArray(arr) || filter_mobile_unsupportedIterableToArray(arr) || filter_mobile_nonIterableSpread();
}
function filter_mobile_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return filter_mobile_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return filter_mobile_arrayLikeToArray(o, minLen);
}















var mobileOverlayContextValue = {
    filterLayout: "mobile-overlay"
};
var FilterMobile = function(props) {
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var ref1 = (0,react.useContext)(FilterContext), mobileFilterOpen = ref1.mobileFilterOpen, setMobileFilterOpen = ref1.setMobileFilterOpen, setCount = ref1.setCount;
    var appliedFilters = props.appliedFilters, clearFilter = props.clearFilter, filters = props.filters, productsCount = props.productsCount, sections = props.sections;
    var ref2 = (0,react.useContext)(context/* default */.Z), dispatchAggregationAction = ref2.dispatchAggregationAction, dispatch = ref2.dispatch;
    var ref3 = filter_mobile_slicedToArray((0,react.useState)([]), 2), expandedGroups = ref3[0], setExpandedGroups = ref3[1];
    var ref4 = filter_mobile_slicedToArray((0,react.useState)(), 2), currentSectionId = ref4[0], setCurrentSectionId = ref4[1];
    var aggregationSettings = (0,hooks/* useAggregationSettings */.J)(currentSectionId || "");
    var currentSection = (0,react.useMemo)(function() {
        return sections.find(function(param) {
            var id = param.id;
            return id === currentSectionId;
        });
    }, [
        sections,
        currentSectionId
    ]);
    var toggleExpandedGroup = (0,react.useCallback)(function(id) {
        if (expandedGroups.includes(id)) {
            setExpandedGroups(expandedGroups.filter(function(groupId) {
                return groupId !== id;
            }));
        } else {
            setExpandedGroups(filter_mobile_toConsumableArray(expandedGroups).concat([
                id
            ]));
        }
    }, [
        expandedGroups
    ]);
    var onBack = (0,react.useCallback)(function() {
        if (aggregationSettings === null || aggregationSettings === void 0 ? void 0 : aggregationSettings.query) {
            dispatchAggregationAction({
                type: "AGGREGATION_SEARCH",
                id: currentSectionId,
                query: ""
            });
        }
        setCurrentSectionId(undefined);
    }, [
        dispatchAggregationAction,
        aggregationSettings,
        currentSectionId
    ]);
    var onClose = (0,react.useCallback)(function() {
        setMobileFilterOpen(false);
        onBack();
    }, []);
    var onClear = (0,react.useCallback)(function() {
        // If currentSection is undefined (index view is open), all filters will be cleared.
        // Otherwise, just the filter for that property will be cleared.
        if (currentSection) {
            clearFilter(currentSection.property);
        } else {
            clearFilter();
        }
    }, [
        currentSection,
        clearFilter
    ]);
    var getCallToActionText = function(option) {
        var filter = appliedFilters.find(function(item) {
            return item.property === option.property;
        });
        if (!filter) return undefined;
        return (0,utils_filter/* formatFilterFn */.M)({
            filter: filter,
            t: t
        }).value;
    };
    var ungroupedSections = (0,react.useMemo)(function() {
        return (0,filter_section/* findUngroupedSections */.xj)(sections);
    }, [
        sections
    ]);
    var sectionGroups = (0,react.useMemo)(function() {
        return (0,filter_section/* findGroupedSections */.ij)(sections, appliedFilters, market.code);
    }, [
        sections,
        appliedFilters,
        market.code
    ]);
    var canClear = currentSection ? appliedFilters.some(function(param) {
        var property = param.property;
        return property === currentSection.property;
    }) : appliedFilters.length > 0;
    var ref5 = useGlobalPropertySearch(), isSearching = ref5.isSearching, filterSearchQuery = ref5.filterSearchQuery, filterByPropertySearch = ref5.filterByPropertySearch, hasSectionMatchingFilter = ref5.hasSectionMatchingFilter, onSecondarySearchFieldChange = ref5.onSecondarySearchFieldChange;
    (0,react.useEffect)(function() {
        setCount(filters.length);
        if (mobileFilterOpen) {
            dispatch({
                type: "SHOW_ALL_FILTERS"
            });
        }
    }, [
        setCount,
        filters,
        mobileFilterOpen
    ]);
    return mobileFilterOpen ? /*#__PURE__*/ react.createElement(filter_tracking/* ProductCollectionFilterContext.Provider */.Yd.Provider, {
        value: mobileOverlayContextValue
    }, /*#__PURE__*/ react.createElement(filter_overlay/* FilterOverlay */.l, {
        allSections: /*#__PURE__*/ react.createElement(AllFilterSections, {
            sections: sections,
            filters: appliedFilters,
            isSearching: isSearching,
            filterByPropertySearch: filterByPropertySearch,
            hasSectionMatchingFilter: hasSectionMatchingFilter
        }),
        canClear: canClear,
        clearFilter: onClear,
        count: productsCount,
        currentSection: currentSection && (0,filter_section/* isValidSection */.uj)(currentSection) && /*#__PURE__*/ react.createElement(filter_section/* default */.ZP, {
            section: currentSection,
            useInfiniteScroll: true,
            appliedFilters: appliedFilters
        }),
        hasFiltered: appliedFilters.length > 0,
        isSearching: isSearching,
        onBack: onBack,
        onClose: onClose,
        searchInput: /*#__PURE__*/ react.createElement(FilterSearchWrapper, null, /*#__PURE__*/ react.createElement(secondary_search_field/* SecondarySearchField */.K, {
            fullWidth: true,
            value: filterSearchQuery,
            onChange: onSecondarySearchFieldChange,
            placeholder: t("filter", "properties.search-placeholder")
        })),
        sectionGroups: /*#__PURE__*/ react.createElement(react.Fragment, null, sectionGroups.map(function(group) {
            return /*#__PURE__*/ react.createElement(filter_group, {
                key: group.title,
                group: group,
                expanded: expandedGroups.includes(group.title) || isSearching,
                toggleExpanded: toggleExpandedGroup
            }, /*#__PURE__*/ react.createElement(section_items/* SectionItems */.j, {
                filters: group.sections,
                getCallToActionText: getCallToActionText,
                setCurrentSectionId: setCurrentSectionId
            }));
        })),
        sectionItems: /*#__PURE__*/ react.createElement(section_items/* SectionItems */.j, {
            filters: ungroupedSections,
            getCallToActionText: getCallToActionText,
            setCurrentSectionId: setCurrentSectionId
        }),
        showBackArrow: Boolean(currentSection),
        showInitialView: !currentSection,
        title: currentSection ? currentSection.title : t("filter", "filter.title")
    }), " ") : null;
};

// EXTERNAL MODULE: ./src/components/applied-filters/index.tsx + 3 modules
var applied_filters = __webpack_require__(52888);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/filter.js
var actions_filter = __webpack_require__(44291);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/featured-filters/styles.ts
function featured_filters_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function featured_filters_styles_templateObject() {
    var data = featured_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: fit-content;\n  gap: ",
        ";\n  flex-wrap: wrap;\n"
    ]);
    featured_filters_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function featured_filters_styles_templateObject1() {
    var data = featured_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    featured_filters_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var FeaturedFilters = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FeaturedFilters",
    componentId: "sc-0-0"
})(featured_filters_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var FiltersWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FiltersWrapper",
    componentId: "sc-0-1"
})(featured_filters_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(33888);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/featured-filters/index.tsx












var featured_filters_FeaturedFilters = function(param) {
    var filters = param.filters, sections = param.sections, clearFilter = param.clearFilter;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ react.createElement(FiltersWrapper, null, /*#__PURE__*/ react.createElement(FeaturedFilters, null, sections.filter(filter_section/* isValidSection */.uj).map(function(section) {
        return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
            key: section.id,
            containerProps: {
                "data-test": "FeaturedFilter",
                "data-test-type": section.__typename,
                "data-test-property": section.property
            }
        }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
            showActiveIcon: true,
            containerProps: {
                "data-test": "FeaturedFilterButton"
            },
            size: button_variants.ButtonSize.SMALL
        }, section.title), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
            width: 304,
            zIndex: zindex/* zindex.overlay */.Y.overlay,
            height: 400
        }, /*#__PURE__*/ react.createElement(filter_section/* default */.ZP, {
            section: section,
            useInfiniteScroll: true,
            appliedFilters: filters,
            autoFocusSearch: true
        })));
    }), /*#__PURE__*/ react.createElement(button_variants.OutlinedButton, {
        size: button_variants.ButtonSize.SMALL,
        onClick: function() {
            return dispatch((0,actions_filter/* toggleFilter */.c)());
        },
        containerProps: {
            "data-test": "FeaturedFilterMoreFiltersButton"
        }
    }, /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(filter/* IconFilter */.w, null)), /*#__PURE__*/ react.createElement(button_variants.ButtonText, null, t("filter", "filter.show-more-filters")))), /*#__PURE__*/ react.createElement(applied_filters/* AppliedFilters */.M, {
        filters: filters,
        filterFormatFn: utils_filter/* formatFilterFn */.M,
        onClearFilter: function(param) {
            var property = param.property;
            return clearFilter(property);
        },
        onClearAll: function() {
            return clearFilter();
        }
    }));
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/filter/index.tsx









var isNameSearchFilter = function(filter) {
    return "type" in filter && filter.type === "name-search";
};
var quickFilterContextValue = {
    filterLayout: "quick-filter"
};
var sidebarFiltersContextValue = {
    filterLayout: "sidebar-filters"
};
var filter_Filter = function(param) {
    var sections = param.sections, filters = param.filters, productsCount = param.productsCount;
    var dispatch = (0,react.useContext)(context/* default */.Z).dispatch;
    var categoryId = (0,react.useContext)(filter_tracking/* ProductCollectionTrackingContext */.Xn).categoryId;
    var scope = (0,react.useContext)(filter_tracking/* ProductCollectionFilterTrackingScopeContext */.G_).scope;
    var trackClearFilter = (0,filter_tracking/* useTrackClearFilter */.JB)();
    var filtersExceptNameSearchFilter = (0,react.useMemo)(function() {
        return filters.filter(function(filter) {
            return !isNameSearchFilter(filter);
        });
    }, [
        filters
    ]);
    var featuredFilterSections = (0,react.useMemo)(function() {
        return sections.filter(function(item) {
            return item.featured;
        });
    }, [
        sections
    ]);
    var clearFilter = (0,react.useCallback)(function(property) {
        if (property) {
            var removedFilter = getFilterByProperty(filtersExceptNameSearchFilter, property);
            var type = convertTypeToFilterType(removedFilter.__typename);
            if (type) {
                (0,tracking_filter/* trackFilterRemoveEvent */.YD)({
                    value: property,
                    scope: scope,
                    property: property,
                    category: categoryId,
                    layout: "applied-filter",
                    type: type,
                    translatedValue: getFilterValue(removedFilter)
                });
            }
            trackClearFilter(property);
        } else {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = filtersExceptNameSearchFilter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var filter = _step.value;
                    var type1 = convertTypeToFilterType(filter.__typename);
                    if (type1) {
                        (0,tracking_filter/* trackFilterRemoveEvent */.YD)({
                            value: filter.property,
                            scope: scope,
                            property: filter.title || filter.property,
                            category: categoryId,
                            layout: "applied-filter-clear-all",
                            type: type1,
                            translatedValue: getFilterValue(filter)
                        });
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        dispatch({
            type: "FILTER_REMOVE",
            property: property
        });
    }, [
        dispatch,
        trackClearFilter,
        filtersExceptNameSearchFilter,
        scope,
        categoryId
    ]);
    return sections.length === 0 ? null : /*#__PURE__*/ react.createElement(styles_Wrapper, null, /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(FilterMobile, {
        appliedFilters: filtersExceptNameSearchFilter,
        clearFilter: clearFilter,
        filters: filters,
        productsCount: productsCount,
        sections: sections
    })), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(filter_tracking/* ProductCollectionFilterContext.Provider */.Yd.Provider, {
        value: quickFilterContextValue
    }, /*#__PURE__*/ react.createElement(featured_filters_FeaturedFilters, {
        filters: filtersExceptNameSearchFilter,
        sections: featuredFilterSections,
        clearFilter: clearFilter
    })))), /*#__PURE__*/ react.createElement(filter_tracking/* ProductCollectionFilterContext.Provider */.Yd.Provider, {
        value: sidebarFiltersContextValue
    }, /*#__PURE__*/ react.createElement(sidebar_filter, {
        key: "sidebar",
        sections: sections,
        filters: filtersExceptNameSearchFilter
    })));
};
function getFilterByProperty(filters, property) {
    return filters.find(function(filter) {
        return filter.property === property;
    });
}
function getFilterValue(filter) {
    switch(filter.__typename){
        case "ProductCollectionTermFilter":
            var _value;
            return (_value = filter.value) !== null && _value !== void 0 ? _value : "";
        case "ProductCollectionTermsFilter":
            var ref;
            var ref1;
            return (ref1 = (ref = filter.values) === null || ref === void 0 ? void 0 : ref.join(",")) !== null && ref1 !== void 0 ? ref1 : "";
        case "ProductCollectionBooleanFilter":
            var _value1;
            return (_value1 = filter.value) !== null && _value1 !== void 0 ? _value1 : "";
        case "ProductCollectionRangeFilter":
            var _value2;
            return (_value2 = filter.value) !== null && _value2 !== void 0 ? _value2 : "";
        case "ProductCollectionRangeGroupFilter":
            var ref2;
            var ref3;
            return (ref3 = (ref2 = filter.values) === null || ref2 === void 0 ? void 0 : ref2.join("-")) !== null && ref3 !== void 0 ? ref3 : "";
        default:
            return "";
    }
}
function convertTypeToFilterType(type) {
    switch(type){
        case "ProductCollectionTermFilter":
            return "list";
        case "ProductCollectionTermsFilter":
            return "list-tree";
        case "ProductCollectionBooleanFilter":
            return "boolean";
        case "ProductCollectionRangeFilter":
            return "range";
        case "ProductCollectionRangeGroupFilter":
            return "range-groups";
        default:
            return null;
    }
}
/* harmony default export */ var components_filter = (filter_Filter);

// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var components_breadcrumbs = __webpack_require__(88999);
// EXTERNAL MODULE: ./src/components/campaign-banners/promo-banner/index.tsx + 2 modules
var promo_banner = __webpack_require__(38911);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/breadcrumb/styles.ts
function breadcrumb_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function breadcrumb_styles_templateObject() {
    var data = breadcrumb_styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    breadcrumb_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function breadcrumb_styles_templateObject1() {
    var data = breadcrumb_styles_taggedTemplateLiteral([
        "\n  margin: ",
        ";\n"
    ]);
    breadcrumb_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledPromoBanner = (0,styled_components_browser_esm["default"])(promo_banner/* default */.Z).withConfig({
    displayName: "StyledPromoBanner",
    componentId: "sc-0-0"
})(breadcrumb_styles_templateObject(), base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem, base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem);
var StyledBreadcrumbs = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledBreadcrumbs",
    componentId: "sc-0-1"
})(breadcrumb_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product-collection/components/breadcrumb/index.tsx




var BreadcrumbSlice = function(param) {
    var items = param.items;
    var activeCampaigns = (0,es/* useSelector */.v9)(function(state) {
        return state.globals.campaignBanners.active.filter(function(campaign) {
            return (campaign === null || campaign === void 0 ? void 0 : campaign.type) === "DURING_PROMO_BANNER";
        });
    });
    var breadcrumbs = items.map(function(item) {
        return (item === null || item === void 0 ? void 0 : item.pathName) ? item : undefined;
    }).filter(function(x) {
        return x;
    });
    return /*#__PURE__*/ react.createElement(react.Fragment, null, !!(activeCampaigns === null || activeCampaigns === void 0 ? void 0 : activeCampaigns.length) && /*#__PURE__*/ react.createElement(StyledPromoBanner, {
        className: "product-collection-promo-banner",
        banners: activeCampaigns
    }), /*#__PURE__*/ react.createElement(StyledBreadcrumbs, null, /*#__PURE__*/ react.createElement(components_breadcrumbs/* Breadcrumbs */.O, {
        crumbs: breadcrumbs.map(function(param, index) {
            var title = param.name, href = param.pathName;
            return {
                href: breadcrumbs.length - 1 !== index ? href : undefined,
                title: title
            };
        })
    })));
};
/* harmony default export */ var breadcrumb = (BreadcrumbSlice);

// EXTERNAL MODULE: ./src/areas/product-collection/components/header-block/index.tsx + 1 modules
var header_block = __webpack_require__(68941);
// EXTERNAL MODULE: ./src/areas/product-collection/components/navigation/navigation-component.tsx + 4 modules
var navigation_component = __webpack_require__(51772);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/navigation/index.tsx
function navigation_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function navigation_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            navigation_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function navigation_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function navigation_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        navigation_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var NavigationSlice = function(props) {
    var links = props.links, property = props.property;
    var ref = (0,react.useContext)(context/* default */.Z), dispatch = ref.dispatch, currentRouteState = ref.currentRouteState;
    var trackFilterSelect = (0,filter_tracking/* useTrackFilterSelect */.o$)({
        property: property || "",
        type: "facet-navigation",
        title: property || ""
    }).trackFilterSelect;
    var filter = (currentRouteState.filters || []).find(function(f) {
        return f.property === property;
    });
    var onClick = (0,react.useCallback)(function(link) {
        trackFilterSelect({
            value: link.id,
            property: property === "brand" ? "brand" : "unknown",
            translatedValue: [
                link.value
            ]
        });
        dispatch({
            type: "FILTER_LIST_UPDATE",
            property: property,
            id: link.id
        });
    }, [
        property,
        dispatch,
        trackFilterSelect
    ]);
    var ref1;
    var formattedLinks = (0,react.useMemo)(function() {
        return (ref1 = links === null || links === void 0 ? void 0 : links.map(function(link) {
            var ref;
            var imageUrl = ((ref = link.productMedia) === null || ref === void 0 ? void 0 : ref.first) || link.fallbackImage;
            var selected = filter && filter.id === link.id;
            return navigation_objectSpreadProps(navigation_objectSpread({}, link), {
                imageUrl: imageUrl,
                selected: selected
            });
        })) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        filter,
        links
    ]);
    return /*#__PURE__*/ react.createElement(navigation_component/* NavigationSliceView */.B, {
        onClick: onClick,
        links: formattedLinks,
        onClickPreventDefault: true
    });
};
/* harmony default export */ var navigation = (NavigationSlice);

// EXTERNAL MODULE: ./node_modules/.pnpm/striptags@3.2.0/node_modules/striptags/src/striptags.js
var striptags = __webpack_require__(26478);
var striptags_default = /*#__PURE__*/__webpack_require__.n(striptags);
// EXTERNAL MODULE: ./src/areas/expert/components/expert-user-card/index.tsx + 1 modules
var expert_user_card = __webpack_require__(8454);
// EXTERNAL MODULE: ./src/areas/expert/types.ts
var expert_types = __webpack_require__(54712);
;// CONCATENATED MODULE: ./src/components/featured-category-article/styles.ts
function featured_category_article_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function featured_category_article_styles_templateObject() {
    var data = featured_category_article_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    featured_category_article_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function featured_category_article_styles_templateObject1() {
    var data = featured_category_article_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n\n  h3 {\n    font-weight: bold;\n    margin-bottom: 0;\n  }\n"
    ]);
    featured_category_article_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function featured_category_article_styles_templateObject2() {
    var data = featured_category_article_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n  "
    ]);
    featured_category_article_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function featured_category_article_styles_templateObject3() {
    var data = featured_category_article_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    featured_category_article_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function featured_category_article_styles_templateObject4() {
    var data = featured_category_article_styles_taggedTemplateLiteral([
        ""
    ]);
    featured_category_article_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function featured_category_article_styles_templateObject5() {
    var data = featured_category_article_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  border-radius: ",
        ";\n  position: relative;\n  margin: ",
        " 0;\n  min-height: 170px;\n  max-height: 250px;\n\n  img {\n    width: 100%;\n  }\n"
    ]);
    featured_category_article_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var ToplistLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "ToplistLink",
    componentId: "sc-0-0"
})(featured_category_article_styles_templateObject(), function(p) {
    return p.theme.colors.maybeBlue700;
});
var FeaturedCategoryArticle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FeaturedCategoryArticle",
    componentId: "sc-0-1"
})(featured_category_article_styles_templateObject1());
var ArticleLink = (0,styled_components_browser_esm["default"])(button_variants.OutlinedButton).withConfig({
    displayName: "ArticleLink",
    componentId: "sc-0-2"
})(featured_category_article_styles_templateObject3(), base/* media.smallOnly */.BC.smallOnly(featured_category_article_styles_templateObject2()));
var TextContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextContainer",
    componentId: "sc-0-3"
})(featured_category_article_styles_templateObject4());
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ImageWrapper",
    componentId: "sc-0-4"
})(featured_category_article_styles_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/components/featured-category-article/index.tsx








var featured_category_article_FeaturedCategoryArticle = function(param) {
    var className = param.className, imageUrl = param.imageUrl, pathName = param.pathName, preamble = param.preamble, title = param.title, linkText = param.linkText, expert = param.expert, category = param.category;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var trackOnClick = (0,react.useCallback)(function() {
        (0,tracking_tracking/* trackInternalNavigationClick */.p)({
            scope: tracking_tracking/* InternalNavigationScope.FEATURED_CATEGORY_ARTICLE */.U.FEATURED_CATEGORY_ARTICLE,
            nextPage: pathName
        });
    }, [
        pathName
    ]);
    return /*#__PURE__*/ react.createElement(FeaturedCategoryArticle, {
        className: className
    }, /*#__PURE__*/ react.createElement(text_variants.H3Text, null, category && category.url && /*#__PURE__*/ react.createElement(ToplistLink, {
        href: category.url,
        onClick: trackOnClick
    }, "Topplista:", " "), /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: pathName,
        onClick: trackOnClick
    }, title)), imageUrl && /*#__PURE__*/ react.createElement(ImageWrapper, null, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: pathName,
        onClick: trackOnClick
    }, /*#__PURE__*/ react.createElement("img", {
        src: imageUrl,
        alt: title
    }))), /*#__PURE__*/ react.createElement(TextContainer, null, preamble && /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: pathName,
        onClick: trackOnClick
    }, /*#__PURE__*/ react.createElement("p", null, preamble)), linkText ? /*#__PURE__*/ react.createElement(ArticleLink, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: pathName,
            onClick: trackOnClick
        }
    }, linkText) : []), expert && category.name && /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
        experts: [
            expert
        ],
        size: expert_types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM,
        subtitle: "".concat(t("expert", "toplist.expert-within"), " ").concat(category.name.toLowerCase())
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/slugify@1.3.4/node_modules/slugify/index.js
var node_modules_slugify = __webpack_require__(13653);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/arrow-up/index.js
var arrow_up = __webpack_require__(30411);
;// CONCATENATED MODULE: ./src/components/experts/product-toplist/styles.ts
function product_toplist_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_toplist_styles_templateObject() {
    var data = product_toplist_styles_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  ",
        "\n"
    ]);
    product_toplist_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_toplist_styles_templateObject1() {
    var data = product_toplist_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: ",
        "px 1fr;\n  column-gap: ",
        ";\n  align-items: center;\n"
    ]);
    product_toplist_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_toplist_styles_templateObject2() {
    var data = product_toplist_styles_taggedTemplateLiteral([
        "\n    margin-top: ",
        ";\n    margin-left: ",
        ";\n  "
    ]);
    product_toplist_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_toplist_styles_templateObject3() {
    var data = product_toplist_styles_taggedTemplateLiteral([
        "\n  margin: ",
        " 0;\n  padding: ",
        " ",
        " ",
        "\n    ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n\n  ",
        ";\n\n  a {\n    display: block;\n    margin-bottom: ",
        ";\n    position: relative;\n  }\n"
    ]);
    product_toplist_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function product_toplist_styles_templateObject4() {
    var data = product_toplist_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: row;\n  row-gap: ",
        ";\n\n  > * {\n    margin: 0;\n  }\n"
    ]);
    product_toplist_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function product_toplist_styles_templateObject5() {
    var data = product_toplist_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n\n  span {\n    margin: 0 ",
        ";\n    flex: initial;\n  }\n"
    ]);
    product_toplist_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function product_toplist_styles_templateObject6() {
    var data = product_toplist_styles_taggedTemplateLiteral([
        "\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    product_toplist_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function product_toplist_styles_templateObject7() {
    var data = product_toplist_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  background-color: ",
        ";\n  color: white;\n  width: ",
        "px;\n  height: ",
        "px;\n  border-radius: 0.125rem;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  line-height: 0;\n"
    ]);
    product_toplist_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function product_toplist_styles_templateObject8() {
    var data = product_toplist_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  outline: none;\n\n  &:hover,\n  &:focus {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    product_toplist_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





var IMAGE_SIZE = 48;
var POSITION_SIZE = 25;
var spacing125 = base/* layout.measurements.spacing125 */.bK.measurements.spacing125;
var ProductsArrow = (0,styled_components_browser_esm["default"])(arrow_up/* IconArrowUp */.C).withConfig({
    displayName: "ProductsArrow",
    componentId: "sc-0-0"
})(product_toplist_styles_templateObject(), base/* layout.measurements.fontSizeLarge */.bK.measurements.fontSizeLarge, function(p) {
    return p.down === "true" && "\n    transform: rotate(180deg)\n  ";
});
var styles_ProductRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductRow",
    componentId: "sc-0-1"
})(product_toplist_styles_templateObject1(), IMAGE_SIZE, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ProductToplistWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductToplistWrapper",
    componentId: "sc-0-2"
})(product_toplist_styles_templateObject3(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, spacing125, spacing125, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, spacing125, base/* colors.lightTheme.base200 */.O9.lightTheme.base200, base/* layout.measurements.spacing125 */.bK.measurements.spacing125, base/* media.largeUp */.BC.largeUp(product_toplist_styles_templateObject2(), base/* layout.measurements.spacing250 */.bK.measurements.spacing250, base/* layout.measurements.spacing150 */.bK.measurements.spacing150), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var ProductToplist = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductToplist",
    componentId: "sc-0-3"
})(product_toplist_styles_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ShowMoreButton = (0,styled_components_browser_esm["default"])(button_variants.TextButton).withConfig({
    displayName: "ShowMoreButton",
    componentId: "sc-0-4"
})(product_toplist_styles_templateObject5(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var ProductName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductName",
    componentId: "sc-0-5"
})(product_toplist_styles_templateObject6(), function(p) {
    return p.theme.text.linkExternal;
});
var ListPosition = styled_components_browser_esm["default"].p.withConfig({
    displayName: "ListPosition",
    componentId: "sc-0-6"
})(product_toplist_styles_templateObject7(), base/* colors.lightTheme.maybeBlue500 */.O9.lightTheme.maybeBlue500, POSITION_SIZE, POSITION_SIZE);
var Link = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Link",
    componentId: "sc-0-7"
})(product_toplist_styles_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});

;// CONCATENATED MODULE: ./src/areas/expert/requests/index.ts
var ExpertContentType;
(function(ExpertContentType) {
    ExpertContentType["topList"] = "toplist";
    ExpertContentType["guide"] = "guide";
    ExpertContentType["test"] = "test";
})(ExpertContentType || (ExpertContentType = {}));
var keyName = function(type, contentId, userId) {
    return "expert_click_".concat(type, "_").concat(contentId.slice(-15)).concat(userId.slice(-15));
};
var request = function(type, contentId, userId, expertsConfig) {
    if (!expertsConfig || !expertsConfig.apiUrl) {
        return;
    }
    fetch("".concat(expertsConfig.apiUrl, "/clickcounter-").concat(type, "/").concat(encodeURIComponent(contentId), "/").concat(encodeURIComponent(userId)), {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    })// eslint-disable-next-line @typescript-eslint/no-empty-function
    .then(function() {})// eslint-disable-next-line @typescript-eslint/no-empty-function
    .catch(function() {});
};
var saveTrackedContent = function(type, id, userId) {
    try {
        window.sessionStorage.setItem(keyName(type, id, userId), "1");
    // eslint-disable-next-line no-empty
    } catch (e) {}
};
var hasTrackedContent = function(type, id, userId) {
    /**
   * Only allow track once per session, contentId, userid.
   * Ignore tracking if sessionStorage does not exist
   */ try {
        return !!window.sessionStorage.getItem(keyName(type, id, userId));
    } catch (e) {
        return true;
    }
};
var likeRequest = function(type, contentId, userId, expertsConfig) {
    if (!expertsConfig || !expertsConfig.clickTrackingEnabled) {
        return;
    }
    if (hasTrackedContent(type, contentId, userId)) {
        return;
    }
    saveTrackedContent(type, contentId, userId);
    request(type, contentId, userId, expertsConfig);
};
var requests_trackExpertList = function(toplistHeadline, userId, expertsConfig) {
    likeRequest(ExpertContentType.topList, toplistHeadline, userId, expertsConfig);
};
var requests_trackExpertGuide = function(guideId, userId, expertsConfig) {
    likeRequest(ExpertContentType.guide, guideId, userId, expertsConfig);
};
var requests_trackExpertTest = function(testId, userId, expertsConfig) {
    likeRequest(ExpertContentType.test, testId, userId, expertsConfig);
};

;// CONCATENATED MODULE: ./src/hooks/expert-content-click-tracking.ts



var expert_content_click_tracking_useExpertContentClickTracker = function() {
    var market = useContext(AppContext).market;
    var trackGuideClick = useCallback(function(guideId, userId) {
        trackExpertGuide(guideId, userId, market.experts);
    }, [
        market.experts
    ]);
    var trackTestClick = useCallback(function(testId, userId) {
        trackExpertTest(testId, userId, market.experts);
    }, [
        market.experts
    ]);
    var trackToplistClick = useCallback(function(listId, userId) {
        trackExpertList(listId, userId, market.experts);
    }, [
        market.experts
    ]);
    return {
        trackGuideClick: trackGuideClick,
        trackTestClick: trackTestClick,
        trackToplistClick: trackToplistClick
    };
};

;// CONCATENATED MODULE: ./src/components/experts/product-toplist/index.tsx
function product_toplist_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_toplist_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_toplist_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_toplist_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_toplist_slicedToArray(arr, i) {
    return product_toplist_arrayWithHoles(arr) || product_toplist_iterableToArrayLimit(arr, i) || product_toplist_unsupportedIterableToArray(arr, i) || product_toplist_nonIterableRest();
}
function product_toplist_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_toplist_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_toplist_arrayLikeToArray(o, minLen);
}







var CategoryPageExpertToplist = function(props) {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var showButtonTextOptions = (0,react.useMemo)(function() {
        return {
            closed: t("symbols", "symbol.expand"),
            open: t("symbols", "symbol.collapse")
        };
    }, [
        t
    ]);
    var ref = product_toplist_slicedToArray((0,react.useState)(false), 2), showRest = ref[0], setShowRest = ref[1];
    var ref1 = product_toplist_slicedToArray((0,react.useState)(showButtonTextOptions.closed), 2), showButtonText = ref1[0], setButtonText = ref1[1];
    var expertProducts = props.products, _isTopList = props.isTopList, isTopList = _isTopList === void 0 ? true : _isTopList;
    var toggleProducts = (0,react.useCallback)(function() {
        setButtonText(showRest ? showButtonTextOptions.closed : showButtonTextOptions.open);
        setShowRest(!showRest);
    }, [
        showRest,
        showButtonTextOptions
    ]);
    if (!Array.isArray(expertProducts) || !expertProducts.length) {
        return null;
    }
    var MAX_PRODUCTS = 4;
    var expertsFirst = expertProducts.slice(0, MAX_PRODUCTS);
    var rest = expertProducts.slice(MAX_PRODUCTS);
    return /*#__PURE__*/ react.createElement(ProductToplistWrapper, null, expertsFirst.map(function(expertProduct, index) {
        return /*#__PURE__*/ react.createElement("a", {
            href: expertProduct.pathName,
            key: expertProduct.name,
            onClick: function() {
                (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking_tracking/* InternalNavigationScope.EXPERT_TOP_LIST */.U.EXPERT_TOP_LIST,
                    nextPage: expertProduct.pathName,
                    index: index
                });
            }
        }, isTopList && /*#__PURE__*/ react.createElement(ListPosition, null, index + 1), /*#__PURE__*/ react.createElement(styles_ProductRow, null, expertProduct.media.first && /*#__PURE__*/ react.createElement("img", {
            src: expertProduct.media.first,
            alt: expertProduct.name
        }), /*#__PURE__*/ react.createElement(ProductName, null, expertProduct.name)));
    }), showRest && /*#__PURE__*/ react.createElement("div", null, rest.map(function(expertProduct, index) {
        return /*#__PURE__*/ react.createElement("a", {
            href: expertProduct.pathName,
            key: expertProduct.name
        }, isTopList && /*#__PURE__*/ react.createElement(ListPosition, null, MAX_PRODUCTS + index + 1), /*#__PURE__*/ react.createElement(styles_ProductRow, null, expertProduct.media.first && /*#__PURE__*/ react.createElement("img", {
            src: expertProduct.media.first,
            alt: expertProduct.name
        }), /*#__PURE__*/ react.createElement(ProductName, null, expertProduct.name)));
    })), rest.length > 0 && /*#__PURE__*/ react.createElement(ShowMoreButton, {
        onClick: toggleProducts
    }, showRest ? /*#__PURE__*/ react.createElement(ProductsArrow, null) : /*#__PURE__*/ react.createElement(ProductsArrow, {
        down: "true"
    }), showRest ? showButtonText : "".concat(showButtonText, " (").concat(rest.length, ")")));
};
var product_toplist_ProductToplist = function(param) {
    var products = param.products, expert = param.expert, headline = param.headline;
    var ref = useContext(AppContext), linkTo = ref.linkTo, t = ref.t, renderMode = ref.renderMode;
    var trackToplistClick = useExpertContentClickTracker().trackToplistClick;
    var compareUrl = linkTo("productCompare", {
        products: products
    });
    if (!Array.isArray(products) || !products.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(S.ProductToplist, {
        "data-test": "ExpertProductToplist"
    }, /*#__PURE__*/ React.createElement(H3Text, null, t("expert", "toplist.products")), /*#__PURE__*/ React.createElement(S.Link, {
        to: compareUrl,
        isExternal: renderMode === "native",
        onClick: function() {
            trackToplistClick(headline.id, expert.id);
            trackInternalNavigationClick({
                scope: InternalNavigationScope.TOPLIST_COMPARE_PRODUCTS,
                nextPage: compareUrl
            });
        }
    }, t("expert", "toplist.products-compare")), products.filter(function(product) {
        return !!product.name;
    }).map(function(product, index) {
        return /*#__PURE__*/ React.createElement("a", {
            className: "product-tab-link",
            href: "#".concat(slugify("".concat(expert.name, "-").concat(product.name))),
            key: product.name
        }, /*#__PURE__*/ React.createElement(S.ProductRow, {
            "data-test": "ExpertProductToplistRow"
        }, product.media.first && /*#__PURE__*/ React.createElement("img", {
            width: S.IMAGE_SIZE,
            src: product.media.first,
            alt: product.name
        }), /*#__PURE__*/ React.createElement(S.ProductName, null, index + 1, ". ", product.name)));
    }));
};

// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/rich-text/index.tsx + 1 modules
var rich_text = __webpack_require__(45030);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/featured-articles/styles.ts
function featured_articles_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function featured_articles_styles_templateObject() {
    var data = featured_articles_styles_taggedTemplateLiteral([
        "\n      margin-top: ",
        ";\n        ",
        " {\n          margin-right: ",
        ";\n        }\n    "
    ]);
    featured_articles_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function featured_articles_styles_templateObject1() {
    var data = featured_articles_styles_taggedTemplateLiteral([
        "\n  display: grid;\n\n  ",
        " {\n    border: 1px solid ",
        ";\n    padding: ",
        ";\n    margin: ",
        " 0\n      ",
        " 0;\n    border-radius: ",
        ";\n\n    ",
        " {\n      grid-template-columns: ",
        "px 1fr;\n      column-gap: ",
        ";\n    }\n\n    ",
        "\n  }\n"
    ]);
    featured_articles_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function featured_articles_styles_templateObject2() {
    var data = featured_articles_styles_taggedTemplateLiteral([
        "\n    grid-template-columns: 70% 1fr;\n    align-items: start;\n    ",
        " {\n      margin-bottom: ",
        ";\n    }\n  "
    ]);
    featured_articles_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function featured_articles_styles_templateObject3() {
    var data = featured_articles_styles_taggedTemplateLiteral([
        "\n  margin: 0 ",
        ";\n\n  ",
        "\n"
    ]);
    featured_articles_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var HEADING_MARGIN = "45px";
var GridWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridWrapper",
    componentId: "sc-0-0"
})(featured_articles_styles_templateObject1(), ProductToplist, function(props) {
    return props.theme.colors.base200;
}, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, styles_ProductRow, 55, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.largeUp */.BC.largeUp(featured_articles_styles_templateObject(), HEADING_MARGIN, FeaturedCategoryArticle, base/* layout.measurements.spacing150 */.bK.measurements.spacing150));
var GridArticleWrapper = (0,styled_components_browser_esm["default"])(GridWrapper).withConfig({
    displayName: "GridArticleWrapper",
    componentId: "sc-0-1"
})(featured_articles_styles_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.largeUp */.BC.largeUp(featured_articles_styles_templateObject2(), FeaturedCategoryArticle, base/* layout.measurements.spacing300 */.bK.measurements.spacing300));

;// CONCATENATED MODULE: ./src/areas/product-collection/components/featured-articles/index.tsx







function getExpertProducts(featuredArticlesSlice) {
    var ref, ref1;
    var primarySlice = (ref1 = featuredArticlesSlice === null || featuredArticlesSlice === void 0 ? void 0 : (ref = featuredArticlesSlice.prismicArticle) === null || ref === void 0 ? void 0 : ref.data.body[0]) === null || ref1 === void 0 ? void 0 : ref1.primary;
    if ((primarySlice === null || primarySlice === void 0 ? void 0 : primarySlice.__typename) !== "PrismicSliceProductList") {
        return undefined;
    }
    return primarySlice.products;
}
var FeaturedArticles = function(param) {
    var featuredArticlesSlice = param.featuredArticlesSlice;
    var prismicArticle = featuredArticlesSlice.prismicArticle, sanityArticle = featuredArticlesSlice.sanityArticle, toplistArticles = featuredArticlesSlice.toplistArticles;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var ref;
    var filteredToplistArticles = (ref = toplistArticles === null || toplistArticles === void 0 ? void 0 : toplistArticles.filter(function(obj) {
        return Boolean(obj);
    })) !== null && ref !== void 0 ? ref : [];
    return /*#__PURE__*/ react.createElement(GridWrapper, null, filteredToplistArticles.map(function(article) {
        var ref, ref1, ref2, ref3, ref4;
        var ref5;
        var imageUrl = (ref5 = (ref = article.image) === null || ref === void 0 ? void 0 : ref.src) !== null && ref5 !== void 0 ? ref5 : (ref2 = (ref1 = article.description) === null || ref1 === void 0 ? void 0 : ref1.find(function(node) {
            return node.type === "image";
        })) === null || ref2 === void 0 ? void 0 : ref2.data;
        var firstParagraph = (ref4 = (ref3 = article.description) === null || ref3 === void 0 ? void 0 : ref3.find(function(node) {
            return node.type === "text";
        })) === null || ref4 === void 0 ? void 0 : ref4.data;
        return /*#__PURE__*/ react.createElement(GridArticleWrapper, {
            key: article.id
        }, /*#__PURE__*/ react.createElement(featured_category_article_FeaturedCategoryArticle, {
            expert: article.expert,
            key: article.id,
            pathName: article.headlineInfo.url || "",
            imageUrl: imageUrl,
            title: article.title || "",
            preamble: firstParagraph && striptags_default()(firstParagraph),
            category: article.category
        }), article.pjProducts && /*#__PURE__*/ react.createElement(CategoryPageExpertToplist, {
            products: article.pjProducts
        }));
    }), !sanityArticle && prismicArticle ? /*#__PURE__*/ react.createElement(GridArticleWrapper, {
        key: prismicArticle.id
    }, /*#__PURE__*/ react.createElement(featured_category_article_FeaturedCategoryArticle, {
        pathName: "/".concat(prismicArticle.pathName),
        imageUrl: prismicArticle.data.featuredImage && prismicArticle.data.featuredImage.url,
        title: (0,rich_text/* plainText */.K)(prismicArticle.data.title),
        preamble: (0,rich_text/* plainText */.K)(prismicArticle.data.metaDescription)
    }), /*#__PURE__*/ react.createElement(CategoryPageExpertToplist, {
        isTopList: false,
        products: getExpertProducts(featuredArticlesSlice)
    })) : null, sanityArticle ? /*#__PURE__*/ react.createElement(GridArticleWrapper, {
        key: sanityArticle.id
    }, /*#__PURE__*/ react.createElement(featured_category_article_FeaturedCategoryArticle, {
        pathName: linkTo("article", sanityArticle),
        imageUrl: sanityArticle.thumbnail,
        title: sanityArticle.title,
        preamble: sanityArticle.description
    }), /*#__PURE__*/ react.createElement(CategoryPageExpertToplist, {
        isTopList: false,
        products: sanityArticle.relatedProducts
    })) : null);
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/index.tsx









// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/index.tsx
var carousel_products = __webpack_require__(23013);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/types.ts
var carousel_products_types = __webpack_require__(57048);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/utils.ts
var utils = __webpack_require__(603);
// EXTERNAL MODULE: ./src/utils/index.ts
var src_utils = __webpack_require__(12650);
// EXTERNAL MODULE: ./src/areas/editorial-content/components/sanity-faq/index.tsx + 3 modules
var sanity_faq = __webpack_require__(56264);
;// CONCATENATED MODULE: ./src/areas/product-collection/selectors.ts
function selectProductLayout(state) {
    var userSelectedLayout = state.areas.productCollection.userSelectedLayout;
    return userSelectedLayout;
}

;// CONCATENATED MODULE: ./src/areas/product-collection/styles.tsx
function product_collection_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_collection_styles_templateObject() {
    var data = product_collection_styles_taggedTemplateLiteral([
        "\n  max-width: ",
        ";\n"
    ]);
    product_collection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SiteWidthWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SiteWidthWrapper",
    componentId: "sc-0-0"
})(product_collection_styles_templateObject(), base/* layout.siteWidth.rem */.bK.siteWidth.rem);

;// CONCATENATED MODULE: ./src/areas/product-collection/utils/format-breadcrumbs.ts
function format_breadcrumbs_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function format_breadcrumbs_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return format_breadcrumbs_arrayLikeToArray(arr);
}
function format_breadcrumbs_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function format_breadcrumbs_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function format_breadcrumbs_toConsumableArray(arr) {
    return format_breadcrumbs_arrayWithoutHoles(arr) || format_breadcrumbs_iterableToArray(arr) || format_breadcrumbs_unsupportedIterableToArray(arr) || format_breadcrumbs_nonIterableSpread();
}
function format_breadcrumbs_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return format_breadcrumbs_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return format_breadcrumbs_arrayLikeToArray(o, minLen);
}
var formatBreadcrumbs = function(sliceItems, categoryPaths) {
    return format_breadcrumbs_toConsumableArray(categoryPaths.map(function(param) {
        var name = param.name, pathName = param.pathName;
        return {
            name: name,
            pathName: pathName
        };
    }).filter(function(c) {
        return !sliceItems.some(function(si) {
            return si.pathName === c.pathName;
        });
    })).concat(format_breadcrumbs_toConsumableArray(sliceItems));
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/ranking-page-banner/styles.ts
function ranking_page_banner_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ranking_page_banner_styles_templateObject() {
    var data = ranking_page_banner_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  border-radius: 8px;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  text-decoration: none;\n  transition: opacity 0.15s ease;\n\n  &:hover {\n    opacity: 0.8;\n  }\n"
    ]);
    ranking_page_banner_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ranking_page_banner_styles_templateObject1() {
    var data = ranking_page_banner_styles_taggedTemplateLiteral([
        "\n  flex: none;\n  width: 34px;\n  height: 60px;\n  object-fit: contain;\n"
    ]);
    ranking_page_banner_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ranking_page_banner_styles_templateObject2() {
    var data = ranking_page_banner_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n"
    ]);
    ranking_page_banner_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ranking_page_banner_styles_templateObject3() {
    var data = ranking_page_banner_styles_taggedTemplateLiteral([
        "\n  font-size: 12px;\n  color: ",
        ";\n"
    ]);
    ranking_page_banner_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ranking_page_banner_styles_templateObject4() {
    var data = ranking_page_banner_styles_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  font-weight: 600;\n  color: ",
        ";\n  overflow: hidden;\n  /* stylelint-disable value-no-vendor-prefix */\n  display: -webkit-box;\n  /* stylelint-disable property-no-vendor-prefix */\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n"
    ]);
    ranking_page_banner_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ranking_page_banner_styles_templateObject5() {
    var data = ranking_page_banner_styles_taggedTemplateLiteral([
        "\n  flex: none;\n  width: 24px;\n  height: 24px;\n  color: ",
        ";\n"
    ]);
    ranking_page_banner_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Banner = styled_components_browser_esm["default"].a.withConfig({
    displayName: "Banner",
    componentId: "sc-0-0"
})(ranking_page_banner_styles_templateObject(), function(props) {
    return props.theme.colors.maybeBlue100;
}, function(props) {
    return props.theme.colors.base200;
});
var styles_Image = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(ranking_page_banner_styles_templateObject1());
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-2"
})(ranking_page_banner_styles_templateObject2());
var Caption = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Caption",
    componentId: "sc-0-3"
})(ranking_page_banner_styles_templateObject3(), function(props) {
    return props.theme.colors.base500;
});
var Title = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Title",
    componentId: "sc-0-4"
})(ranking_page_banner_styles_templateObject4(), function(props) {
    return props.theme.colors.base700;
});
var Arrow = styled_components_browser_esm["default"].svg.withConfig({
    displayName: "Arrow",
    componentId: "sc-0-5"
})(ranking_page_banner_styles_templateObject5(), function(props) {
    return props.theme.colors.maybeBlue500;
});

;// CONCATENATED MODULE: ./src/areas/product-collection/components/ranking-page-banner/index.tsx



// Links to a web-app /best-of page, so a plain href: full navigation out of the SPA.
var RankingPageBanner = function(param) {
    var slug = param.slug, title = param.title;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    return /*#__PURE__*/ react.createElement(Banner, {
        href: "/best-of/".concat(slug)
    }, /*#__PURE__*/ react.createElement(styles_Image, {
        src: "".concat(market.cdn, "/g/rfe/illustrations/bestof_header.png"),
        alt: "",
        width: 34,
        height: 60
    }), /*#__PURE__*/ react.createElement(Content, null, /*#__PURE__*/ react.createElement(Caption, null, t("ranking", "banner.caption")), /*#__PURE__*/ react.createElement(Title, null, title)), /*#__PURE__*/ react.createElement(Arrow, {
        viewBox: "0 0 24 24",
        "aria-hidden": "true"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M9 6l6 6-6 6",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })));
};

;// CONCATENATED MODULE: ./src/areas/product-collection/components/product-collection/styles.ts
function components_product_collection_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function components_product_collection_styles_templateObject() {
    var data = components_product_collection_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  padding: 0 ",
        ";\n"
    ]);
    components_product_collection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var MarginWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MarginWrapper",
    componentId: "sc-0-0"
})(components_product_collection_styles_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product-collection/components/product-collection/index.tsx
function product_collection_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_collection_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_collection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_collection_extends() {
    product_collection_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return product_collection_extends.apply(this, arguments);
}
function product_collection_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_collection_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_collection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_collection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_collection_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_collection_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_collection_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function product_collection_slicedToArray(arr, i) {
    return product_collection_arrayWithHoles(arr) || product_collection_iterableToArrayLimit(arr, i) || product_collection_unsupportedIterableToArray(arr, i) || product_collection_nonIterableRest();
}
function product_collection_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_collection_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_collection_arrayLikeToArray(o, minLen);
}

























var trackingScopeContextValue = {
    scope: tracking_filter/* PageScope.CATEGORY */.VN.CATEGORY
};
var product_collection_productCollectionFilterContextValue = {
    filterLayout: "facet-navigation"
};
var getLayout = function(preferredViewMode) {
    if (!preferredViewMode) {
        return types/* LayoutMode.GRID */.X.GRID;
    }
    // If the preferredViewMode is not set to grid we default to list
    // preferredViewMode can be more things than just "gird" and "list"
    return preferredViewMode === types/* LayoutMode.GRID */.X.GRID ? types/* LayoutMode.GRID */.X.GRID : types/* LayoutMode.TABLE */.X.TABLE;
};
var ProductCollection = function(param) {
    var data = param.data;
    var currentRouteState = (0,react.useContext)(context/* default */.Z).currentRouteState;
    // route state
    var isPaginated = currentRouteState.offset > 0;
    var productCollection = data;
    var ref = productCollection || {}, newPopularSearchTerms = ref.newPopularSearchTerms, _slices = ref.slices, slices = _slices === void 0 ? [] : _slices, slug = ref.slug, name = ref.name, trendingProducts = ref.trendingProducts, sanityFaq = ref.sanityFaq;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref1.t, linkTo = ref1.linkTo;
    var ref2 = (0,viewport_context/* useViewportContext */.Ak)(), isMobile = ref2.isMobile, isTablet = ref2.isTablet;
    var removeHeaderMargins = isMobile || isTablet;
    var popularKeywords = (newPopularSearchTerms === null || newPopularSearchTerms === void 0 ? void 0 : newPopularSearchTerms.popularKeywords) && (newPopularSearchTerms === null || newPopularSearchTerms === void 0 ? void 0 : newPopularSearchTerms.popularKeywords.length) ? newPopularSearchTerms.popularKeywords : null;
    var ref3;
    var trendingKeywords = (ref3 = newPopularSearchTerms === null || newPopularSearchTerms === void 0 ? void 0 : newPopularSearchTerms.trendingKeywords) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4 = product_collection_slicedToArray((0,react.useState)(false), 2), mobileFilterOpen = ref4[0], setMobileFilterOpen = ref4[1];
    var ref5 = product_collection_slicedToArray((0,react.useState)(0), 2), count = ref5[0], setCount = ref5[1];
    var ref6 = (0,src_utils/* discriminatedArrayToMap */.OS)(slices, "__typename"), BreadcrumbsSlice = ref6.BreadcrumbsSlice, HeaderBlockSlice = ref6.HeaderBlockSlice, FilterSlice = ref6.FilterSlice, NavigationSlice = ref6.NavigationSlice, ProductsSlice = ref6.ProductsSlice, DescriptionSlice = ref6.DescriptionSlice, FeaturedArticlesSlice = ref6.FeaturedArticlesSlice, ExpertSlice = ref6.ExpertSlice, SecondaryNavigationSlice = ref6.SecondaryNavigationSlice, AdsSlice = ref6.AdsSlice;
    var trackingContextValue = (0,react.useMemo)(function() {
        return {
            categoryId: slug,
            categoryName: name
        };
    }, [
        slug,
        name
    ]);
    var filterContextValue = (0,react.useMemo)(function() {
        return {
            mobileFilterOpen: mobileFilterOpen,
            setMobileFilterOpen: setMobileFilterOpen,
            count: count,
            setCount: setCount
        };
    }, [
        count,
        mobileFilterOpen
    ]);
    var customLayout = (0,es/* useSelector */.v9)(function(state) {
        return selectProductLayout(state);
    });
    var activeLayout = customLayout || getLayout(ProductsSlice === null || ProductsSlice === void 0 ? void 0 : ProductsSlice.preferredViewMode);
    return /*#__PURE__*/ react.createElement(filter_tracking/* ProductCollectionFilterTrackingScopeContext.Provider */.G_.Provider, {
        value: trackingScopeContextValue
    }, /*#__PURE__*/ react.createElement(filter_tracking/* ProductCollectionTrackingContext.Provider */.Xn.Provider, {
        value: trackingContextValue
    }, /*#__PURE__*/ react.createElement(FilterContext.Provider, {
        value: filterContextValue
    }, /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        "data-test": "ProductCollectionPage",
        withAds: true,
        adsConfig: {
            pageOptions: product_collection_objectSpreadProps(product_collection_objectSpread({}, product_collection_constants/* categoryAdsConfig.pageOptions */.ZZ.pageOptions), {
                categoryPath: AdsSlice === null || AdsSlice === void 0 ? void 0 : AdsSlice.categoryPath
            }),
            formats: product_collection_constants/* categoryAdsConfig.formats */.ZZ.formats,
            enabled: product_collection_constants/* categoryAdsConfig.enabled */.ZZ.enabled
        }
    }, BreadcrumbsSlice ? /*#__PURE__*/ react.createElement(breadcrumb, {
        id: BreadcrumbsSlice.id,
        items: formatBreadcrumbs(BreadcrumbsSlice.items, productCollection.categoryPath)
    }) : null, HeaderBlockSlice ? /*#__PURE__*/ react.createElement(header_block/* default */.Z, {
        title: HeaderBlockSlice.title,
        pagination: HeaderBlockSlice.pagination,
        noMargins: removeHeaderMargins
    }) : null, FilterSlice ? /*#__PURE__*/ react.createElement(components_filter, {
        id: FilterSlice.id,
        sections: FilterSlice.sections,
        filters: FilterSlice.filters,
        productsCount: FilterSlice.productsCount
    }) : null, NavigationSlice ? /*#__PURE__*/ react.createElement(filter_tracking/* ProductCollectionFilterContext.Provider */.Yd.Provider, {
        value: product_collection_productCollectionFilterContextValue
    }, /*#__PURE__*/ react.createElement(navigation, {
        id: NavigationSlice.id,
        links: NavigationSlice.links,
        property: NavigationSlice.property,
        key: "".concat(NavigationSlice.id, "_").concat(Array.isArray(NavigationSlice.links) ? NavigationSlice.links.map(function(param) {
            var id = param.id;
            return id;
        }).join(",") : "")
    })) : null, ProductsSlice ? /*#__PURE__*/ react.createElement(products, {
        id: ProductsSlice.id,
        pageInfo: ProductsSlice.pageInfo,
        products: ProductsSlice.products,
        productsCount: ProductsSlice.productsCount,
        storeCount: ProductsSlice.storeCount,
        legalText: ProductsSlice.legalText,
        availableSorts: ProductsSlice.availableSorts,
        currentSort: ProductsSlice.currentSort,
        maxHitsAmount: ProductsSlice.maxHitsAmount,
        sortDirection: ProductsSlice.sortDirection,
        propertyColumns: ProductsSlice.propertyColumns,
        expert: ExpertSlice === null || ExpertSlice === void 0 ? void 0 : ExpertSlice.expert,
        productCollection: productCollection,
        activeLayout: activeLayout
    }) : null, /*#__PURE__*/ react.createElement(SiteWidthWrapper, null, DescriptionSlice ? /*#__PURE__*/ react.createElement(category_description/* default */.Z, {
        name: productCollection.name,
        description: DescriptionSlice.description,
        aliases: productCollection.aliases,
        categoryUrl: linkTo("productCollection", {
            pathName: productCollection.url,
            filters: productCollection.filters
        })
    }) : null, productCollection.connectedRankingPage ? /*#__PURE__*/ react.createElement(MarginWrapper, {
        key: "ranking-page-banner"
    }, /*#__PURE__*/ react.createElement(RankingPageBanner, {
        slug: productCollection.connectedRankingPage.slug,
        title: productCollection.connectedRankingPage.title
    })) : null, (sanityFaq === null || sanityFaq === void 0 ? void 0 : sanityFaq.faqItems) ? /*#__PURE__*/ react.createElement(sanity_faq/* FaqSanity */.P, {
        faq: sanityFaq
    }) : null, FeaturedArticlesSlice ? /*#__PURE__*/ react.createElement(FeaturedArticles, {
        featuredArticlesSlice: FeaturedArticlesSlice
    }) : null, !isPaginated && ExpertSlice ? /*#__PURE__*/ react.createElement(advized/* AdvizedCarousel */._, product_collection_extends({
        offset: ExpertSlice.offset,
        isList: false,
        numberOfCards: isTablet ? 5 : 3,
        hideExperts: false
    }, ExpertSlice.expert)) : null, Array.isArray(trendingProducts) && trendingProducts.length > 0 ? /*#__PURE__*/ react.createElement(MarginWrapper, {
        key: "trending-products"
    }, /*#__PURE__*/ react.createElement(carousel_products/* CarouselProducts */.S, {
        title: t("landing", "trending-products.title"),
        products: (0,utils/* mapCarouselProducts */.b)(trendingProducts) || [],
        carouselType: carousel_products_types/* CarouselTypeEnum.TRENDING_PRODUCTS */.c.TRENDING_PRODUCTS
    })) : null, SecondaryNavigationSlice ? /*#__PURE__*/ react.createElement(secondary_navigation, {
        id: SecondaryNavigationSlice.id,
        key: SecondaryNavigationSlice.id,
        productCollection: productCollection,
        navigationItems: SecondaryNavigationSlice.navigationItems
    }) : null, Array.isArray(trendingKeywords) && trendingKeywords.length ? /*#__PURE__*/ react.createElement(MarginWrapper, {
        key: "trending-word-cloud"
    }, /*#__PURE__*/ react.createElement(word_cloud/* default */.Z, {
        title: t("search", "search.trending-searches"),
        items: trendingKeywords,
        showMoreUrl: linkTo("keywordListing", productCollection),
        numberOfVisibleItems: 10
    })) : null, Array.isArray(popularKeywords) && popularKeywords.length ? /*#__PURE__*/ react.createElement(MarginWrapper, {
        key: "word-cloud"
    }, /*#__PURE__*/ react.createElement(word_cloud/* default */.Z, {
        title: t("search", "search.related-searches"),
        items: popularKeywords,
        showMoreUrl: linkTo("keywordListing", productCollection),
        numberOfVisibleItems: 35
    })) : null)))));
};

// EXTERNAL MODULE: ./src/areas/product-collection/search-global-filters.graphql
var search_global_filters_graphql = __webpack_require__(27154);
var search_global_filters_graphql_default = /*#__PURE__*/__webpack_require__.n(search_global_filters_graphql);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(27019);
;// CONCATENATED MODULE: ./src/areas/product-collection/queries/useProductCollectionGlobalFilterSearchQuery.ts


function useGlobalFilterSearchQuery(variables) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (search_global_filters_graphql_default()),
        queryKey: [
            "productCollectionGlobalFilters"
        ],
        variables: variables,
        enabled: !!variables.definitionId
    });
}

// EXTERNAL MODULE: ./src/areas/product-collection/query.graphql
var query_graphql = __webpack_require__(50699);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/product-collection/queries/useProductCollectionPageQuery.ts


function useProductCollectionPageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "productCollection",
        variables: variables
    });
}

// EXTERNAL MODULE: ./src/areas/product-collection/search.graphql
var search_graphql = __webpack_require__(85534);
var search_graphql_default = /*#__PURE__*/__webpack_require__.n(search_graphql);
;// CONCATENATED MODULE: ./src/areas/product-collection/queries/useProductCollectionSearchQuery.ts


function useProductCollectionSearchQuery(variables) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (search_graphql_default()),
        queryKey: [
            "productCollectionAggregations"
        ],
        variables: variables,
        enabled: !!variables.aggregationId
    });
}

;// CONCATENATED MODULE: ./src/areas/product-collection/product-collection.tsx
function product_collection_product_collection_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_collection_product_collection_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_collection_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return product_collection_product_collection_arrayLikeToArray(arr);
}
function product_collection_product_collection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_collection_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function product_collection_product_collection_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_collection_product_collection_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_collection_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_collection_product_collection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_collection_product_collection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_collection_product_collection_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_collection_product_collection_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_collection_product_collection_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function product_collection_product_collection_slicedToArray(arr, i) {
    return product_collection_product_collection_arrayWithHoles(arr) || product_collection_product_collection_iterableToArrayLimit(arr, i) || product_collection_product_collection_unsupportedIterableToArray(arr, i) || product_collection_product_collection_nonIterableRest();
}
function product_collection_toConsumableArray(arr) {
    return product_collection_arrayWithoutHoles(arr) || product_collection_iterableToArray(arr) || product_collection_product_collection_unsupportedIterableToArray(arr) || product_collection_nonIterableSpread();
}
function product_collection_product_collection_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_collection_product_collection_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_collection_product_collection_arrayLikeToArray(o, minLen);
}










// RQ Queries




var ProductCollectionStateWrapper = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var _slug;
    return /*#__PURE__*/ react.createElement(ProductCollectionLoader, {
        key: (_slug = route === null || route === void 0 ? void 0 : route.variables.slug) !== null && _slug !== void 0 ? _slug : "unknown"
    });
};
var ProductCollectionLoader = function() {
    var addToFetchedUrls = function addToFetchedUrls(newUrl) {
        setFetchedUrls(function(prevSet) {
            return new Set(product_collection_toConsumableArray(prevSet).concat([
                newUrl
            ]));
        });
    };
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var location = (0,react_router_dom/* useLocation */.TH)();
    var history = (0,react_router_dom/* useHistory */.k6)();
    var ref = product_collection_product_collection_slicedToArray((0,react.useState)(new Set()), 2), fetchedUrls = ref[0], setFetchedUrls = ref[1];
    var activeSponsoredContent = (0,experiments/* useSponsoredContent */.L1)();
    // The initial state here needs to match what gets returned from stateToVariables({})
    var ref1 = product_collection_product_collection_slicedToArray((0,react.useState)(route === null || route === void 0 ? void 0 : route.ssr({
        location: location
    })), 2), routeState = ref1[0], setRouteState = ref1[1];
    var ref2 = useProductCollectionPageQuery(product_collection_product_collection_objectSpread({}, route === null || route === void 0 ? void 0 : route.variables, route === null || route === void 0 ? void 0 : route.component.stateToVariables(routeState))), pcData = ref2.data, pcIsLoading = ref2.isLoading, pcIsSuccess = ref2.isSuccess;
    var ref3 = product_collection_product_collection_slicedToArray((0,react.useState)(""), 2), globalPropertySearch = ref3[0], setGlobalPropertySearch = ref3[1];
    var globalFiltersQueryVariables = (0,react.useMemo)(function() {
        var _id, _aggregations;
        return {
            definitionId: (_id = routeState.id) !== null && _id !== void 0 ? _id : "",
            query: {
                filters: routeState.filters,
                aggregations: (_aggregations = routeState.aggregations) !== null && _aggregations !== void 0 ? _aggregations : [],
                globalPropertySearch: globalPropertySearch
            }
        };
    }, [
        routeState,
        globalPropertySearch
    ]);
    var ref4 = useGlobalFilterSearchQuery(globalFiltersQueryVariables), globalFiltersData = ref4.data;
    var ref5 = product_collection_product_collection_slicedToArray((0,react.useState)({}), 2), seachQueryVariables = ref5[0], setSearchQueryVariables = ref5[1];
    var ref6 = useProductCollectionSearchQuery(seachQueryVariables), pcSearchData = ref6.data;
    // getStateFromReducer regular reducer actions
    var setRegularReducerVariables = (0,react.useCallback)(function(action) {
        setRouteState(function(state) {
            return product_collection_product_collection_objectSpreadProps(product_collection_product_collection_objectSpread({}, productCollectionStaticReducer(state, action)), {
                useSponsoredContent: false
            });
        });
    }, []);
    // AGGREGATION_MORE_ITEMS, AGGREGATION_SEARCH
    var setAggregationVariables = (0,react.useCallback)(function(action) {
        var query = action.query, size = action.size;
        setRouteState(function(previousRouteState) {
            var ref;
            var newAggregation = product_collection_product_collection_objectSpread(product_collection_product_collection_objectSpreadProps(product_collection_product_collection_objectSpread({}, (ref = previousRouteState.aggregations) === null || ref === void 0 ? void 0 : ref.find(function(agg) {
                return agg && "id" in agg && (agg === null || agg === void 0 ? void 0 : agg.id) === action.id;
            })), {
                id: action.id
            }), query !== undefined && {
                query: query
            }, size && {
                size: size
            });
            var aggVariables = {
                id: previousRouteState.id,
                aggregationId: action.id,
                query: {
                    filters: previousRouteState.filters,
                    aggregations: [
                        newAggregation
                    ]
                }
            };
            // re-triggers RQ query agg search
            // TODO: This shouldn't really be here but whatever,
            // too much work to find alternative solution atm.
            setSearchQueryVariables(aggVariables);
            var newAggregations = mergeIntoQueryArray(// TODO: fix generic type
            // @ts-expect-error fix generic type
            previousRouteState.aggregations, newAggregation, "id");
            return product_collection_product_collection_objectSpreadProps(product_collection_product_collection_objectSpread({}, previousRouteState), {
                aggregations: newAggregations,
                useSponsoredContent: false
            });
        });
    }, []);
    // replaces ROUTE_DATA_REFETCHED action
    // updates history based on the new product collection url from API
    var updateHistory = (0,react.useCallback)(function(fetchedUrl, shouldPushToHistory) {
        if (fetchedUrl) {
            var offset = routeState.offset, sort = routeState.sort, direction = routeState.direction;
            var ref = dist_default().parseUrl(fetchedUrl), url = ref.url, query = ref.query;
            var finalQuery = product_collection_product_collection_objectSpread({}, query, offset && offset > 0 && {
                offset: offset.toString()
            }, sort && {
                sort: sort
            }, direction && {
                direction: direction
            });
            var queryStr = Object.keys(finalQuery).length ? "?".concat(dist_default().stringify(finalQuery)) : "";
            var newUrl = "".concat(url).concat(queryStr);
            if (shouldPushToHistory) {
                history.push(newUrl, {
                    refreshRoute: false
                });
            } else {
                history.replace(newUrl, {
                    refreshRoute: false
                });
            }
        }
    }, [
        history,
        routeState
    ]);
    (0,react.useEffect)(function() {
        // RQ: regular PC updates when RQ re-fetch happens and replicates ROUTE_LOADED action from the old solution
        if (!pcIsLoading && pcIsSuccess) {
            var pc = pcData === null || pcData === void 0 ? void 0 : pcData.productCollection;
            // Updates history every time we re-fetch a product collection
            // replaces ROUTE_DATA_REFETCHED action
            // replicates ROUTE_LOADED action
            if (!routeState.initialLoad) {
                var ref, ref1;
                var productsSlice = pc === null || pc === void 0 ? void 0 : (ref = pc.slices) === null || ref === void 0 ? void 0 : ref.find(function(slice) {
                    return slice.__typename === "ProductsSlice";
                });
                var propertyColumnIds = productsSlice === null || productsSlice === void 0 ? void 0 : (ref1 = productsSlice.propertyColumns) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                    var id = param.id;
                    return id;
                });
                // on initial load add url to fetched urls state
                if ((pc === null || pc === void 0 ? void 0 : pc.url) && !fetchedUrls.has(pc === null || pc === void 0 ? void 0 : pc.url)) addToFetchedUrls(pc === null || pc === void 0 ? void 0 : pc.url);
                setRouteState(product_collection_product_collection_objectSpreadProps(product_collection_product_collection_objectSpread({}, routeState), {
                    initialLoad: true,
                    id: pc === null || pc === void 0 ? void 0 : pc.id,
                    url: null,
                    filters: pc === null || pc === void 0 ? void 0 : pc.filters,
                    propertyColumnIds: propertyColumnIds,
                    useSponsoredContent: activeSponsoredContent
                }));
            }
            if (routeState.initialLoad) {
                var ref2;
                updateHistory((ref2 = pc === null || pc === void 0 ? void 0 : pc.url) !== null && ref2 !== void 0 ? ref2 : null, !fetchedUrls.has(pc === null || pc === void 0 ? void 0 : pc.url));
                if ((pc === null || pc === void 0 ? void 0 : pc.url) && !fetchedUrls.has(pc === null || pc === void 0 ? void 0 : pc.url)) addToFetchedUrls(pc === null || pc === void 0 ? void 0 : pc.url);
            }
        }
        // update urls when using broswer actions and update component state
        var listenToHistory = history.listen(function(newLocation) {
            setRegularReducerVariables({
                type: "URL_CHANGE",
                location: newLocation
            });
        });
        return function() {
            listenToHistory();
        };
    // doesn't need routeState and updateHistory as dependency. Better way to do this?
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pcData,
        pcIsSuccess,
        pcIsLoading,
        history
    ]);
    var dispatchAggregationAction = (0,react.useCallback)(function(action) {
        switch(action.type){
            case "AGGREGATION_SEARCH":
            case "AGGREGATION_MORE_ITEMS":
                setAggregationVariables(action);
                break;
            case "GLOBAL_AGGREGATION_SEARCH":
                setGlobalPropertySearch(action.globalPropertySearch);
                break;
            default:
                break;
        }
    }, [
        setAggregationVariables,
        setGlobalPropertySearch
    ]);
    // ROUTE CONTEXT. Preserving the dispatch pattern for now
    var routeContextValue = (0,react.useMemo)(function() {
        return {
            dispatchAggregationAction: dispatchAggregationAction,
            dispatch: setRegularReducerVariables,
            currentRouteState: routeState
        };
    }, [
        routeState,
        dispatchAggregationAction,
        setRegularReducerVariables
    ]);
    var data = (0,react.useMemo)(function() {
        if (!(pcData === null || pcData === void 0 ? void 0 : pcData.productCollection)) return null;
        var filterSlice = pcData.productCollection.slices.find(function(slice) {
            return slice.__typename === "FilterSlice";
        });
        var searchAgg = (pcSearchData === null || pcSearchData === void 0 ? void 0 : pcSearchData.productCollectionAggregation) && [
            pcSearchData === null || pcSearchData === void 0 ? void 0 : pcSearchData.productCollectionAggregation
        ];
        var globalFilterAggs = globalFiltersData === null || globalFiltersData === void 0 ? void 0 : globalFiltersData.globalFilterSearch;
        if (filterSlice && (searchAgg || globalFilterAggs)) {
            filterSlice.sections = [].concat(filterSlice.sections.map(function(section) {
                var searchSection = searchAgg === null || searchAgg === void 0 ? void 0 : searchAgg.find(function(param) {
                    var id = param.id;
                    return section.id === id;
                });
                var globalFilterSection = globalFilterAggs === null || globalFilterAggs === void 0 ? void 0 : globalFilterAggs.find(function(param) {
                    var id = param.id;
                    return section.id === id;
                });
                var result = product_collection_product_collection_objectSpread({}, section, globalFilterSection !== null && globalFilterSection !== void 0 ? globalFilterSection : searchSection);
                return result;
            }));
        }
        return pcData === null || pcData === void 0 ? void 0 : pcData.productCollection;
    }, [
        pcData,
        pcSearchData,
        globalFiltersData
    ]);
    if (pcIsLoading) {
        return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, null, /*#__PURE__*/ react.createElement(loader/* default */.Z, null));
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, pcIsSuccess && data ? /*#__PURE__*/ react.createElement(context/* default.Provider */.Z.Provider, {
        value: routeContextValue
    }, /*#__PURE__*/ react.createElement(ProductCollection, {
        data: data
    })) : null);
};
/* harmony default export */ var product_collection = (ProductCollectionStateWrapper);


/***/ }),

/***/ 48105:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ formatFilterFn)
/* harmony export */ });
function isNameSearchFilter(x) {
    return x.__typename === "ProductCollectionNameSearchFilter";
}
var formatFilterFn = function(param) {
    var filter = param.filter, t = param.t;
    if (isNameSearchFilter(filter)) {
        return {
            prefix: "",
            value: '"'.concat(filter.query, '"'),
            key: filter.query
        };
    }
    var value = filter.property;
    switch(filter.__typename){
        case "ProductCollectionTermsFilter":
            {
                var values = Array.isArray(filter.values) ? filter.values.map(function(v, index) {
                    return v === "" ? filter.ids[index] || "?" : v;
                }) : filter.ids;
                value = values.length > 3 ? "".concat(values.slice(0, 2).join(", "), ", +").concat(values.length - 2) : values.join(", ");
                break;
            }
        case "ProductCollectionTermFilter":
            value = filter.value || filter.id;
            break;
        case "ProductCollectionRangeFilter":
            {
                var ranges = filter.from === filter.to ? "".concat(filter.from) : "".concat(filter.from, " - ").concat(filter.to);
                value = "".concat(ranges).concat(filter.unit ? " ".concat(filter.unit) : "");
                break;
            }
        case "ProductCollectionRangeGroupFilter":
            {
                var values1 = Array.isArray(filter.values) ? filter.values : [
                    filter.id
                ];
                value = values1.join(", ");
                break;
            }
        case "ProductCollectionBooleanFilter":
            value = t("filter", filter.id === "true" ? "properties.select-true" : "properties.select-false");
            break;
        default:
    }
    var _title;
    return {
        prefix: (_title = filter.title) !== null && _title !== void 0 ? _title : undefined,
        value: value,
        key: value
    };
};


/***/ }),

/***/ 37424:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ isRaw)
/* harmony export */ });
var isRaw = function(variableToCheck) {
    return variableToCheck.__typename === "Raw" || variableToCheck.__typename === "Offer";
};


/***/ }),

/***/ 82740:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ getPropertyFromSortKey),
/* harmony export */   "g": () => (/* binding */ getSortKeyForProperty)
/* harmony export */ });
function getSortKeyForProperty(id) {
    return "property.".concat(id);
}
function getPropertyFromSortKey(sortKey) {
    return sortKey.substring("property.".length);
}


/***/ }),

/***/ 28978:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": () => (/* binding */ getPropertyColumnName),
/* harmony export */   "x": () => (/* binding */ UNTOGGLABLE_PROPERTY_COLUMNS)
/* harmony export */ });
// It's possible to toggle a product list column from most filter sections, but some columns can't
// be removed as they are part of the base set of columns, and some filters aren't supported as
// columns at all.
var UNTOGGLABLE_PROPERTY_COLUMNS = [
    // These map to columns that can't be removed
    "lowestPrice",
    "in_stock",
    "user_reviews_rating",
    // Stores is not a real product property, and we don't handle it as a special case (unlike brand)
    "stores"
];
function getPropertyColumnName(column, t) {
    if (column.__typename === "ProductCollectionTruePropertyColumn") {
        return column.name;
    }
    switch(column.id){
        case "brand":
            return t("category", "product-list.brand-column-name");
        case "deal_diff_percentage":
            return t("category", "product-list.deal-diff-column-name");
        case "days_since_indexing":
            return t("category", "product-list.index-date-column-name");
        default:
            return "-";
    }
}


/***/ }),

/***/ 78082:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ TabAnchor)
/* harmony export */ });
var TabAnchor;
(function(TabAnchor) {
    TabAnchor["PRODUCTS"] = "#products";
    TabAnchor["CATEGORIES"] = "#categories";
    TabAnchor["TESTS"] = "#tests-and-guides";
})(TabAnchor || (TabAnchor = {}));


/***/ }),

/***/ 69988:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ AdvizedCarousel)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25349);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3616);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89218);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21541);
/* harmony import */ var src_areas_expert_components_list_of_content_cards__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8263);
/* harmony import */ var _tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98864);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33222);
/* harmony import */ var src_ui_block__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84234);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57735);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var MIN_INFO_LIST_COUNT = 5;
var AdvizedContent = function(param) {
    var testsCount = param.testsCount, toplistsCount = param.toplistsCount, guidesCount = param.guidesCount, category = param.category, toplists = param.toplists, tests = param.tests, _numberOfCards = param.numberOfCards, numberOfCards = _numberOfCards === void 0 ? 5 : _numberOfCards, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _hideExperts = param.hideExperts, hideExperts = _hideExperts === void 0 ? true : _hideExperts;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il), linkTo = ref.linkTo, renderMode = ref.renderMode, t = ref.t;
    if (!category || !(testsCount || toplistsCount || guidesCount)) return null;
    var content = _toConsumableArray(tests || []).concat(_toConsumableArray(toplists || []));
    var getInfoListItems = function() {
        return [
            toplistsCount ? "".concat(toplistsCount, " ").concat(t("expert", "toplist.lists")) : null,
            testsCount ? "".concat(testsCount, " ").concat(t("expert", "test.tests")) : null,
            guidesCount ? "".concat(guidesCount, " ").concat(t("expert", "guide.guides")) : null
        ].filter(function(item) {
            return item;
        });
    };
    var showInfoList = (toplistsCount !== null && toplistsCount !== void 0 ? toplistsCount : 0) - offset >= MIN_INFO_LIST_COUNT;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .Header */ .h4, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.H3Text, null, t("expert", "widget.category-page-title")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
        to: linkTo("experts"),
        onClick: function() {
            (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .trackInternalNavigationClick */ .p)({
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .InternalNavigationScope.EXPERT_ADVISE_SHOW_ALL */ .U.EXPERT_ADVISE_SHOW_ALL,
                nextPage: linkTo("experts")
            });
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.TitleSmallText, {
        color: _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.FontColor.PRIMARY
    }, t("expert", "widget.category-page-link")))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .Cards */ .oy, null, showInfoList && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .Card */ .Zb, {
        outlined: false
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .CardActionArea */ .MU, {
        container: src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P,
        containerProps: {
            onClick: function() {
                (0,_tracking__WEBPACK_IMPORTED_MODULE_6__/* .trackCategoryPageExpertCarouselInfoList */ .e)(category.url, "infoList");
                (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .trackInternalNavigationClick */ .p)({
                    scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .InternalNavigationScope.EXPERT_ADVISE_SHOW_ALL */ .U.EXPERT_ADVISE_SHOW_ALL,
                    nextPage: linkTo("experts")
                });
            },
            to: linkTo("expertCategory", {
                semantic_id: category.url
            }, renderMode === "native" ? {
                view: "native"
            } : undefined)
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .CardBackgroundImage */ .Gl, {
        src: category.descriptionImage || ""
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .CardContent */ .aY, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .Description */ .dk, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, t("expert", "widget.category-page-description", {
        category: category.name.toLowerCase()
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .InfoList */ .Q4, {
        list: getInfoListItems()
    })))))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .ContentCards */ .g1, {
        offset: offset,
        category: category,
        items: content,
        limit: numberOfCards,
        hideExperts: hideExperts,
        trackingSource: src_areas_expert_components_list_of_content_cards__WEBPACK_IMPORTED_MODULE_5__/* .TrackingSource.ADVIZED_WIDGET */ .e.ADVIZED_WIDGET,
        onClick: function(onClickData) {
            return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .trackInternalNavigationClick */ .p)({
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_9__/* .InternalNavigationScope.ARTICLE_CONTENT_CARD */ .U.ARTICLE_CONTENT_CARD,
                nextPage: onClickData.url,
                index: onClickData.index
            });
        }
    })));
};
var AdvizedCarousel = function(props) {
    var _isList = props.isList, isList = _isList === void 0 ? true : _isList, grid = props.grid;
    return isList ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_ui_block__WEBPACK_IMPORTED_MODULE_8__/* .MobileOnly */ .iB, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .AdvizedListWrapper */ .hI, {
        grid: grid || false
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AdvizedContent, _extends({}, props)))) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_ui_block__WEBPACK_IMPORTED_MODULE_8__/* .MediumUp */ .TD, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_7__/* .Wrapper */ .im, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AdvizedContent, _extends({}, props))));
};


/***/ }),

/***/ 33222:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gl": () => (/* binding */ CardBackgroundImage),
/* harmony export */   "MU": () => (/* binding */ CardActionArea),
/* harmony export */   "Q4": () => (/* binding */ InfoList),
/* harmony export */   "Zb": () => (/* binding */ Card),
/* harmony export */   "aY": () => (/* binding */ CardContent),
/* harmony export */   "dk": () => (/* binding */ Description),
/* harmony export */   "g1": () => (/* binding */ ContentCards),
/* harmony export */   "h4": () => (/* binding */ Header),
/* harmony export */   "hI": () => (/* binding */ AdvizedListWrapper),
/* harmony export */   "im": () => (/* binding */ Wrapper),
/* harmony export */   "oy": () => (/* binding */ Cards)
/* harmony export */ });
/* unused harmony exports PreTitle, Title */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33561);
/* harmony import */ var src_components_info_list__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29089);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29261);
/* harmony import */ var _areas_expert_components_list_of_content_cards__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8263);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n      padding: ",
        ";\n      padding-bottom: 0;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    display: none;\n\n    ",
        "\n  }\n\n  a {\n    max-width: max-content;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    height: 100%;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(6, minmax(240px, 1fr));\n  overflow-x: auto;\n  column-gap: ",
        ";\n  padding: ",
        ";\n\n  > * {\n    /* Set a white background color to all cards */\n    background: ",
        ";\n  }\n\n  &::after {\n    /* Adds spacing to the end of the scroll area */\n    content: '';\n    display: block;\n    width: ",
        ";\n    margin-left: -",
        ";\n    pointer-events: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    order: 2;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    grid-area: 4 / 1 / auto / -1;\n    display: grid;\n    background: ",
        ";\n    margin: ",
        " -",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      min-width: 25%;\n      flex: 1 1 25%;\n\n      @media screen and (max-width: 820px) and (min-width: 520px) {\n        min-width: 33%;\n        flex: 1 1 33%;\n        order: 2 !important;\n      }\n\n      @media screen and (max-width: 520px) {\n        min-width: 50%;\n        flex: 1 1 50%;\n        order: 1 !important;\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  order: 3;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: ",
        ";\n\n      ",
        " {\n        grid-template-columns: repeat(6, minmax(235px, 1fr));\n        padding: ",
        ";\n      }\n\n      ",
        " {\n        display: flex;\n        padding: ",
        ";\n        padding-bottom: 0;\n      }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        " {\n      overflow-x: hidden;\n    }\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  background: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  background-position: center center;\n  flex: 1 0 auto;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: bold;\n  line-height: 1.25;\n  color: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: 800;\n  line-height: 1.5;\n  text-transform: uppercase;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-row-gap: ",
        ";\n\n  ",
        " {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: bold;\n  line-height: 1.25;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}






var ContentCards = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_areas_expert_components_list_of_content_cards__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    displayName: "ContentCards",
    componentId: "sc-0-0"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject()));
var Header = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_4__.Column).withConfig({
    displayName: "Header",
    componentId: "sc-0-1"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100));
var Cards = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Cards",
    componentId: "sc-0-2"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, function(p) {
    return p.theme.bg.primary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject4()));
var AdvizedListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].li.withConfig({
    displayName: "AdvizedListWrapper",
    componentId: "sc-0-3"
})(_templateObject9(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject6()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject7(), function(p) {
    return p.theme.colors.maybeBlue100;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), function(props) {
    return !props.grid && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8());
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-4"
})(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200, Cards, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, Header, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject11(), Cards));
var Card = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_2__.Card).withConfig({
    displayName: "Card",
    componentId: "sc-0-5"
})(_templateObject13(), function(p) {
    return p.theme.bg.primary;
});
var CardBackgroundImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_2__.CardBackgroundImage).withConfig({
    displayName: "CardBackgroundImage",
    componentId: "sc-0-6"
})(_templateObject14());
var PreTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "PreTitle",
    componentId: "sc-0-7"
})(_templateObject15(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, function(p) {
    return src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(p.theme.colors.base0, 0.72);
});
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Title",
    componentId: "sc-0-8"
})(_templateObject16(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeLarge */ .bK.measurements.fontSizeLarge);
var CardContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_2__.CardContent).withConfig({
    displayName: "CardContent",
    componentId: "sc-0-9"
})(_templateObject17(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, PreTitle);
var CardActionArea = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_2__.CardActionArea).withConfig({
    displayName: "CardActionArea",
    componentId: "sc-0-10"
})(_templateObject18());
var Description = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Description",
    componentId: "sc-0-11"
})(_templateObject19(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium);
var InfoList = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_info_list__WEBPACK_IMPORTED_MODULE_3__/* .InfoList */ .Q).withConfig({
    displayName: "InfoList",
    componentId: "sc-0-12"
})(_templateObject20(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, function(p) {
    return p.theme.colors.staticBase0;
});


/***/ }),

/***/ 98864:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ trackCategoryPageExpertCarouselInfoList),
/* harmony export */   "t": () => (/* binding */ trackCategoryPageExpertCarouselCard)
/* harmony export */ });
/* harmony import */ var _client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24005);

var trackCategoryPageExpertCarouselCard = function(pageUrl, cardType) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("productCollectionExpertCarouselCardClick", {
        pageUrl: pageUrl,
        cardType: cardType
    });
};
var trackCategoryPageExpertCarouselInfoList = function(pageUrl, cardType) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("productCollectionExpertCarouselInfoClick", {
        pageUrl: pageUrl,
        cardType: cardType
    });
};


/***/ }),

/***/ 7688:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ category_description)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(82691);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/category-description/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: column;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border-top: 1px solid ",
        ";\n  margin: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  padding: ",
        " 0 0 0;\n  display: flex;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 0 ",
        " 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  margin: 0;\n  max-width: 600px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var DescriptionContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DescriptionContainer",
    componentId: "sc-0-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.lines.secondary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.smallDown */.BC.smallDown(_templateObject()));
var DescriptionTitle = (0,styled_components_browser_esm["default"])(variants.H2Text).withConfig({
    displayName: "DescriptionTitle",
    componentId: "sc-0-1"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var DescriptionText = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "DescriptionText",
    componentId: "sc-0-2"
})(_templateObject3());
var DescriptionBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DescriptionBox",
    componentId: "sc-0-3"
})(_templateObject4());
var AliasLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "AliasLink",
    componentId: "sc-0-4"
})(_templateObject5(), function(p) {
    return p.theme.text.linkExternal;
}, function(p) {
    return p.theme.text.linkExternalHover;
});

;// CONCATENATED MODULE: ./src/components/category-description/index.tsx




var CategoryDescription = function(param) {
    var name = param.name, description = param.description, aliases = param.aliases, categoryUrl = param.categoryUrl;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var scrollToTop = react.useCallback(function() {
        return window.scroll(0, 0);
    }, []);
    var aliasLinks = react.useMemo(function() {
        if (!aliases) {
            return null;
        }
        var arr = aliases.filter(function(alias) {
            return typeof alias === "string";
        }).filter(// We don't want empty aliases
        function(alias) {
            return alias.trim();
        });
        if (isEmpty_default()(arr)) {
            return null;
        }
        var aliasElements = arr.map(function(alias, index) {
            if (categoryUrl) {
                return /*#__PURE__*/ react.createElement(react.Fragment, {
                    key: alias
                }, /*#__PURE__*/ react.createElement(AliasLink, {
                    to: categoryUrl,
                    onClick: scrollToTop
                }, alias), arr.length > 2 && index < arr.length - 2 && /*#__PURE__*/ react.createElement(react.Fragment, null, ", "));
            }
            return /*#__PURE__*/ react.createElement(react.Fragment, {
                key: alias
            }, /*#__PURE__*/ react.createElement("span", null, alias), arr.length > 2 && index < arr.length - 2 && /*#__PURE__*/ react.createElement(react.Fragment, null, ", "));
        });
        if (aliasElements.length === 1) {
            return t("category", "product-collection.aliases-single", {
                alias: aliasElements[0]
            });
        }
        return t("category", "product-collection.aliases-plural", {
            aliasesExceptLast: aliasElements.slice(0, aliasElements.length - 1),
            last: aliasElements[aliasElements.length - 1]
        });
    }, [
        t,
        aliases,
        categoryUrl,
        scrollToTop
    ]);
    var hasDescriptionOrAliases = !!(description || aliasLinks);
    return /*#__PURE__*/ react.createElement(DescriptionContainer, null, hasDescriptionOrAliases ? /*#__PURE__*/ react.createElement(DescriptionBox, null, name ? /*#__PURE__*/ react.createElement(DescriptionTitle, null, name) : null, /*#__PURE__*/ react.createElement(DescriptionText, {
        containerProps: {
            "data-test": "CategoryDescription"
        }
    }, description, description && aliasLinks && " ", aliasLinks)) : null);
};
/* harmony default export */ var category_description = (CategoryDescription);


/***/ }),

/***/ 62960:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ compare_products_basket)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(24562);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
;// CONCATENATED MODULE: ./src/components/compare-products-basket/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    width: 760px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 70vh;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  position: fixed;\n  bottom: 0;\n  z-index: ",
        ";\n  max-width: ",
        ";\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);\n\n  ",
        "\n\n  @supports (position: sticky) {\n    position: sticky;\n    width: 100%;\n    left: calc(\n      ",
        " +\n        ",
        "\n    );\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background-color: ",
        ";\n  padding: 10px;\n  cursor: pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 10px;\n\n  svg {\n    display: block;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 5px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  border-bottom: 1px solid ",
        ";\n  padding: 5px 10px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  font-style: italic;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  font-weight: 600;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 0 ",
        ";\n  padding-bottom: ",
        ";\n  box-sizing: border-box;\n  transition: max-height 0.15s\n    ",
        ";\n  overflow: hidden;\n  overflow-y: auto;\n  max-height: ",
        "px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    min-height: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}





var productRowHeight = 55;
var FlexWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FlexWrapper",
    componentId: "sc-0-0"
})(_templateObject());
// Use position: sticky when supported
// otherwise fallback to position: fixed
// and set specific width for desktop viewport size
var Container = styled_components_browser_esm["default"].div.attrs({
    "data-test": "CompareProductsBasket"
}).withConfig({
    displayName: "Container",
    componentId: "sc-0-1"
})(_templateObject2(), zindex/* zindex.menu.sticky.background.isSticky */.Y.menu.sticky.background.isSticky, base/* layout.siteWidth.rem */.bK.siteWidth.rem, base/* media.largeUp */.BC.largeUp(_templateObject1()), base/* layout.sidebarMenuWidth.desktop.rem */.bK.sidebarMenuWidth.desktop.rem, function(p) {
    return p.sidebarOpen ? base/* layout.sidebarContentWidth.desktop.rem */.bK.sidebarContentWidth.desktop.rem : "0px";
});
var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-2"
})(_templateObject3(), function(p) {
    return p.theme.colors.yellove500;
});
var ExpandIcon = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpandIcon",
    componentId: "sc-0-3"
})(_templateObject4());
var ClearButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "ClearButton",
    componentId: "sc-0-4"
})(_templateObject5());
var ProductDeleteButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "ProductDeleteButton",
    componentId: "sc-0-5"
})(_templateObject6());
var InfoBar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InfoBar",
    componentId: "sc-0-6"
})(_templateObject7(), function(p) {
    return p.theme.colors.base200;
});
var InfoText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InfoText",
    componentId: "sc-0-7"
})(_templateObject8(), function(p) {
    return p.theme.colors.base600;
});
var ProductCount = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductCount",
    componentId: "sc-0-8"
})(_templateObject9());
var ProductWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductWrapper",
    componentId: "sc-0-9"
})(_templateObject10(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(props) {
    return props.expanded ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0;
}, function(props) {
    return props.expanded ? "ease-out" : "ease-in";
}, function(props) {
    return props.expanded ? props.count * productRowHeight + productRowHeight : 0;
});
var ProductRow = (0,styled_components_browser_esm["default"])(product_row/* default */.Z).withConfig({
    displayName: "ProductRow",
    componentId: "sc-0-10"
})(_templateObject11());


// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-down/index.js
var chevron_down = __webpack_require__(34783);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-up/index.js
var chevron_up = __webpack_require__(44651);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(56853);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/compare/index.js
var compare = __webpack_require__(34645);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
;// CONCATENATED MODULE: ./src/components/compare-products-basket/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var CompareProductsBasket = function(param) {
    var products = param.products, compareUrl = param.compareUrl, onEmpty = param.onEmpty, onProductDelete = param.onProductDelete;
    var ref = _slicedToArray((0,react.useState)(false), 2), expanded = ref[0], setExpanded = ref[1];
    var toggleExpanded = (0,react.useCallback)(function() {
        return setExpanded(!expanded);
    }, [
        expanded
    ]);
    var stopPropagation = function(e) {
        e.stopPropagation();
    };
    var productsWithImage = (0,react.useMemo)(function() {
        return products.map(function(product) {
            return _objectSpreadProps(_objectSpread({}, product), {
                image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                    name: product.name,
                    src: product.media.first || ""
                })
            });
        });
    }, [
        products
    ]);
    var isSidebarOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.tab != null && state.areas.sidebar.tab !== "none";
    });
    return /*#__PURE__*/ react.createElement(Container, {
        sidebarOpen: isSidebarOpen
    }, /*#__PURE__*/ react.createElement(Header, {
        onClick: toggleExpanded
    }, /*#__PURE__*/ react.createElement(FlexWrapper, null, /*#__PURE__*/ react.createElement(ExpandIcon, null, expanded ? /*#__PURE__*/ react.createElement(chevron_down/* IconChevronDown */.C, null) : /*#__PURE__*/ react.createElement(chevron_up.IconChevronUp, null)), products.length === 0 ? /*#__PURE__*/ react.createElement(InfoText, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "product-compare.choose-products")) : /*#__PURE__*/ react.createElement(ProductCount, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "lists",
        n: products.length
    }, "list.n-products"))), /*#__PURE__*/ react.createElement(variants.OutlinedButton, {
        onClick: stopPropagation,
        container: products.length < 2 ? "button" : react_router_dom/* Link */.rU,
        disabled: true // Won't affect the link ☝️
        ,
        containerProps: {
            "data-test": "CompareButton",
            to: compareUrl
        },
        style: {
            backgroundColor: "white"
        }
    }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, {
        size: 18
    })), /*#__PURE__*/ react.createElement(variants.ButtonText, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "product-compare.compare")))), /*#__PURE__*/ react.createElement(ProductWrapper, {
        count: products.length,
        expanded: expanded
    }, /*#__PURE__*/ react.createElement(InfoBar, null, products.length < 2 && /*#__PURE__*/ react.createElement(InfoText, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "product-compare.choose-more-products")), /*#__PURE__*/ react.createElement(ClearButton, {
        variant: "text",
        color: "link",
        onClick: onEmpty
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "product-compare.cancel-compare"))), productsWithImage.map(function(product) {
        return /*#__PURE__*/ react.createElement(CompareProductsBasketRow, {
            key: product.id,
            product: product,
            onProductDelete: onProductDelete
        });
    })));
};
var CompareProductsBasketRow = function(param) {
    var product = param.product, onProductDelete = param.onProductDelete;
    var productImage = (0,react.useMemo)(function() {
        return /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
            name: product.name,
            src: product.media.first || ""
        });
    }, [
        product.name,
        product.media.first
    ]);
    var onProductClick = (0,react.useCallback)(function(e) {
        return e.preventDefault();
    }, []);
    var onDelete = (0,react.useCallback)(function() {
        return onProductDelete(product.id);
    }, [
        onProductDelete,
        product.id
    ]);
    return /*#__PURE__*/ react.createElement(ProductRow, {
        key: product.id,
        link: product.pathName,
        onClick: onProductClick,
        name: product.name,
        image: productImage,
        price: product.priceSummary.regular || product.priceSummary.alternative,
        showDivider: true
    }, /*#__PURE__*/ react.createElement(ProductDeleteButton, {
        size: "small",
        variant: "icon",
        color: "primary",
        icon: /*#__PURE__*/ react.createElement(icon_close.IconClose, null),
        onClick: onDelete
    }));
};
/* harmony default export */ var compare_products_basket = (CompareProductsBasket);


/***/ }),

/***/ 25687:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ compare_products_toggle)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/compare/index.js
var compare = __webpack_require__(34645);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(71551);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/compare-products-toggle/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  align-self: stretch;\n  outline: none;\n  cursor: pointer;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      box-shadow: 0 0 0 1px ",
        ";\n      color: ",
        ";\n\n      &:active,\n      &:hover,\n      &:focus {\n        background-color: ",
        ";\n        box-shadow: 0 0 0 1px ",
        ";\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  background-color: transparent;\n  ",
        ";\n\n  ",
        ";\n\n  & > span {\n    flex-grow: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  padding: 0 ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: block;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  width: 32px;\n\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var sharedCompareButtonStyled = (0,styled_components_browser_esm.css)(_templateObject());
var CompareProductButtonMobile = (0,styled_components_browser_esm["default"])(variants.OutlinedButton).attrs({
    "data-test": "CompareProductButtonMobile"
}).withConfig({
    displayName: "CompareProductButtonMobile",
    componentId: "sc-0-0"
})(_templateObject2(), sharedCompareButtonStyled, function(props) {
    return props.$selected && (0,styled_components_browser_esm.css)(_templateObject1(), props.theme.bg.productCompare, props.theme.bg.productCompare, props.theme.text.primary, props.theme.bg.productCompare, props.theme.bg.productCompare, props.theme.text.primary);
});
var CompareProductButtonDesktop = styled_components_browser_esm["default"].button.attrs({
    "data-test": "CompareProductButtonDesktop"
}).withConfig({
    displayName: "CompareProductButtonDesktop",
    componentId: "sc-0-1"
})(_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, sharedCompareButtonStyled);
var Title = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(_templateObject5(), base/* media.mediumDown */.BC.mediumDown(_templateObject4()));
var CompareIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CompareIconWrapper",
    componentId: "sc-0-3"
})(_templateObject6(), function(param) {
    var theme = param.theme, active = param.active;
    return active ? theme.bg.productCompare : "transparent";
}, base/* layout.borderRadius */.bK.borderRadius, function(param) {
    var theme = param.theme, active = param.active;
    return active ? theme.colors.base700 : theme.icons.callToAction;
}, function(param) {
    var theme = param.theme, active = param.active;
    return active ? theme.colors.base700 : theme.icons.callToActionHover;
});


;// CONCATENATED MODULE: ./src/components/compare-products-toggle/index.tsx








var CompareProductsToggle = function(param) {
    var active = param.active, activate = param.activate, className = param.className, deactivate = param.deactivate, _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var label = active ? t("product", "product-compare.cancel-compare") : t("product", "product-compare.choose-products");
    return /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Left */.Nm.Left,
        title: label,
        className: className
    }, /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(CompareProductButtonMobile, {
        ariaLabel: label,
        onClick: active ? deactivate : activate,
        $selected: active
    }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, {
        size: 24
    })), showTitle && /*#__PURE__*/ react.createElement(variants.ButtonText, null, t("product", "product-compare.compare")))), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(CompareProductButtonDesktop, {
        onClick: active ? deactivate : activate,
        "aria-label": label
    }, /*#__PURE__*/ react.createElement(CompareIconWrapper, {
        active: active
    }, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, {
        size: 24
    })))));
};
/* harmony default export */ var compare_products_toggle = (/*#__PURE__*/(0,react.memo)(CompareProductsToggle));


/***/ }),

/***/ 57737:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony exports ActionBar, ProductCount */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94141);
/* harmony import */ var src_components_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95088);
/* harmony import */ var src_components_translate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37702);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29261);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55586);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  color: ",
        ";\n  width: 100%;\n  padding: 10px;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n\n  /* Set explicit height in order to account for that height in the wrapper */\n  height: ",
        "px;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ApplyFilterButton = function(param) {
    var _count = param.count, count = _count === void 0 ? 0 : _count, _hasFiltered = param.hasFiltered, hasFiltered = _hasFiltered === void 0 ? true : _hasFiltered, onClick = param.onClick, onClear = param.onClear, _canClear = param.canClear, canClear = _canClear === void 0 ? true : _canClear;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActionBar, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_5__.Column, {
        gap: parseFloat(src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050)
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductCount, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_translate__WEBPACK_IMPORTED_MODULE_4__/* .Translate */ .v, {
        domain: "filter",
        n: count
    }, "result.n-products")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_5__.GridRow, {
        gap: parseFloat(src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050)
    }, onClear && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
        color: "tertiary",
        variant: "outlined",
        onClick: onClear,
        disabled: !canClear
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_translate__WEBPACK_IMPORTED_MODULE_4__/* .Translate */ .v, {
        domain: "filter"
    }, "button.clear-filter")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
        color: "primary",
        onClick: onClick,
        disabled: !hasFiltered
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_translate__WEBPACK_IMPORTED_MODULE_4__/* .Translate */ .v, {
        domain: "filter"
    }, "button.apply-filter")))));
};
/* harmony default export */ __webpack_exports__["ZP"] = (ApplyFilterButton);
var ActionBar = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "ActionBar",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.theme.actionBar.bg;
}, function(p) {
    return p.theme.actionBar.boxShadow;
}, function(p) {
    return p.theme.actionBar.fg;
}, _constants__WEBPACK_IMPORTED_MODULE_6__/* .applyFilterAreaHeight */ .e, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.largeUp */ .BC.largeUp(_templateObject()));
var ProductCount = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "ProductCount",
    componentId: "sc-0-1"
})(_templateObject2());


/***/ }),

/***/ 65304:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fp": () => (/* binding */ OverlayWrapper),
/* harmony export */   "xT": () => (/* binding */ OverlayView)
/* harmony export */ });
/* unused harmony exports Dialog, Header */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55586);
/* harmony import */ var src_components_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95088);
/* harmony import */ var src_components_list_header_list_header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23087);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29261);
/* harmony import */ var _prisjakt_ui_hideable_variants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28285);
/* harmony import */ var _prisjakt_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49452);
/* harmony import */ var src_components_no_scroll__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83464);
/* harmony import */ var src_components_overlay__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34879);
/* harmony import */ var src_ui_zindex__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92873);
/* harmony import */ var _prisjakt_ui_icon_close__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56853);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 0;\n  flex: 1 1 0;\n  background: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: ",
        ";\n  overflow-x: hidden;\n  overflow-y: scroll; /* has to be scroll, not auto */\n  -webkit-overflow-scrolling: touch;\n  /* Makes sure no content is hidden behind the \"apply filter\" area */\n  ::after {\n    content: '';\n    display: block;\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 0;\n  z-index: 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var OverlayWrapper = function(param) {
    var applyButton = param.applyButton, children = param.children, onBack = param.onBack, onClose = param.onClose, _showBackArrow = param.showBackArrow, showBackArrow = _showBackArrow === void 0 ? false : _showBackArrow, title = param.title;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_no_scroll__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        mobile: true,
        tablet: true
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_overlay__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        active: true
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Dialog, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Header, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_list_header_list_header__WEBPACK_IMPORTED_MODULE_4__/* .ListHeader */ .B, {
        title: title,
        onClick: onBack,
        showBackArrow: showBackArrow
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
        color: "quarternary",
        variant: "icon",
        onClick: onClose,
        icon: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_close__WEBPACK_IMPORTED_MODULE_12__.IconClose, null)
    }))), children, applyButton || null));
};
var OverlayView = function(param) {
    var children = param.children, slideDirection = param.slideDirection, visible = param.visible;
    var _obj;
    var Hideable = (_obj = {}, _defineProperty(_obj, _prisjakt_ui__WEBPACK_IMPORTED_MODULE_8__/* .Direction.Left */ .Nm.Left, _prisjakt_ui_hideable_variants__WEBPACK_IMPORTED_MODULE_7__.SlideLeft), _defineProperty(_obj, _prisjakt_ui__WEBPACK_IMPORTED_MODULE_8__/* .Direction.Right */ .Nm.Right, _prisjakt_ui_hideable_variants__WEBPACK_IMPORTED_MODULE_7__.SlideRight), _obj)[slideDirection];
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Hideable, {
        visible: visible,
        speed: _prisjakt_ui__WEBPACK_IMPORTED_MODULE_8__/* .Speed.Fast */ .fD.Fast,
        delayIn: _prisjakt_ui__WEBPACK_IMPORTED_MODULE_8__/* .Delay.Short */ .cN.Short
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_6__.GridRow, {
        gap: parseFloat(src_components_base__WEBPACK_IMPORTED_MODULE_5__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100)
    }, children));
};

var Dialog = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "Dialog",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.bg.primary;
}, src_ui_zindex__WEBPACK_IMPORTED_MODULE_11__/* .zindex.menu.filter */ .Y.menu.filter, _constants__WEBPACK_IMPORTED_MODULE_2__/* .applyFilterAreaHeight */ .e);
var Header = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-1"
})(_templateObject1());


/***/ }),

/***/ 70258:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": () => (/* binding */ SectionItems)
/* harmony export */ });
/* unused harmony export List */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_list_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91441);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var SectionItems = function(props) {
    var filters = props.filters, getCallToActionText = props.getCallToActionText, setCurrentSectionId = props.setCurrentSectionId;
    var onClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(id) {
        return setCurrentSectionId(id);
    }, [
        setCurrentSectionId
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(List, null, filters.map(function(option) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_list_item__WEBPACK_IMPORTED_MODULE_2__/* .ListItem */ .H, {
            key: option.id,
            name: option.title,
            callToActionText: getCallToActionText(option),
            showArrow: true,
            onClick: function() {
                return onClick(option.id);
            }
        });
    }));
};
var List = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "List",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 55586:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ applyFilterAreaHeight)
/* harmony export */ });
var applyFilterAreaHeight = 90;


/***/ }),

/***/ 15679:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": () => (/* binding */ FilterOverlay)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./src/components/filter-overlay/components/apply-button/index.tsx
var apply_button = __webpack_require__(57737);
// EXTERNAL MODULE: ./src/components/filter-overlay/components/overlay.tsx
var overlay = __webpack_require__(65304);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(29261);
;// CONCATENATED MODULE: ./src/components/filter-overlay/styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var SectionSeparator = styled_components_browser_esm["default"].li.attrs({
    role: "presentation"
}).withConfig({
    displayName: "SectionSeparator",
    componentId: "sc-0-0"
})(_templateObject(), base/* colors.borderLightGray */.O9.borderLightGray);
var SectionList = (0,styled_components_browser_esm["default"])(variants.Column).attrs({
    styledComponentProps: {
        as: "ul"
    },
    separator: /*#__PURE__*/ react.createElement(SectionSeparator, null)
}).withConfig({
    displayName: "SectionList",
    componentId: "sc-0-1"
})(_templateObject1());
var FilterSectionSeparator = (0,styled_components_browser_esm["default"])(SectionSeparator).attrs({
    as: "div"
}).withConfig({
    displayName: "FilterSectionSeparator",
    componentId: "sc-0-2"
})(_templateObject2());
var FilterSectionButtonList = (0,styled_components_browser_esm["default"])(SectionList).attrs({
    styledComponentProps: {
        as: "div"
    },
    separator: /*#__PURE__*/ react.createElement(FilterSectionSeparator, null)
}).withConfig({
    displayName: "FilterSectionButtonList",
    componentId: "sc-0-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/filter-overlay/index.tsx





var FilterOverlay = function(props) {
    var allSections = props.allSections, _canClear = props.canClear, canClear = _canClear === void 0 ? false : _canClear, clearFilter = props.clearFilter, _count = props.count, count = _count === void 0 ? 0 : _count, currentSection = props.currentSection, _hasFiltered = props.hasFiltered, hasFiltered = _hasFiltered === void 0 ? false : _hasFiltered, _isSearching = props.isSearching, isSearching = _isSearching === void 0 ? false : _isSearching, onBack = props.onBack, onClose = props.onClose, searchInput = props.searchInput, sectionGroups = props.sectionGroups, sectionItems = props.sectionItems, _showBackArrow = props.showBackArrow, showBackArrow = _showBackArrow === void 0 ? false : _showBackArrow, _showInitialView = props.showInitialView, showInitialView = _showInitialView === void 0 ? true : _showInitialView, title = props.title;
    return /*#__PURE__*/ react.createElement(overlay/* OverlayWrapper */.Fp, {
        applyButton: /*#__PURE__*/ react.createElement(apply_button/* default */.ZP, {
            count: count,
            hasFiltered: hasFiltered,
            onClick: onClose,
            onClear: clearFilter,
            canClear: canClear
        }),
        onBack: onBack,
        onClose: onClose,
        showBackArrow: showBackArrow,
        title: title
    }, /*#__PURE__*/ react.createElement(overlay/* OverlayView */.xT, {
        visible: showInitialView,
        slideDirection: ui/* Direction.Left */.Nm.Left
    }, /*#__PURE__*/ react.createElement(FilterSectionButtonList, null, Boolean(allSections) && searchInput, isSearching && Boolean(allSections) ? allSections : /*#__PURE__*/ react.createElement(react.Fragment, null, sectionItems, " ", sectionGroups))), /*#__PURE__*/ react.createElement(overlay/* OverlayView */.xT, {
        visible: !showInitialView,
        slideDirection: ui/* Direction.Right */.Nm.Right
    }, currentSection));
};


/***/ }),

/***/ 42081:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ layout_buttons)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(21068);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/layout-buttons/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  padding: ",
        "px;\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n    cursor: pointer;\n    position: relative;\n    padding: 6px;\n    background: ",
        ";\n    border-radius: calc(",
        " - 1px);\n    color: ",
        ";\n    &:hover {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var LAYOUT_BUTTON_CONTAINER_PADDING = 2;
var containerRadius = base/* layout.measurements.spacing025 */.bK.measurements.spacing025;
var LayoutButtonContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LayoutButtonContainer",
    componentId: "sc-0-0"
})(_templateObject(), LAYOUT_BUTTON_CONTAINER_PADDING, function(p) {
    return p.theme.bg.tertiary;
}, containerRadius);
var LayoutButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "LayoutButton",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), props.active ? props.theme.bg.primary : "none", containerRadius, function(p) {
        return p.theme.text.primary;
    }, function(p) {
        return p.theme.icons.callToActionHover;
    });
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/view-compact-list/index.js
var view_compact_list = __webpack_require__(77141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/view-grid/index.js
var view_grid = __webpack_require__(40483);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/view-list/index.js
var view_list = __webpack_require__(71282);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/view-column/index.js
var view_column = __webpack_require__(10213);
;// CONCATENATED MODULE: ./src/components/layout-buttons/layout-picker.tsx









var LayoutPicker = function(param) {
    var mode = param.mode, onClick = param.onClick, active = param.active;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var theme = (0,styled_components_browser_esm.useTheme)();
    var iconColor = active ? theme.icons.primary : theme.icons.secondary;
    var setListMode = (0,react.useCallback)(function() {
        return onClick(mode);
    }, [
        mode,
        onClick
    ]);
    return /*#__PURE__*/ react.createElement(LayoutButton, {
        onClick: setListMode,
        "aria-label": t("category", mode === types/* LayoutMode.GRID */.X.GRID ? "product-list.grid-layout-button" : "product-list.list-layout-button"),
        active: active,
        "data-test": "layout-button-".concat(mode)
    }, /*#__PURE__*/ react.createElement(Icon, {
        mode: mode,
        color: iconColor
    }));
};
var Icon = function(param) {
    var mode = param.mode, color = param.color;
    switch(mode){
        case types/* LayoutMode.GRID */.X.GRID:
            return /*#__PURE__*/ react.createElement(view_grid/* IconViewGrid */.M, {
                color: color
            });
        case types/* LayoutMode.LIST */.X.LIST:
            return /*#__PURE__*/ react.createElement(view_list/* IconViewList */.d, {
                color: color
            });
        case types/* LayoutMode.TABLE */.X.TABLE:
            return /*#__PURE__*/ react.createElement(view_column/* IconViewColumn */.n, {
                size: 24,
                color: color
            });
        case types/* LayoutMode.COMPACT_LIST */.X.COMPACT_LIST:
            return /*#__PURE__*/ react.createElement(view_compact_list/* IconViewCompactList */.e, {
                color: color
            });
        default:
            return /*#__PURE__*/ react.createElement(view_list/* IconViewList */.d, {
                color: color
            });
    }
};
/* harmony default export */ var layout_picker = (/*#__PURE__*/(0,react.memo)(LayoutPicker));

;// CONCATENATED MODULE: ./src/components/layout-buttons/index.tsx




var LayoutButtons = function(param) {
    var activeLayout = param.activeLayout, layoutModes = param.layoutModes, setLayout = param.setLayout;
    return layoutModes.length > 1 ? /*#__PURE__*/ react.createElement(LayoutButtonContainer, null, layoutModes.includes(types/* LayoutMode.GRID */.X.GRID) && layoutModes.length > 1 && /*#__PURE__*/ react.createElement(layout_picker, {
        active: activeLayout === types/* LayoutMode.GRID */.X.GRID,
        mode: types/* LayoutMode.GRID */.X.GRID,
        onClick: function() {
            return setLayout(types/* LayoutMode.GRID */.X.GRID);
        }
    }), layoutModes.includes(types/* LayoutMode.LIST */.X.LIST) && layoutModes.length > 1 && /*#__PURE__*/ react.createElement(layout_picker, {
        active: activeLayout === types/* LayoutMode.LIST */.X.LIST,
        mode: types/* LayoutMode.LIST */.X.LIST,
        onClick: setLayout
    }), layoutModes.includes(types/* LayoutMode.COMPACT_LIST */.X.COMPACT_LIST) && layoutModes.length > 1 && /*#__PURE__*/ react.createElement(layout_picker, {
        active: activeLayout === types/* LayoutMode.COMPACT_LIST */.X.COMPACT_LIST,
        mode: types/* LayoutMode.COMPACT_LIST */.X.COMPACT_LIST,
        onClick: setLayout
    }), layoutModes.includes(types/* LayoutMode.TABLE */.X.TABLE) && layoutModes.length > 1 && /*#__PURE__*/ react.createElement(layout_picker, {
        active: activeLayout === types/* LayoutMode.TABLE */.X.TABLE,
        mode: types/* LayoutMode.TABLE */.X.TABLE,
        onClick: setLayout
    })) : null;
};
/* harmony default export */ var layout_buttons = (LayoutButtons);


/***/ }),

/***/ 23087:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": () => (/* binding */ list_header_ListHeader)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(37456);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(59945);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/components/list-header/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  align-items: center;\n  color: inherit;\n  font-size: 1rem;\n\n  /* Set the width and box-sizing to account for inconsistencies between <button> and <a> */\n  box-sizing: border-box;\n  width: 100%;\n\n  &:hover,\n  &.focus-visible {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  flex: 1 0 auto;\n  min-height: 64px;\n  padding: ",
        " ",
        ";\n  padding-right: 0;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  /* Increase specifity to override Hideable flex property */\n  && {\n    align-items: center;\n    flex: 0 0 auto;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-weight: 900;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  box-sizing: content-box;\n  display: flex;\n  justify-content: center;\n  padding: ",
        " ",
        ";\n  padding-left: 0;\n  /* Reserve space for an extra option */\n  width: 34px;\n  height: 34px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var ListHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListHeader",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.theme.colors.base0;
}, function(param) {
    var theme = param.theme;
    return theme.lines.secondary;
}, function(props) {
    return props.theme.bg.secondary;
});
var MainArea = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "MainArea",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.theme.text.primary;
});
var LeftArrowArea = (0,styled_components_browser_esm["default"])(hideable.Hideable).attrs({
    renderWhenHidden: true
}).withConfig({
    displayName: "LeftArrowArea",
    componentId: "sc-0-2"
})(_templateObject2());
var LeftArrow = (0,styled_components_browser_esm["default"])(chevron_left.IconChevronLeft).attrs({
    size: 20
}).withConfig({
    displayName: "LeftArrow",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var HeaderTitle = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "HeaderTitle",
    componentId: "sc-0-4"
})(_templateObject4());
var ExtraContentArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExtraContentArea",
    componentId: "sc-0-5"
})(_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/components/list-header/list-header.tsx


var list_header_ListHeader = function(param) {
    var title = param.title, onClick = param.onClick, children = param.children, _showBackArrow = param.showBackArrow, showBackArrow = _showBackArrow === void 0 ? true : _showBackArrow;
    return /*#__PURE__*/ react.createElement(ListHeader, null, /*#__PURE__*/ react.createElement(MainArea, {
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(LeftArrowArea, {
        visible: showBackArrow
    }, /*#__PURE__*/ react.createElement(LeftArrow, null)), /*#__PURE__*/ react.createElement(HeaderTitle, null, title)), /*#__PURE__*/ react.createElement(ExtraContentArea, null, children));
};


/***/ }),

/***/ 91441:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ ListItem)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40889);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var ListItem = function(param) {
    var children = param.children, name = param.name, link = param.link, image = param.image, callToActionText = param.callToActionText, showArrow = param.showArrow, showBackArrow = param.showBackArrow, _onClick = param.onClick, onClick = _onClick === void 0 ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT : _onClick, className = param.className, isExternal = param.isExternal, linkAttributes = param.linkAttributes, dataTest = param["data-test"], disabled = param.disabled;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ListItem */ .HC, _extends({
        onClick: onClick,
        className: className,
        to: link,
        isExternal: isExternal
    }, linkAttributes || {}, {
        "data-test": dataTest,
        disabled: disabled
    }), showBackArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .LeftArrow */ .IT, null), image && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, null, image), children, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Name */ .VG, null, name), callToActionText && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .CallToAction */ .Jd, null, callToActionText), showArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RightArrow */ .UV, null));
};


/***/ }),

/***/ 40889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": () => (/* binding */ Image),
/* harmony export */   "HC": () => (/* binding */ ListItem),
/* harmony export */   "IT": () => (/* binding */ LeftArrow),
/* harmony export */   "Jd": () => (/* binding */ CallToAction),
/* harmony export */   "UV": () => (/* binding */ RightArrow),
/* harmony export */   "VG": () => (/* binding */ Name)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37456);
/* harmony import */ var _prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93345);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89218);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21541);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: default;\n      opacity: 0.5;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  min-height: 48px;\n  padding: ",
        " ",
        ";\n  text-align: left;\n  display: flex;\n  align-items: center;\n\n  /* Set the width and box-sizing to account for inconsistencies between <button> and <a> */\n  box-sizing: border-box;\n  width: 100%;\n\n  &:hover,\n  &.focus-visible {\n    background-color: ",
        ";\n    outline: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  flex: 0 1 50%;\n  margin-left: ",
        ";\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-left: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-right: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var padding = src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
var ListItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.theme.text.primary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, padding, function(props) {
    return props.theme.bg.secondary;
}, function(props) {
    return props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
});
var Image = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(_templateObject2(), padding);
var Name = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.TitleSmallText).withConfig({
    displayName: "Name",
    componentId: "sc-0-2"
})(_templateObject3());
var CallToAction = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "CallToAction",
    componentId: "sc-0-3"
})(_templateObject4(), function(props) {
    return props.theme.text.callToAction;
}, padding);
var RightArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__.IconChevronRight).attrs({
    size: 20
}).withConfig({
    displayName: "RightArrow",
    componentId: "sc-0-4"
})(_templateObject5(), padding);
var LeftArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__.IconChevronLeft).attrs({
    size: 20
}).withConfig({
    displayName: "LeftArrow",
    componentId: "sc-0-5"
})(_templateObject6(), padding);


/***/ }),

/***/ 2836:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": () => (/* binding */ NoResults)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/no-results/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: left;\n  padding: 0 ",
        ";\n  margin: ",
        " 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledNoResult = (0,styled_components_browser_esm["default"])(list_variants.Column).withConfig({
    displayName: "StyledNoResult",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledTitle = styled_components_browser_esm["default"].p.withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);

;// CONCATENATED MODULE: ./src/components/no-results/index.tsx




var NoResults = function(props) {
    var content = props.content, title = props.title;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    return /*#__PURE__*/ react.createElement(StyledNoResult, {
        gap: 1
    }, /*#__PURE__*/ react.createElement(variants.BodyMediumText, null, /*#__PURE__*/ react.createElement(StyledTitle, null, title), content), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledImage, {
        src: "".concat(market.cdn, "/g/rfe/illustrations/no-search-result-illustration-309x229px.png"),
        srcSet: "".concat(market.cdn, "/g/rfe/illustrations/no-search-result-illustration-309x229px.png 1x, ").concat(market.cdn, "/g/rfe/illustrations/no-search-result-illustration-618x458px.png 2x"),
        alt: t("product", "results.no-product-found")
    })));
};


/***/ }),

/***/ 49192:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": () => (/* binding */ NumberPagination)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-items.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function notNull(item) {
    return item !== null;
}
function getPrevPageItem(currentPage, alwaysShowStepButtons) {
    if (currentPage === 1 && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "prev",
        pageNumber: currentPage - 1,
        disabled: currentPage === 1
    };
}
function getFirstPageItem(nearbyPages) {
    var _Math;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    if (firstNearbyPage === 1) {
        return null;
    }
    return {
        type: "first",
        pageNumber: 1,
        indicateOmittedPages: firstNearbyPage > 2 ? "after" : undefined
    };
}
function getNearbyPages(currentPage, totalPages) {
    var from = Math.max(1, Math.min(totalPages - 4, currentPage - 2));
    var to = Math.min(totalPages, Math.max(5, currentPage + 2));
    var pages = [];
    for(var i = from; i <= to; i += 1){
        var page = {
            type: "nearby-page",
            pageNumber: i,
            isCurrent: currentPage === i
        };
        if ([
            from,
            to
        ].includes(i) && !page.isCurrent) {
            page.omitOnSmallDevices = true;
        }
        pages.push(page);
    }
    return pages;
}
var getMidrangePage = function(position, nearbyPages, totalPages) {
    var _Math, _Math1;
    var threshold = 5;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    var lastNearByPage = (_Math1 = Math).max.apply(_Math1, _toConsumableArray(nearbyPages));
    switch(position){
        case "before":
            if (firstNearbyPage < threshold) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.ceil(firstNearbyPage / 2),
                indicateOmittedPages: "after"
            };
        case "after":
            if (lastNearByPage + threshold > totalPages) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.floor((totalPages - lastNearByPage) / 2) + lastNearByPage,
                indicateOmittedPages: "before"
            };
        default:
            return null;
    }
};
function getLastPageItem(nearbyPages, totalPages) {
    var _Math;
    var lastNearbyPage = (_Math = Math).max.apply(_Math, _toConsumableArray(nearbyPages));
    if (lastNearbyPage === totalPages) {
        return null;
    }
    return {
        type: "last",
        pageNumber: totalPages,
        indicateOmittedPages: lastNearbyPage < totalPages - 1 ? "before" : undefined
    };
}
function getNextPageItem(currentPage, totalPages, alwaysShowStepButtons) {
    if (currentPage === totalPages && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "next",
        pageNumber: currentPage + 1,
        disabled: currentPage === totalPages
    };
}
function getPaginationItems(currentPage, totalPages) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _alwaysShowStepButtons = ref.alwaysShowStepButtons, alwaysShowStepButtons = _alwaysShowStepButtons === void 0 ? false : _alwaysShowStepButtons;
    if (totalPages <= 1) {
        return [];
    }
    var clampedCurrentPage = Math.max(1, Math.min(totalPages, currentPage));
    var nearbyPages = getNearbyPages(clampedCurrentPage, totalPages);
    var nearbyPageNrs = nearbyPages.map(function(page) {
        return page.pageNumber;
    });
    return [
        getPrevPageItem(clampedCurrentPage, alwaysShowStepButtons),
        getFirstPageItem(nearbyPageNrs),
        getMidrangePage("before", nearbyPageNrs, totalPages)
    ].concat(_toConsumableArray(nearbyPages), [
        getMidrangePage("after", nearbyPageNrs, totalPages),
        getLastPageItem(nearbyPageNrs, totalPages),
        getNextPageItem(clampedCurrentPage, totalPages, alwaysShowStepButtons)
    ]).filter(notNull);
}

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/number-pagination/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: ",
        ";\n      margin-right: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n\n    ",
        "\n\n    @media screen and (max-width: 420px) {\n      ",
        "\n\n      @media screen and (max-width: 350px) {\n        margin: 0 ",
        " 0 0;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  border-radius: 8px;\n  display: flex;\n  font-weight: 600;\n  height: 30px;\n  justify-content: center;\n  min-width: 30px;\n  padding: ",
        ";\n  transition: all ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n\n  &:hover,\n  &.focus-visible {\n    background: ",
        ";\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  box-shadow: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  background: ",
        ";\n  color: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var measurements = base/* layout.measurements */.bK.measurements, animations = base/* layout.animations */.bK.animations;
var Pagination = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "Pagination",
    componentId: "sc-0-0"
})(_templateObject());
var PaginationListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "PaginationListItem",
    componentId: "sc-0-1"
})(function(param) {
    var indicateOmittedPages = param.indicateOmittedPages, omitOnSmallDevices = param.omitOnSmallDevices;
    return (0,styled_components_browser_esm.css)(_templateObject2(), indicateOmittedPages === "before" ? measurements.spacing150 : 0, indicateOmittedPages === "after" ? measurements.spacing150 : measurements.spacing025, base/* media.smallOnly */.BC.smallOnly(_templateObject1(), indicateOmittedPages === "before" ? measurements.spacing050 : 0, indicateOmittedPages === "after" ? measurements.spacing050 : measurements.spacing025), omitOnSmallDevices ? "display: none;" : "", measurements.spacing025);
});
var paginationLinkStyles = (0,styled_components_browser_esm.css)(_templateObject4(), measurements.spacing050, animations.buttonTransition, base/* media.smallOnly */.BC.smallOnly(_templateObject3(), measurements.spacing025));
var PaginationLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "PaginationLink",
    componentId: "sc-0-2"
})(_templateObject5(), paginationLinkStyles, function(props) {
    return props.theme.colors.base800;
}, function(props) {
    return props.theme.colors.base200;
}, function(props) {
    return "transparent 0px 0px ".concat(props.theme.colors.base800, " 0px 0px 0px 1px");
});
var DisabledPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "DisabledPaginationLink",
    componentId: "sc-0-3"
})(_templateObject6(), paginationLinkStyles, function(props) {
    return "inset 0 0 0 1px ".concat(props.theme.lines.primary);
}, function(props) {
    return props.theme.text.quaternary;
}, function(props) {
    return props.theme.bg.secondary;
});
var CurrentPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CurrentPaginationLink",
    componentId: "sc-0-4"
})(_templateObject7(), paginationLinkStyles, function(props) {
    return props.theme.colors.maybeBlue500;
}, function(props) {
    return props.theme.colors.base0;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(37456);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-item.tsx





var PaginationItem = function(param) {
    var item = param.item, linkToPage = param.linkToPage, onClick = param.onClick;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var label = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, null);
            case "next":
                return /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null);
            default:
                return /*#__PURE__*/ react.createElement(react.Fragment, null, item.pageNumber);
        }
    }, [
        item.type,
        item.pageNumber
    ]);
    var ariaLabel = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return t("symbols", "symbol.show-prev-page");
            case "next":
                return t("symbols", "symbol.show-next-page");
            default:
                return t("common", "pagination.page-number", {
                    number: item.pageNumber
                });
        }
    }, [
        item.type,
        item.pageNumber,
        t
    ]);
    var onClickHandler = (0,react.useCallback)(function() {
        return typeof onClick === "function" && onClick(item);
    }, [
        item,
        onClick
    ]);
    if (item.disabled) {
        return /*#__PURE__*/ react.createElement(DisabledPaginationLink, null, label);
    }
    if (item.isCurrent) {
        return /*#__PURE__*/ react.createElement(CurrentPaginationLink, {
            "data-test": "CurrentPaginationLink"
        }, label);
    }
    return /*#__PURE__*/ react.createElement(PaginationLink, {
        to: linkToPage(item.pageNumber),
        "data-test": "PaginationLink",
        "data-test-page": item.pageNumber,
        onClick: onClickHandler,
        "aria-label": ariaLabel
    }, label);
};
/* harmony default export */ var pagination_item = (PaginationItem);

;// CONCATENATED MODULE: ./src/components/number-pagination/index.tsx




var NumberPagination = function(param) {
    var currentPage = param.currentPage, totalPages = param.totalPages, linkToPage = param.linkToPage, onClick = param.onClick, alwaysShowStepButtons = param.alwaysShowStepButtons;
    var paginationItems = (0,react.useMemo)(function() {
        return getPaginationItems(currentPage, totalPages, {
            alwaysShowStepButtons: alwaysShowStepButtons
        });
    }, [
        currentPage,
        totalPages,
        alwaysShowStepButtons
    ]);
    return /*#__PURE__*/ react.createElement(Pagination, {
        "data-test": "Pagination"
    }, paginationItems.map(function(item) {
        return /*#__PURE__*/ react.createElement(PaginationListItem, {
            key: "".concat(item.type, ":").concat(item.pageNumber),
            indicateOmittedPages: item.indicateOmittedPages,
            omitOnSmallDevices: item.omitOnSmallDevices
        }, /*#__PURE__*/ react.createElement(pagination_item, {
            item: item,
            linkToPage: linkToPage,
            onClick: onClick
        }));
    }));
};


/***/ }),

/***/ 53692:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mr": () => (/* reexport */ SIZE),
  "WX": () => (/* binding */ ProductCheckbox),
  "lo": () => (/* reexport */ hoverStyle)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/check/index.js
var check = __webpack_require__(24300);
;// CONCATENATED MODULE: ./src/components/product-checkbox/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  box-shadow: inset 0 0 0 2px ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  align-self: center;\n  background: ",
        ";\n  box-shadow: inset 0 0 0 1px ",
        ";\n  color: ",
        ";\n  border-radius: 3px;\n  cursor: pointer;\n  height: ",
        "px;\n  width: ",
        "px;\n  flex: 0 0 auto;\n  transition:\n    0.05s box-shadow linear,\n    0.05s background-color linear;\n\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  appearance: none;\n  outline: 0;\n  opacity: 0;\n  position: absolute;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SIZE = 20;
var hoverStyle = (0,styled_components_browser_esm.css)(_templateObject(), function(props) {
    return props.theme.bg.productCompare;
});
var Wrapper = styled_components_browser_esm["default"].label.attrs({
    "data-test": "ProductCheckbox"
}).withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.selected ? props.theme.bg.productCompare : "transparent";
}, function(props) {
    return props.theme.bg.productCompare;
}, function(props) {
    return props.theme.colors.base0;
}, SIZE, SIZE, hoverStyle);
var Input = styled_components_browser_esm["default"].input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "Input",
    componentId: "sc-0-1"
})(_templateObject2());
var Icon = (0,styled_components_browser_esm["default"])(check/* IconCheck */.N).attrs({
    size: SIZE
}).withConfig({
    displayName: "Icon",
    componentId: "sc-0-2"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/product-checkbox/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var ProductCheckbox = function(_param) {
    var selected = _param.selected, name = _param.name, onSelect = _param.onSelect, onDeselect = _param.onDeselect, wrapperProps = _objectWithoutProperties(_param, [
        "selected",
        "name",
        "onSelect",
        "onDeselect"
    ]);
    var onChange = (0,react.useCallback)(function(e) {
        return e.target.checked ? onSelect === null || onSelect === void 0 ? void 0 : onSelect() : onDeselect === null || onDeselect === void 0 ? void 0 : onDeselect();
    }, [
        onSelect,
        onDeselect
    ]);
    return /*#__PURE__*/ react.createElement(Wrapper, _extends({
        selected: selected
    }, wrapperProps), /*#__PURE__*/ react.createElement(Input, {
        id: name,
        name: name,
        type: "checkbox",
        checked: selected,
        onChange: onChange,
        tabIndex: 0,
        value: selected ? "1" : "0"
    }), selected && /*#__PURE__*/ react.createElement(Icon, null));
};


/***/ }),

/***/ 24562:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ product_row)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(75695);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/product-checkbox/index.tsx + 1 modules
var product_checkbox = __webpack_require__(53692);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/product-row/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 5px 10px;\n  outline: none;\n\n  :hover::after,\n  :focus::after {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        padding-left: ",
        "px;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "::before {\n        ",
        "\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  line-height: 1.2em;\n  min-height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  .pj-ui-product-core-properties {\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n  background: ",
        ";\n  border-radius: ",
        ";\n\n  .pj-ui-product-image {\n    display: block;\n    max-width: 40px;\n    max-height: 40px;\n    width: auto;\n    height: auto;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 100%;\n  margin-right: 3px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  :not(:last-child) {\n    margin-bottom: 1px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  margin-left: 10px;\n  white-space: nowrap;\n  text-align: right;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  font-size: 12px;\n  color: ",
        ";\n  fill: ",
        ";\n  align-items: center;\n\n  svg {\n    height: 16px !important;\n    width: 16px !important;\n    margin-left: 2px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: ",
        ";\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n\n  ",
        ":hover & {\n    ",
        "\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  min-width: 80px;\n  margin: ",
        ";\n  display: flex;\n  justify-content: end;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: -",
        ";\n  z-index: 2;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-0"
})(_templateObject(), base/* styledUtils.overlay */.au.overlay());
var Row = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductRow"
}).withConfig({
    displayName: "Row",
    componentId: "sc-0-1"
})(_templateObject4(), function(props) {
    return props.showDivider && (0,styled_components_browser_esm.css)(_templateObject1(), function(p) {
        return p.theme.lines.primary;
    });
}, function(props) {
    return props.selectable && (0,styled_components_browser_esm.css)(_templateObject2(), ProductLink, product_checkbox/* PRODUCT_CHECKBOX_SIZE */.mr + (0,base/* pixelCalc */.A)(base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
}, function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject3(), ProductLink, base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
});
var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-2"
})(_templateObject5(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var BasicInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BasicInfo",
    componentId: "sc-0-3"
})(_templateObject6());
var ProductName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductName",
    componentId: "sc-0-4"
})(_templateObject7());
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-5"
})(_templateObject8(), function(p) {
    return p.theme.text.tertiary;
});
var PriceLabelWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "PriceLabelWrapper",
    componentId: "sc-0-6"
})(_templateObject9());
var StoreCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StoreCount",
    componentId: "sc-0-7"
})(_templateObject10(), function(p) {
    return p.theme.text.tertiary;
}, function(p) {
    return p.theme.icons.tertiary;
});
var Gutter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Gutter",
    componentId: "sc-0-8"
})(_templateObject11());
var SelectBox = (0,styled_components_browser_esm["default"])(product_checkbox/* ProductCheckbox */.WX).withConfig({
    displayName: "SelectBox",
    componentId: "sc-0-9"
})(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Row, product_checkbox/* productCheckboxHoverStyle */.lo);
var CampaignBadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CampaignBadgeWrapper",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CampaignBadge = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CampaignBadge",
    componentId: "sc-0-11"
})(_templateObject14(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/shopping-cart/index.js
var shopping_cart = __webpack_require__(54497);
;// CONCATENATED MODULE: ./src/components/product-row/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var ProductRow = function(param) {
    var onClick = param.onClick, linkAttributes = param.linkAttributes, _link = param.link, link = _link === void 0 ? "" : _link, image = param.image, name = param.name, rating = param.rating, subtitle = param.subtitle, campaignBadge = param.campaignBadge, ratingCount = param.ratingCount, _ratingCountTranslation = param.ratingCountTranslation, ratingCountTranslation = _ratingCountTranslation === void 0 ? {
        domain: "product",
        key: "product-card.n-ratings"
    } : _ratingCountTranslation, price = param.price, storesCount = param.storesCount, storesCountText = param.storesCountText, children = param.children, className = param.className, showDivider = param.showDivider, selectable = param.selectable, selected = param.selected, onSelect = param.onSelect, onDeselect = param.onDeselect;
    var onToggle = selected ? onDeselect : onSelect;
    var clickHandler = (0,react.useCallback)(function(e) {
        if (selectable) {
            e.preventDefault();
            onToggle === null || onToggle === void 0 ? void 0 : onToggle();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [
        selectable,
        onToggle,
        onClick
    ]);
    return /*#__PURE__*/ react.createElement(Row, {
        className: className,
        showDivider: showDivider,
        selectable: selectable,
        selected: selected
    }, /*#__PURE__*/ react.createElement(ProductLink, _extends({
        onClick: clickHandler
    }, linkAttributes || {}, {
        to: link,
        "aria-label": name
    }), image && /*#__PURE__*/ react.createElement(ProductImage, null, image), /*#__PURE__*/ react.createElement(BasicInfo, null, /*#__PURE__*/ react.createElement(ProductName, null, name), rating ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        hide: rating === null,
        rate: rating,
        showRate: true,
        size: "small",
        count: ratingCount,
        countTranslation: ratingCountTranslation,
        showCounter: true
    }) : null, subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle)), campaignBadge && /*#__PURE__*/ react.createElement(CampaignBadgeWrapper, null, /*#__PURE__*/ react.createElement(CampaignBadge, null, campaignBadge)), price && /*#__PURE__*/ react.createElement(PriceLabelWrapper, null, /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price
    }), storesCount !== null && /*#__PURE__*/ react.createElement(StoreCount, {
        title: storesCountText
    }, /*#__PURE__*/ react.createElement("span", null, storesCount), " ", /*#__PURE__*/ react.createElement(shopping_cart/* IconShoppingCart */.w, {
        color: "base500"
    })))), children && /*#__PURE__*/ react.createElement(Gutter, null, children), selectable && /*#__PURE__*/ react.createElement(SelectBox, {
        selected: selected,
        onSelect: onSelect,
        onDeselect: onDeselect,
        "aria-label": name
    }));
};
/* harmony default export */ var product_row = (ProductRow);


/***/ }),

/***/ 63536:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": () => (/* binding */ ProductsHeader)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/products-header/components/header-row/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      display: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: baseline;\n\n  > a {\n    text-decoration: underline;\n    line-height: 1.4;\n\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  margin-right: ",
        ";\n  margin-bottom: 0;\n  flex-grow: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: space-between;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    width: 100%;\n    grid-column-gap: ",
        ";\n    align-items: center;\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-column-gap: ",
        ";\n  align-items: center;\n  grid-auto-flow: column;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TitleWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var TitleFlex = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TitleFlex",
    componentId: "sc-0-1"
})(_templateObject2(), base/* media.smallDown */.BC.smallDown(_templateObject1()));
var Title = (0,styled_components_browser_esm["default"])(variants.H3Text).withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Subtitle = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-3"
})(_templateObject4());
var HeaderRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HeaderRow",
    componentId: "sc-0-4"
})(function() {
    return (0,styled_components_browser_esm.css)(_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(_templateObject5()));
});
var DisplayOptions = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DisplayOptions",
    componentId: "sc-0-5"
})(_templateObject7(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/areas/search/components/sorted-by/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledTestsAndGuidesLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "StyledTestsAndGuidesLink",
    componentId: "sc-0-0"
})(styles_templateObject(), light_theme_colors.maybeBlue700);

// EXTERNAL MODULE: ./src/areas/search/types.ts
var types = __webpack_require__(78082);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/areas/search/components/hash-navigation.tsx





var TestsAndGuidesLink = function(param) {
    var count = param.count;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var history = (0,react_router_dom/* useHistory */.k6)();
    var location = (0,react_router_dom/* useLocation */.TH)();
    (0,react.useEffect)(function() {
        var clearHashNavWithDelay = function() {
            if (location.hash === types/* TabAnchor.TESTS */.X.TESTS) {
                var searchQuery = location.search;
                setTimeout(function() {
                    history.replace("".concat(location.pathname).concat(searchQuery));
                }, 1000);
            }
        };
        window === null || window === void 0 ? void 0 : window.addEventListener("hashchange", clearHashNavWithDelay);
        return function() {
            window === null || window === void 0 ? void 0 : window.removeEventListener("hashchange", clearHashNavWithDelay);
        };
    }, [
        location.hash,
        location.search,
        history
    ]);
    if (count <= 0) return null;
    return /*#__PURE__*/ react.createElement(StyledTestsAndGuidesLink, {
        href: types/* TabAnchor.TESTS */.X.TESTS,
        "data-test": "srp-expert-and-guide-button"
    }, "".concat(t("search", "search.buy-advice-guides"), " (").concat(count, ")"));
};

;// CONCATENATED MODULE: ./src/components/products-header/components/header-row/index.tsx



var header_row_HeaderRow = function(props) {
    var className = props.className, dataBotify = props.dataBotify, displayOptions = props.displayOptions, sortOptions = props.sortOptions, subtitle = props.subtitle, title = props.title, testsAndGuidesCount = props.testsAndGuidesCount;
    return /*#__PURE__*/ react.createElement(HeaderRow, {
        className: className,
        "data-test": "ProductsHeader"
    }, title || subtitle ? /*#__PURE__*/ react.createElement(TitleWrapper, {
        "data-test": "ProductsHeaderTitleWrapper"
    }, /*#__PURE__*/ react.createElement(TitleFlex, null, title && /*#__PURE__*/ react.createElement(Title, {
        "data-botify": dataBotify
    }, title), /*#__PURE__*/ react.createElement(TestsAndGuidesLink, {
        count: testsAndGuidesCount || 0
    })), subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle)) : null, sortOptions !== null && sortOptions !== void 0 ? sortOptions : null, displayOptions ? /*#__PURE__*/ react.createElement(DisplayOptions, null, displayOptions) : null);
};

;// CONCATENATED MODULE: ./src/components/products-header/index.tsx


var ProductsHeader = function(props) {
    var children = props.children, className = props.className, dataBotify = props.dataBotify, displayOptions = props.displayOptions, sortOptions = props.sortOptions, subtitle = props.subtitle, title = props.title, testsAndGuidesCount = props.testsAndGuidesCount;
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(header_row_HeaderRow, {
        className: className,
        "data-botify": dataBotify,
        displayOptions: displayOptions,
        sortOptions: sortOptions,
        subtitle: subtitle,
        title: title,
        testsAndGuidesCount: testsAndGuidesCount
    }), children);
};


/***/ }),

/***/ 10215:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": () => (/* binding */ SecondarySearchField)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_input_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16133);
/* harmony import */ var _prisjakt_ui_icon_magnifier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83830);



var SecondarySearchField = function(param) {
    var _autoFocus = param.autoFocus, autoFocus = _autoFocus === void 0 ? false : _autoFocus, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, placeholder = param.placeholder, onChange = param.onChange, value = param.value;
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(val) {
        return onChange(val);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        "data-test": "SecondarySearchField"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_input_variants__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .II, {
        fullWidth: fullWidth,
        icon: _prisjakt_ui_icon_magnifier__WEBPACK_IMPORTED_MODULE_2__/* .IconMagnifier */ .j,
        clearable: true,
        onChangeHandler: handleChange,
        value: value,
        placeHolder: placeholder,
        type: "text",
        containerProps: {
            autoFocus: autoFocus
        }
    }));
};


/***/ }),

/***/ 55330:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ word_cloud)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/product-collection/tracking.ts + 2 modules
var tracking = __webpack_require__(91567);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(83830);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/components/word-cloud/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0;\n  max-width: 250px;\n  margin: 4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        ";\n  overflow: hidden;\n  max-width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var Title = (0,styled_components_browser_esm["default"])(text_variants.H3Text).withConfig({
    displayName: "Title",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ShowMoreButton = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ShowMoreButton",
    componentId: "sc-0-1"
})(_templateObject1());
var ShowMoreIcon = (0,styled_components_browser_esm["default"])(chevron_right.IconChevronRight).attrs({
    size: 16
}).withConfig({
    displayName: "ShowMoreIcon",
    componentId: "sc-0-2"
})(_templateObject2());
var List = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "List",
    componentId: "sc-0-3"
})(_templateObject3());
var ListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/components/word-cloud/index.tsx









var WordCloud = function(param) {
    var title = param.title, items = param.items, showMoreUrl = param.showMoreUrl, numberOfVisibleItems = param.numberOfVisibleItems, className = param.className;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var onClickWord = (0,react.useCallback)(function(event, index) {
        var href = event.currentTarget.getAttribute("href");
        (0,tracking/* trackProductCollectionWordCloudClick */._P)(href);
        (0,tracking_tracking/* trackInternalNavigationClick */.p)({
            scope: tracking_tracking/* InternalNavigationScope.WORD_CLOUD */.U.WORD_CLOUD,
            nextPage: href,
            index: index
        });
    }, []);
    var onClickShowMore = (0,react.useCallback)(function(event) {
        var href = event.currentTarget.getAttribute("href");
        (0,tracking/* trackProductCollectionWordCloudClick */._P)(href);
        (0,tracking_tracking/* trackInternalNavigationClick */.p)({
            scope: tracking_tracking/* InternalNavigationScope.WORD_CLOUD */.U.WORD_CLOUD,
            nextPage: href
        });
    }, []);
    var wordCloudItems = numberOfVisibleItems ? items.slice(0, numberOfVisibleItems) : items;
    return /*#__PURE__*/ react.createElement("div", {
        className: className
    }, /*#__PURE__*/ react.createElement(Title, null, title), /*#__PURE__*/ react.createElement(List, null, wordCloudItems.map(function(param, index) {
        var name = param.name, url = param.url;
        return /*#__PURE__*/ react.createElement(ListItem, {
            key: url
        }, /*#__PURE__*/ react.createElement(variants.TonalButton, {
            size: variants.ButtonSize.SMALL,
            onClick: function(e) {
                return onClickWord(e, index);
            },
            container: clickable/* Clickable */.P,
            containerProps: {
                to: url,
                title: name
            },
            fullWidth: true
        }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(magnifier/* IconMagnifier */.j, null)), /*#__PURE__*/ react.createElement(variants.ButtonText, {
            behavior: ui_text.Behavior.OnelineEllipsis
        }, name)));
    }), showMoreUrl && /*#__PURE__*/ react.createElement(ShowMoreButton, null, /*#__PURE__*/ react.createElement(variants.TonalButton, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: showMoreUrl
        },
        onClick: onClickShowMore,
        size: variants.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(variants.ButtonText, null, t("common", "button.show-more")), /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(ShowMoreIcon, null))))));
};
/* harmony default export */ var word_cloud = (WordCloud);


/***/ }),

/***/ 51836:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ useCompareProductsSelection)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var MAX_PRODUCTS_TO_COMPARE = 40;
/**
 * Does not store state in a context or anything like that, so you cannot use
 * it multiple times in the same context/page and expect state to be shared across usages
 */ var useCompareProductsSelection = function() {
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), isSelectingProducts = ref[0], setIsSelectingProducts = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), 2), selectedProducts = ref1[0], setSelectedProducts = ref1[1];
    var startProductSelection = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsSelectingProducts(true);
    }, []);
    var abortProductSelection = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsSelectingProducts(false);
        setSelectedProducts([]);
    }, []);
    var selectProduct = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(product) {
        if (selectedProducts.some(function(param) {
            var id = param.id;
            return id === product.id;
        }) || selectedProducts.length > MAX_PRODUCTS_TO_COMPARE) {
            return;
        }
        var products = _toConsumableArray(selectedProducts).concat([
            product
        ]);
        setSelectedProducts(products);
    }, [
        selectedProducts
    ]);
    var deselectProduct = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(product) {
        var products = selectedProducts.filter(function(param) {
            var id = param.id;
            return id !== product.id;
        });
        setSelectedProducts(products);
    }, [
        selectedProducts
    ]);
    return {
        isSelectingProducts: isSelectingProducts,
        selectedProducts: selectedProducts,
        startProductSelection: startProductSelection,
        abortProductSelection: abortProductSelection,
        selectProduct: selectProduct,
        deselectProduct: deselectProduct
    };
};


/***/ }),

/***/ 60392:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D8": () => (/* binding */ useSponsoredInMixedContent),
/* harmony export */   "Ih": () => (/* binding */ useKWLPDeprioritizeNoImageOffers),
/* harmony export */   "L1": () => (/* binding */ useSponsoredContent),
/* harmony export */   "RY": () => (/* binding */ useAllProductsFilter)
/* harmony export */ });
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25349);

/**
 * RFE no longer runs experiments — new ones live in the Next.js app
 * (services/web-app/docs/experiments.md). Each hook below returns what the
 * runtime resolved to when it was removed, so nothing changed for users; the
 * assignment, exposure tracking and store reads are simply gone.
 *
 * The store is configured **per market**, and the removed
 * `createExperimentHook` fell back to its baseline for any experiment missing
 * from the current market's config:
 *
 * ```ts
 * return variantName && variantName in variants ? variants[variantName] : baseline;
 * ```
 *
 * So an experiment at 100% in `se` alone was still baseline everywhere else,
 * and a hook pinned to a single constant would silently switch it on in the
 * other six markets. The two experiments that were live are therefore pinned
 * per market, against the store config as published.
 *
 * Review and e2e environments render these the same as production. The old
 * always-baseline-in-review behavior was a side effect of blanking the
 * experiment store there; these are shipped outcomes now, not experiments, so
 * review deliberately shows what production shows.
 */ /** `market.code` values where an experiment was active at 100%. */ function useEnabledInMarkets(markets) {
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_0__/* .useAppContext */ .bp)().market;
    return markets.includes(market.code);
}
/** `kwlp-deprioritize-no-image-offers` — absent from every market; baseline. */ var useKWLPDeprioritizeNoImageOffers = function() {
    return false;
};
/** `search-page-all-products-searchable` — absent from every market; baseline. */ var useAllProductsFilter = function() {
    return false;
};
/**
 * `sponsored-in-mixed` — active with `distribution: { show: 1 }` in `se` only.
 * Every other market had no entry, so it resolved to the `false` baseline.
 *
 * The ignored parameter survives because its one call site still passes the
 * old `shouldSetAsViewed` argument.
 */ var useSponsoredInMixedContent = function() {
    var _shouldSetAsViewed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    return useEnabledInMarkets([
        "se"
    ]);
};
/**
 * `native-ads-pc` — active with `distribution: { show: 1 }` in `dk`, `fi`, `no`
 * and `se`. Absent in `fr`, `gb` and `nz`, where it resolved to the `false`
 * baseline.
 */ var useSponsoredContent = function() {
    return useEnabledInMarkets([
        "dk",
        "fi",
        "no",
        "se"
    ]);
};


/***/ }),

/***/ 65620:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var RouteContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    dispatch: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    dispatchAggregationAction: function() {},
    currentRouteState: {}
});
/* harmony default export */ __webpack_exports__["Z"] = (RouteContext);


/***/ }),

/***/ 12650:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F3": () => (/* binding */ chunkArray),
/* harmony export */   "OS": () => (/* binding */ discriminatedArrayToMap)
/* harmony export */ });
/* unused harmony export waitForCondition */
/**
 * @example
 * ```ts
 * type DiscriminatedObjects = { type: 'a', a: 1 } | { type: 'b', b: 2 };
 * type DiscriminatingKey = 'type';
 *
 * type Result = DiscriminatedToMap<DiscriminatedObjects, DiscriminatingKey>;
 * // Result = { a?: { type: 'a', a: 1 } | undefined, b?: { type: 'b', b: 2 } | undefined }
 * ```
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * @example
 * ```ts
 * const arr = [
 *  { type: 'a', a: 1 },
 *  { type: 'b', b: 2 },
 *  { type: 'c', c: 3 },
 * ];
 *
 * const map = discriminatedArrayToMap(arr, 'type');
 * // map = { a: { type: 'a', a: 1 }, b: { type: 'b', b: 2 }, c: { type: 'c', c: 3 } }
 * ```
 */ function discriminatedArrayToMap(arr, key) {
    return arr.reduce(function(map, item) {
        if (key in item) {
            // eslint-disable-next-line no-param-reassign
            map[item[key]] = item;
        }
        return map;
    }, {});
}
/**
 * @example
 * ```ts
 * const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
 * const result = chunkArray(arr, 3);
 * // result = [[1, 2, 3, 4], [5, 6, 7], [8, 9, 10]]
 * ```
 */ function chunkArray(arr, maxNum) {
    var result = [];
    var chunkCount = 0;
    var start = 0;
    var chunkSize = Math.floor(arr.length / maxNum);
    var remainder = arr.length % maxNum;
    while(start < arr.length && chunkCount < maxNum){
        var shouldIncreaseChunkSize = chunkCount >= maxNum - remainder;
        var end = start + chunkSize + (shouldIncreaseChunkSize ? 1 : 0);
        result.push(arr.slice(start, end));
        start = end;
        chunkCount += 1;
    }
    return result;
}
/**
 * Wait for a condition to be truthy
 *
 * @param f function that checks the condition.
 * @param maxWaitMs max milliseconds to wait for the condition to be truthy. Default is 10 seconds.
 * @param waitIntervalMs interval between each evaluation of the condition in milliseconds. Default is 100ms.
 * @returns last evaluation of the condition.
 */ var waitForCondition = function() {
    var _ref = _asyncToGenerator(function(f) {
        var maxWaitMs, waitIntervalMs, condition, msLeft;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    maxWaitMs = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 10000, waitIntervalMs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 100;
                    return [
                        4,
                        f()
                    ];
                case 1:
                    condition = _state.sent();
                    msLeft = maxWaitMs;
                    _state.label = 2;
                case 2:
                    if (!(!condition && msLeft > 0)) return [
                        3,
                        5
                    ];
                    // eslint-disable-next-line no-await-in-loop
                    return [
                        4,
                        new Promise(function(r) {
                            setTimeout(r, waitIntervalMs);
                        })
                    ];
                case 3:
                    _state.sent();
                    msLeft -= waitIntervalMs;
                    return [
                        4,
                        f()
                    ];
                case 4:
                    // eslint-disable-next-line no-await-in-loop
                    condition = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        2,
                        condition
                    ];
            }
        });
    });
    return function waitForCondition(f) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 27154:
/***/ ((module) => {

module.exports = "query globalFilterSearch($definitionId: String!, $query: ProductCollectionQueryInput!) {\n  globalFilterSearch(definitionId: $definitionId, query: $query) {\n    ... on ListSection {\n      id\n      hasMore\n      items {\n        id\n        value\n        count\n        path\n        indexable\n      }\n      popular {\n        id\n        value\n        count\n        path\n        indexable\n      }\n    }\n    ... on UnsupportedSection {\n      id\n      type\n    }\n  }\n}"

/***/ }),

/***/ 85534:
/***/ ((module) => {

module.exports = "query productCollectionAggregation($id: String, $aggregationId: String, $query: ProductCollectionQueryInput) {\n  productCollectionAggregation(\n    id: $id\n    aggregationId: $aggregationId\n    query: $query\n  ) {\n    ... on ListSection {\n      id\n      hasMore\n      items {\n        id\n        value\n        count\n        path\n        indexable\n      }\n      popular {\n        id\n        value\n        count\n        path\n        indexable\n      }\n    }\n    ... on UnsupportedSection {\n      id\n      type\n    }\n  }\n}"

/***/ })

}]);